[
  {
    "codigo": "010105",
    "descricao": "Oficial general da aeron�utica"
  },
  {
    "codigo": "010110",
    "descricao": "Oficial general do ex�rcito"
  },
  {
    "codigo": "010115",
    "descricao": "Oficial general da marinha"
  },
  {
    "codigo": "010205",
    "descricao": "Oficial da aeron�utica"
  },
  {
    "codigo": "010210",
    "descricao": "Oficial do ex�rcito"
  },
  {
    "codigo": "010215",
    "descricao": "Oficial da marinha"
  },
  {
    "codigo": "010305",
    "descricao": "Pra�a da aeron�utica"
  },
  {
    "codigo": "010310",
    "descricao": "Pra�a do ex�rcito"
  },
  {
    "codigo": "010315",
    "descricao": "Pra�a da marinha"
  },
  {
    "codigo": "020105",
    "descricao": "Coronel da pol�cia militar"
  },
  {
    "codigo": "020110",
    "descricao": "Tenente-coronel da pol�cia militar"
  },
  {
    "codigo": "020115",
    "descricao": "Major da pol�cia militar"
  },
  {
    "codigo": "020205",
    "descricao": "Capit�o da pol�cia militar"
  },
  {
    "codigo": "020305",
    "descricao": "Primeiro tenente de pol�cia militar"
  },
  {
    "codigo": "020310",
    "descricao": "Segundo tenente de pol�cia militar"
  },
  {
    "codigo": "021105",
    "descricao": "Subtenente da policia militar"
  },
  {
    "codigo": "021110",
    "descricao": "Sargento da policia militar"
  },
  {
    "codigo": "021205",
    "descricao": "Cabo da pol�cia militar"
  },
  {
    "codigo": "021210",
    "descricao": "Soldado da pol�cia militar"
  },
  {
    "codigo": "030105",
    "descricao": "Coronel bombeiro militar"
  },
  {
    "codigo": "030110",
    "descricao": "Major bombeiro militar"
  },
  {
    "codigo": "030115",
    "descricao": "Tenente-coronel bombeiro militar"
  },
  {
    "codigo": "030205",
    "descricao": "Capit�o bombeiro militar"
  },
  {
    "codigo": "030305",
    "descricao": "Tenente do corpo de bombeiros militar"
  },
  {
    "codigo": "031105",
    "descricao": "Subtenente bombeiro militar"
  },
  {
    "codigo": "031110",
    "descricao": "Sargento bombeiro militar"
  },
  {
    "codigo": "031205",
    "descricao": "Cabo bombeiro militar"
  },
  {
    "codigo": "031210",
    "descricao": "Soldado bombeiro militar"
  },
  {
    "codigo": "111105",
    "descricao": "Senador"
  },
  {
    "codigo": "111110",
    "descricao": "Deputado federal"
  },
  {
    "codigo": "111115",
    "descricao": "Deputado estadual e distrital"
  },
  {
    "codigo": "111120",
    "descricao": "Vereador"
  },
  {
    "codigo": "111205",
    "descricao": "Presidente da rep�blica"
  },
  {
    "codigo": "111210",
    "descricao": "Vice-presidente da rep�blica"
  },
  {
    "codigo": "111215",
    "descricao": "Ministro de estado"
  },
  {
    "codigo": "111220",
    "descricao": "Secret�rio - executivo"
  },
  {
    "codigo": "111225",
    "descricao": "Membro superior do poder executivo"
  },
  {
    "codigo": "111230",
    "descricao": "Governador de estado"
  },
  {
    "codigo": "111235",
    "descricao": "Governador do distrito federal"
  },
  {
    "codigo": "111240",
    "descricao": "Vice-governador de estado"
  },
  {
    "codigo": "111245",
    "descricao": "Vice-governador do distrito federal"
  },
  {
    "codigo": "111250",
    "descricao": "Prefeito"
  },
  {
    "codigo": "111255",
    "descricao": "Vice-prefeito"
  },
  {
    "codigo": "111305",
    "descricao": "Ministro do supremo tribunal federal"
  },
  {
    "codigo": "111310",
    "descricao": "Ministro do superior tribunal de justi�a"
  },
  {
    "codigo": "111315",
    "descricao": "Ministro do  superior tribunal militar"
  },
  {
    "codigo": "111320",
    "descricao": "Ministro do  superior tribunal do trabalho"
  },
  {
    "codigo": "111325",
    "descricao": "Juiz de direito"
  },
  {
    "codigo": "111330",
    "descricao": "Juiz federal"
  },
  {
    "codigo": "111335",
    "descricao": "Juiz auditor federal - justi�a militar"
  },
  {
    "codigo": "111340",
    "descricao": "Juiz auditor estadual - justi�a militar"
  },
  {
    "codigo": "111345",
    "descricao": "Juiz do trabalho"
  },
  {
    "codigo": "111405",
    "descricao": "Dirigente do servi�o p�blico federal"
  },
  {
    "codigo": "111410",
    "descricao": "Dirigente do servi�o p�blico estadual e distrital"
  },
  {
    "codigo": "111415",
    "descricao": "Dirigente do servi�o p�blico municipal"
  },
  {
    "codigo": "111505",
    "descricao": "Especialista de pol�ticas p�blicas e gest�o governamental - eppgg"
  },
  {
    "codigo": "111510",
    "descricao": "Analista de planejamento e or�amento - apo"
  },
  {
    "codigo": "113005",
    "descricao": "Cacique"
  },
  {
    "codigo": "113010",
    "descricao": "L�der de comunidade cai�ara"
  },
  {
    "codigo": "113015",
    "descricao": "Membro de lideran�a quilombola"
  },
  {
    "codigo": "114105",
    "descricao": "Dirigente de partido pol�tico"
  },
  {
    "codigo": "114205",
    "descricao": "Dirigente de entidade de trabalhadores"
  },
  {
    "codigo": "114210",
    "descricao": "Dirigente de entidade patronal"
  },
  {
    "codigo": "114305",
    "descricao": "Dirigente e administrador de organiza��o religiosa"
  },
  {
    "codigo": "114405",
    "descricao": "Dirigente e administrador de organiza��o da sociedade civil sem fins lucrativos"
  },
  {
    "codigo": "121005",
    "descricao": "Diretor de planejamento estrat�gico"
  },
  {
    "codigo": "121010",
    "descricao": "Diretor geral de empresa e organiza��es (exceto de interesse p�blico)"
  },
  {
    "codigo": "122105",
    "descricao": "Diretor de produ��o e opera��es em empresa agropecu�ria"
  },
  {
    "codigo": "122110",
    "descricao": "Diretor de produ��o e opera��es em empresa aq��cola"
  },
  {
    "codigo": "122115",
    "descricao": "Diretor de produ��o e opera��es em empresa florestal"
  },
  {
    "codigo": "122120",
    "descricao": "Diretor de produ��o e opera��es em empresa pesqueira"
  },
  {
    "codigo": "122205",
    "descricao": "Diretor de produ��o e opera��es da ind�stria de transforma��o, extra��o mineral e utilidades"
  },
  {
    "codigo": "122305",
    "descricao": "Diretor de opera��es de obras p�blica e civil"
  },
  {
    "codigo": "122405",
    "descricao": "Diretor de opera��es comerciais (com�rcio atacadista e varejista)"
  },
  {
    "codigo": "122505",
    "descricao": "Diretor de  produ��o e opera��es de alimenta��o"
  },
  {
    "codigo": "122510",
    "descricao": "Diretor de  produ��o e opera��es de hotel"
  },
  {
    "codigo": "122515",
    "descricao": "Diretor de  produ��o e opera��es de turismo"
  },
  {
    "codigo": "122520",
    "descricao": "Turism�logo"
  },
  {
    "codigo": "122605",
    "descricao": "Diretor de opera��es de correios"
  },
  {
    "codigo": "122610",
    "descricao": "Diretor de opera��es de servi�os de armazenamento"
  },
  {
    "codigo": "122615",
    "descricao": "Diretor de opera��es de servi�os de telecomunica��es"
  },
  {
    "codigo": "122620",
    "descricao": "Diretor de opera��es de servi�os de transporte"
  },
  {
    "codigo": "122705",
    "descricao": "Diretor comercial em opera��es de intermedia��o financeira"
  },
  {
    "codigo": "122710",
    "descricao": "Diretor de produtos banc�rios"
  },
  {
    "codigo": "122715",
    "descricao": "Diretor de cr�dito rural"
  },
  {
    "codigo": "122720",
    "descricao": "Diretor de c�mbio e com�rcio exterior"
  },
  {
    "codigo": "122725",
    "descricao": "Diretor de compliance"
  },
  {
    "codigo": "122730",
    "descricao": "Diretor de cr�dito (exceto cr�dito imobili�rio)"
  },
  {
    "codigo": "122735",
    "descricao": "Diretor de cr�dito imobili�rio"
  },
  {
    "codigo": "122740",
    "descricao": "Diretor de leasing"
  },
  {
    "codigo": "122745",
    "descricao": "Diretor de mercado de capitais"
  },
  {
    "codigo": "122750",
    "descricao": "Diretor de recupera��o de cr�ditos em opera��es de intermedia��o financeira"
  },
  {
    "codigo": "122755",
    "descricao": "Diretor de riscos de mercado"
  },
  {
    "codigo": "123105",
    "descricao": "Diretor administrativo"
  },
  {
    "codigo": "123110",
    "descricao": "Diretor administrativo e financeiro"
  },
  {
    "codigo": "123115",
    "descricao": "Diretor financeiro"
  },
  {
    "codigo": "123205",
    "descricao": "Diretor de recursos humanos"
  },
  {
    "codigo": "123210",
    "descricao": "Diretor de rela��es de trabalho"
  },
  {
    "codigo": "123305",
    "descricao": "Diretor comercial"
  },
  {
    "codigo": "123310",
    "descricao": "Diretor de marketing"
  },
  {
    "codigo": "123405",
    "descricao": "Diretor de suprimentos"
  },
  {
    "codigo": "123410",
    "descricao": "Diretor de suprimentos no servi�o p�blico"
  },
  {
    "codigo": "123605",
    "descricao": "Diretor de tecnologia da informa��o"
  },
  {
    "codigo": "123705",
    "descricao": "Diretor de pesquisa e desenvolvimento (p&d)"
  },
  {
    "codigo": "123805",
    "descricao": "Diretor de manuten��o"
  },
  {
    "codigo": "131105",
    "descricao": "Diretor de servi�os culturais"
  },
  {
    "codigo": "131110",
    "descricao": "Diretor de servi�os sociais"
  },
  {
    "codigo": "131115",
    "descricao": "Gerente de servi�os culturais"
  },
  {
    "codigo": "131120",
    "descricao": "Gerente de servi�os sociais"
  },
  {
    "codigo": "131205",
    "descricao": "Diretor de servi�os de sa�de"
  },
  {
    "codigo": "131210",
    "descricao": "Gerente de servi�os de sa�de"
  },
  {
    "codigo": "131215",
    "descricao": "Tecn�logo em gest�o hospitalar"
  },
  {
    "codigo": "131220",
    "descricao": "Geront�logo"
  },
  {
    "codigo": "131225",
    "descricao": "Sanitarista"
  },
  {
    "codigo": "131305",
    "descricao": "Diretor de institui��o educacional da �rea privada"
  },
  {
    "codigo": "131310",
    "descricao": "Diretor de institui��o educacional p�blica"
  },
  {
    "codigo": "131315",
    "descricao": "Gerente de institui��o educacional da �rea privada"
  },
  {
    "codigo": "131320",
    "descricao": "Gerente de servi�os educacionais da �rea p�blica"
  },
  {
    "codigo": "141105",
    "descricao": "Gerente de produ��o e opera��es  aq��colas"
  },
  {
    "codigo": "141110",
    "descricao": "Gerente de produ��o e opera��es  florestais"
  },
  {
    "codigo": "141115",
    "descricao": "Gerente de produ��o e opera��es agropecu�rias"
  },
  {
    "codigo": "141120",
    "descricao": "Gerente de produ��o e opera��es pesqueiras"
  },
  {
    "codigo": "141205",
    "descricao": "Gerente de produ��o e opera��es"
  },
  {
    "codigo": "141305",
    "descricao": "Gerente de produ��o e opera��es da constru��o civil e obras p�blicas"
  },
  {
    "codigo": "141405",
    "descricao": "Comerciante atacadista"
  },
  {
    "codigo": "141410",
    "descricao": "Comerciante varejista"
  },
  {
    "codigo": "141415",
    "descricao": "Gerente de loja e supermercado"
  },
  {
    "codigo": "141420",
    "descricao": "Gerente de opera��es de servi�os de assist�ncia t�cnica"
  },
  {
    "codigo": "141505",
    "descricao": "Gerente de hotel"
  },
  {
    "codigo": "141510",
    "descricao": "Gerente de restaurante"
  },
  {
    "codigo": "141515",
    "descricao": "Gerente de bar"
  },
  {
    "codigo": "141520",
    "descricao": "Gerente de pens�o"
  },
  {
    "codigo": "141525",
    "descricao": "Gerente de turismo"
  },
  {
    "codigo": "141605",
    "descricao": "Gerente de opera��es de transportes"
  },
  {
    "codigo": "141610",
    "descricao": "Gerente de opera��es de correios e telecomunica��es"
  },
  {
    "codigo": "141615",
    "descricao": "Gerente de log�stica (armazenagem e distribui��o)"
  },
  {
    "codigo": "141705",
    "descricao": "Gerente de produtos banc�rios"
  },
  {
    "codigo": "141710",
    "descricao": "Gerente de ag�ncia"
  },
  {
    "codigo": "141715",
    "descricao": "Gerente de c�mbio e com�rcio exterior"
  },
  {
    "codigo": "141720",
    "descricao": "Gerente de cr�dito e cobran�a"
  },
  {
    "codigo": "141725",
    "descricao": "Gerente de cr�dito imobili�rio"
  },
  {
    "codigo": "141730",
    "descricao": "Gerente de cr�dito rural"
  },
  {
    "codigo": "141735",
    "descricao": "Gerente de recupera��o de cr�dito"
  },
  {
    "codigo": "141805",
    "descricao": "Gerente de administra��o em aeroportos"
  },
  {
    "codigo": "141810",
    "descricao": "Gerente de empresa a�rea e empresa de servi�os auxiliares ao transporte a�reo (esata) em aeroportos"
  },
  {
    "codigo": "141815",
    "descricao": "Gerente de opera��es em aeroportos"
  },
  {
    "codigo": "141820",
    "descricao": "Gerente de opera��es de cargas"
  },
  {
    "codigo": "141825",
    "descricao": "Gerente de seguran�a da avia��o civil"
  },
  {
    "codigo": "141830",
    "descricao": "Gerente de seguran�a operacional (avia��o civil)"
  },
  {
    "codigo": "142105",
    "descricao": "Gerente administrativo"
  },
  {
    "codigo": "142110",
    "descricao": "Gerente de riscos"
  },
  {
    "codigo": "142115",
    "descricao": "Gerente financeiro"
  },
  {
    "codigo": "142120",
    "descricao": "Tecn�logo em gest�o administrativo- financeira"
  },
  {
    "codigo": "142125",
    "descricao": "Analista de compliance"
  },
  {
    "codigo": "142130",
    "descricao": "Analista de riscos"
  },
  {
    "codigo": "142135",
    "descricao": "Oficial de prote��o de dados pessoais (dpo)"
  },
  {
    "codigo": "142140",
    "descricao": "Gerente de facility management"
  },
  {
    "codigo": "142205",
    "descricao": "Gerente de recursos humanos"
  },
  {
    "codigo": "142210",
    "descricao": "Gerente de departamento pessoal"
  },
  {
    "codigo": "142305",
    "descricao": "Gerente comercial"
  },
  {
    "codigo": "142310",
    "descricao": "Gerente de comunica��o"
  },
  {
    "codigo": "142315",
    "descricao": "Gerente de marketing"
  },
  {
    "codigo": "142320",
    "descricao": "Gerente de vendas"
  },
  {
    "codigo": "142325",
    "descricao": "Rela��es p�blicas"
  },
  {
    "codigo": "142330",
    "descricao": "Analista de neg�cios"
  },
  {
    "codigo": "142335",
    "descricao": "Analista de pesquisa de mercado"
  },
  {
    "codigo": "142340",
    "descricao": "Ouvidor"
  },
  {
    "codigo": "142345",
    "descricao": "Profissional de rela��es institucionais e governamentais"
  },
  {
    "codigo": "142350",
    "descricao": "Profissonal de rela��es internacionais"
  },
  {
    "codigo": "142355",
    "descricao": "Analista de e-commerce"
  },
  {
    "codigo": "142405",
    "descricao": "Gerente de compras"
  },
  {
    "codigo": "142410",
    "descricao": "Gerente de suprimentos"
  },
  {
    "codigo": "142415",
    "descricao": "Gerente de almoxarifado"
  },
  {
    "codigo": "142505",
    "descricao": "Gerente de infraestrutura de tecnologia da informa��o"
  },
  {
    "codigo": "142510",
    "descricao": "Gerente de desenvolvimento de sistemas"
  },
  {
    "codigo": "142515",
    "descricao": "Gerente de opera��o de tecnologia da informa��o"
  },
  {
    "codigo": "142520",
    "descricao": "Gerente de projetos de tecnologia da informa��o"
  },
  {
    "codigo": "142525",
    "descricao": "Gerente de seguran�a da informa��o"
  },
  {
    "codigo": "142530",
    "descricao": "Gerente de suporte t�cnico de tecnologia da informa��o"
  },
  {
    "codigo": "142535",
    "descricao": "Tecn�logo em gest�o da tecnologia da informa��o"
  },
  {
    "codigo": "142605",
    "descricao": "Gerente de pesquisa e desenvolvimento (p&d)"
  },
  {
    "codigo": "142610",
    "descricao": "Especialista em desenvolvimento de cigarros"
  },
  {
    "codigo": "142705",
    "descricao": "Gerente de projetos e servi�os de manuten��o"
  },
  {
    "codigo": "142710",
    "descricao": "Tecn�logo em sistemas biom�dicos"
  },
  {
    "codigo": "201105",
    "descricao": "Bioengenheiro"
  },
  {
    "codigo": "201110",
    "descricao": "Biotecnologista"
  },
  {
    "codigo": "201115",
    "descricao": "Geneticista"
  },
  {
    "codigo": "201205",
    "descricao": "Pesquisador em metrologia"
  },
  {
    "codigo": "201210",
    "descricao": "Especialista em calibra��es metrol�gicas"
  },
  {
    "codigo": "201215",
    "descricao": "Especialista em ensaios metrol�gicos"
  },
  {
    "codigo": "201220",
    "descricao": "Especialista em instrumenta��o metrol�gica"
  },
  {
    "codigo": "201225",
    "descricao": "Especialista em materiais de refer�ncia metrol�gica"
  },
  {
    "codigo": "202105",
    "descricao": "Engenheiro mecatr�nico"
  },
  {
    "codigo": "202110",
    "descricao": "Engenheiro de controle e automa��o"
  },
  {
    "codigo": "202115",
    "descricao": "Tecn�logo em mecatr�nica"
  },
  {
    "codigo": "202120",
    "descricao": "Tecn�logo em automa��o industrial"
  },
  {
    "codigo": "203005",
    "descricao": "Pesquisador em biologia ambiental"
  },
  {
    "codigo": "203010",
    "descricao": "Pesquisador em biologia animal"
  },
  {
    "codigo": "203015",
    "descricao": "Pesquisador em biologia de microorganismos e parasitas"
  },
  {
    "codigo": "203020",
    "descricao": "Pesquisador em biologia humana"
  },
  {
    "codigo": "203025",
    "descricao": "Pesquisador em biologia vegetal"
  },
  {
    "codigo": "203105",
    "descricao": "Pesquisador em ci�ncias da computa��o e inform�tica"
  },
  {
    "codigo": "203110",
    "descricao": "Pesquisador em ci�ncias da terra e meio ambiente"
  },
  {
    "codigo": "203115",
    "descricao": "Pesquisador em f�sica"
  },
  {
    "codigo": "203120",
    "descricao": "Pesquisador em matem�tica"
  },
  {
    "codigo": "203125",
    "descricao": "Pesquisador em qu�mica"
  },
  {
    "codigo": "203205",
    "descricao": "Pesquisador de engenharia civil"
  },
  {
    "codigo": "203210",
    "descricao": "Pesquisador de engenharia e tecnologia (outras �reas da engenharia)"
  },
  {
    "codigo": "203215",
    "descricao": "Pesquisador de engenharia el�trica e eletr�nica"
  },
  {
    "codigo": "203220",
    "descricao": "Pesquisador de engenharia mec�nica"
  },
  {
    "codigo": "203225",
    "descricao": "Pesquisador de engenharia metal�rgica, de minas e de materiais"
  },
  {
    "codigo": "203230",
    "descricao": "Pesquisador de engenharia qu�mica"
  },
  {
    "codigo": "203305",
    "descricao": "Pesquisador de cl�nica m�dica"
  },
  {
    "codigo": "203310",
    "descricao": "Pesquisador de medicina b�sica"
  },
  {
    "codigo": "203315",
    "descricao": "Pesquisador em medicina veterin�ria"
  },
  {
    "codigo": "203320",
    "descricao": "Pesquisador em sa�de coletiva"
  },
  {
    "codigo": "203405",
    "descricao": "Pesquisador em ci�ncias agron�micas"
  },
  {
    "codigo": "203410",
    "descricao": "Pesquisador em ci�ncias da pesca e aq�icultura"
  },
  {
    "codigo": "203415",
    "descricao": "Pesquisador em ci�ncias da zootecnia"
  },
  {
    "codigo": "203420",
    "descricao": "Pesquisador em ci�ncias florestais"
  },
  {
    "codigo": "203505",
    "descricao": "Pesquisador em ci�ncias sociais e humanas"
  },
  {
    "codigo": "203510",
    "descricao": "Pesquisador em economia"
  },
  {
    "codigo": "203515",
    "descricao": "Pesquisador em ci�ncias da educa��o"
  },
  {
    "codigo": "203520",
    "descricao": "Pesquisador em hist�ria"
  },
  {
    "codigo": "203525",
    "descricao": "Pesquisador em psicologia"
  },
  {
    "codigo": "204105",
    "descricao": "Perito criminal"
  },
  {
    "codigo": "204110",
    "descricao": "Perito judicial"
  },
  {
    "codigo": "211105",
    "descricao": "Atu�rio"
  },
  {
    "codigo": "211110",
    "descricao": "Especialista em pesquisa operacional"
  },
  {
    "codigo": "211115",
    "descricao": "Matem�tico"
  },
  {
    "codigo": "211120",
    "descricao": "Matem�tico aplicado"
  },
  {
    "codigo": "211205",
    "descricao": "Estat�stico"
  },
  {
    "codigo": "211210",
    "descricao": "Estat�stico (estat�stica aplicada)"
  },
  {
    "codigo": "211215",
    "descricao": "Estat�stico te�rico"
  },
  {
    "codigo": "211220",
    "descricao": "Cientista de dados"
  },
  {
    "codigo": "212205",
    "descricao": "Engenheiro de aplicativos em computa��o"
  },
  {
    "codigo": "212210",
    "descricao": "Engenheiro de equipamentos em computa��o"
  },
  {
    "codigo": "212215",
    "descricao": "Engenheiros de sistemas operacionais em computa��o"
  },
  {
    "codigo": "212305",
    "descricao": "Administrador de banco de dados"
  },
  {
    "codigo": "212310",
    "descricao": "Administrador de redes"
  },
  {
    "codigo": "212315",
    "descricao": "Administrador de sistemas operacionais"
  },
  {
    "codigo": "212320",
    "descricao": "Administrador em seguran�a da informa��o"
  },
  {
    "codigo": "212405",
    "descricao": "Analista de desenvolvimento de sistemas"
  },
  {
    "codigo": "212410",
    "descricao": "Analista de redes e de comunica��o de dados"
  },
  {
    "codigo": "212415",
    "descricao": "Analista de sistemas de automa��o"
  },
  {
    "codigo": "212420",
    "descricao": "Analista de suporte computacional"
  },
  {
    "codigo": "212425",
    "descricao": "Arquiteto de solu��es de tecnologia da informa��o"
  },
  {
    "codigo": "212430",
    "descricao": "Analista de testes de tecnologia da informa��o"
  },
  {
    "codigo": "213105",
    "descricao": "F�sico"
  },
  {
    "codigo": "213110",
    "descricao": "F�sico (ac�stica)"
  },
  {
    "codigo": "213115",
    "descricao": "F�sico (at�mica e molecular)"
  },
  {
    "codigo": "213120",
    "descricao": "F�sico (cosmologia)"
  },
  {
    "codigo": "213125",
    "descricao": "F�sico (estat�stica e matem�tica)"
  },
  {
    "codigo": "213130",
    "descricao": "F�sico (fluidos)"
  },
  {
    "codigo": "213135",
    "descricao": "F�sico (instrumenta��o)"
  },
  {
    "codigo": "213140",
    "descricao": "F�sico (mat�ria condensada)"
  },
  {
    "codigo": "213145",
    "descricao": "F�sico (materiais)"
  },
  {
    "codigo": "213150",
    "descricao": "F�sico (medicina)"
  },
  {
    "codigo": "213155",
    "descricao": "F�sico (nuclear e reatores)"
  },
  {
    "codigo": "213160",
    "descricao": "F�sico (�ptica)"
  },
  {
    "codigo": "213165",
    "descricao": "F�sico (part�culas e campos)"
  },
  {
    "codigo": "213170",
    "descricao": "F�sico (plasma)"
  },
  {
    "codigo": "213175",
    "descricao": "F�sico (t�rmica)"
  },
  {
    "codigo": "213205",
    "descricao": "Qu�mico"
  },
  {
    "codigo": "213210",
    "descricao": "Qu�mico industrial"
  },
  {
    "codigo": "213215",
    "descricao": "Tecn�logo em processos qu�micos"
  },
  {
    "codigo": "213305",
    "descricao": "Astr�nomo"
  },
  {
    "codigo": "213310",
    "descricao": "Geof�sico espacial"
  },
  {
    "codigo": "213315",
    "descricao": "Meteorologista"
  },
  {
    "codigo": "213405",
    "descricao": "Ge�logo"
  },
  {
    "codigo": "213410",
    "descricao": "Ge�logo de engenharia"
  },
  {
    "codigo": "213415",
    "descricao": "Geof�sico"
  },
  {
    "codigo": "213420",
    "descricao": "Geoqu�mico"
  },
  {
    "codigo": "213425",
    "descricao": "Hidroge�logo"
  },
  {
    "codigo": "213430",
    "descricao": "Paleont�logo"
  },
  {
    "codigo": "213435",
    "descricao": "Petr�grafo"
  },
  {
    "codigo": "213440",
    "descricao": "Ocean�grafo"
  },
  {
    "codigo": "214005",
    "descricao": "Engenheiro ambiental"
  },
  {
    "codigo": "214010",
    "descricao": "Tecn�logo em meio ambiente"
  },
  {
    "codigo": "214105",
    "descricao": "Arquiteto de edifica��es"
  },
  {
    "codigo": "214110",
    "descricao": "Arquiteto de interiores"
  },
  {
    "codigo": "214115",
    "descricao": "Arquiteto de patrim�nio"
  },
  {
    "codigo": "214120",
    "descricao": "Arquiteto paisagista"
  },
  {
    "codigo": "214125",
    "descricao": "Arquiteto urbanista"
  },
  {
    "codigo": "214130",
    "descricao": "Urbanista"
  },
  {
    "codigo": "214205",
    "descricao": "Engenheiro civil"
  },
  {
    "codigo": "214210",
    "descricao": "Engenheiro civil (aeroportos)"
  },
  {
    "codigo": "214215",
    "descricao": "Engenheiro civil (edifica��es)"
  },
  {
    "codigo": "214220",
    "descricao": "Engenheiro civil (estruturas met�licas)"
  },
  {
    "codigo": "214225",
    "descricao": "Engenheiro civil (ferrovias e metrovias)"
  },
  {
    "codigo": "214230",
    "descricao": "Engenheiro civil (geot�cnia)"
  },
  {
    "codigo": "214235",
    "descricao": "Engenheiro civil (hidrologia)"
  },
  {
    "codigo": "214240",
    "descricao": "Engenheiro civil (hidr�ulica)"
  },
  {
    "codigo": "214245",
    "descricao": "Engenheiro civil (pontes e viadutos)"
  },
  {
    "codigo": "214250",
    "descricao": "Engenheiro civil (portos e vias naveg�veis)"
  },
  {
    "codigo": "214255",
    "descricao": "Engenheiro civil (rodovias)"
  },
  {
    "codigo": "214260",
    "descricao": "Engenheiro civil (saneamento)"
  },
  {
    "codigo": "214265",
    "descricao": "Engenheiro civil (t�neis)"
  },
  {
    "codigo": "214270",
    "descricao": "Engenheiro civil (transportes e tr�nsito)"
  },
  {
    "codigo": "214280",
    "descricao": "Tecn�logo em constru��o civil"
  },
  {
    "codigo": "214305",
    "descricao": "Engenheiro eletricista"
  },
  {
    "codigo": "214310",
    "descricao": "Engenheiro eletr�nico"
  },
  {
    "codigo": "214315",
    "descricao": "Engenheiro eletricista de manuten��o"
  },
  {
    "codigo": "214320",
    "descricao": "Engenheiro eletricista de projetos"
  },
  {
    "codigo": "214325",
    "descricao": "Engenheiro eletr�nico de manuten��o"
  },
  {
    "codigo": "214330",
    "descricao": "Engenheiro eletr�nico de projetos"
  },
  {
    "codigo": "214335",
    "descricao": "Engenheiro de manuten��o de telecomunica��es"
  },
  {
    "codigo": "214340",
    "descricao": "Engenheiro de telecomunica��es"
  },
  {
    "codigo": "214345",
    "descricao": "Engenheiro projetista de telecomunica��es"
  },
  {
    "codigo": "214350",
    "descricao": "Engenheiro de redes de comunica��o"
  },
  {
    "codigo": "214360",
    "descricao": "Tecn�logo em eletricidade"
  },
  {
    "codigo": "214365",
    "descricao": "Tecn�logo em eletr�nica"
  },
  {
    "codigo": "214370",
    "descricao": "Tecn�logo em telecomunica��es"
  },
  {
    "codigo": "214375",
    "descricao": "Engenheiro de energia"
  },
  {
    "codigo": "214380",
    "descricao": "Engenheiro biom�dico"
  },
  {
    "codigo": "214405",
    "descricao": "Engenheiro mec�nico"
  },
  {
    "codigo": "214410",
    "descricao": "Engenheiro mec�nico automotivo"
  },
  {
    "codigo": "214415",
    "descricao": "Engenheiro mec�nico (energia nuclear)"
  },
  {
    "codigo": "214420",
    "descricao": "Engenheiro mec�nico industrial"
  },
  {
    "codigo": "214425",
    "descricao": "Engenheiro aeron�utico"
  },
  {
    "codigo": "214430",
    "descricao": "Engenheiro naval"
  },
  {
    "codigo": "214435",
    "descricao": "Tecn�logo em fabrica��o mec�nica"
  },
  {
    "codigo": "214505",
    "descricao": "Engenheiro qu�mico"
  },
  {
    "codigo": "214510",
    "descricao": "Engenheiro qu�mico (ind�stria qu�mica)"
  },
  {
    "codigo": "214515",
    "descricao": "Engenheiro qu�mico (minera��o, metalurgia, siderurgia, cimenteira e cer�mica)"
  },
  {
    "codigo": "214520",
    "descricao": "Engenheiro qu�mico (papel e celulose)"
  },
  {
    "codigo": "214525",
    "descricao": "Engenheiro qu�mico (petr�leo e borracha)"
  },
  {
    "codigo": "214530",
    "descricao": "Engenheiro qu�mico (utilidades e meio ambiente)"
  },
  {
    "codigo": "214535",
    "descricao": "Tecn�logo em produ��o sulcroalcooleira"
  },
  {
    "codigo": "214540",
    "descricao": "Engenheiro t�xtil"
  },
  {
    "codigo": "214605",
    "descricao": "Engenheiro de materiais"
  },
  {
    "codigo": "214610",
    "descricao": "Engenheiro metalurgista"
  },
  {
    "codigo": "214615",
    "descricao": "Tecn�logo em metalurgia"
  },
  {
    "codigo": "214705",
    "descricao": "Engenheiro de minas"
  },
  {
    "codigo": "214710",
    "descricao": "Engenheiro de minas (beneficiamento)"
  },
  {
    "codigo": "214715",
    "descricao": "Engenheiro de minas (lavra a c�u aberto)"
  },
  {
    "codigo": "214720",
    "descricao": "Engenheiro de minas (lavra subterr�nea)"
  },
  {
    "codigo": "214725",
    "descricao": "Engenheiro de minas (pesquisa mineral)"
  },
  {
    "codigo": "214730",
    "descricao": "Engenheiro de minas (planejamento)"
  },
  {
    "codigo": "214735",
    "descricao": "Engenheiro de minas (processo)"
  },
  {
    "codigo": "214740",
    "descricao": "Engenheiro de minas (projeto)"
  },
  {
    "codigo": "214745",
    "descricao": "Tecn�logo em petr�leo e g�s"
  },
  {
    "codigo": "214750",
    "descricao": "Tecn�logo em rochas ornamentais"
  },
  {
    "codigo": "214805",
    "descricao": "Engenheiro agrimensor"
  },
  {
    "codigo": "214810",
    "descricao": "Engenheiro cart�grafo"
  },
  {
    "codigo": "214905",
    "descricao": "Engenheiro de produ��o"
  },
  {
    "codigo": "214910",
    "descricao": "Engenheiro de controle de qualidade"
  },
  {
    "codigo": "214915",
    "descricao": "Engenheiro de seguran�a do trabalho"
  },
  {
    "codigo": "214920",
    "descricao": "Engenheiro de riscos"
  },
  {
    "codigo": "214925",
    "descricao": "Engenheiro de tempos e movimentos"
  },
  {
    "codigo": "214930",
    "descricao": "Tecn�logo em produ��o industrial"
  },
  {
    "codigo": "214935",
    "descricao": "Tecn�logo em seguran�a do trabalho"
  },
  {
    "codigo": "214940",
    "descricao": "Higienista ocupacional"
  },
  {
    "codigo": "214945",
    "descricao": "Engenheiro de logistica"
  },
  {
    "codigo": "215105",
    "descricao": "Agente de manobra e docagem"
  },
  {
    "codigo": "215110",
    "descricao": "Capit�o de manobra da marinha mercante"
  },
  {
    "codigo": "215115",
    "descricao": "Comandante da marinha mercante"
  },
  {
    "codigo": "215120",
    "descricao": "Coordenador de opera��es de combate � polui��o no meio aquavi�rio"
  },
  {
    "codigo": "215125",
    "descricao": "Imediato da marinha mercante"
  },
  {
    "codigo": "215130",
    "descricao": "Inspetor de terminal"
  },
  {
    "codigo": "215135",
    "descricao": "Inspetor naval"
  },
  {
    "codigo": "215140",
    "descricao": "Oficial de quarto de navega��o da marinha mercante"
  },
  {
    "codigo": "215145",
    "descricao": "Pr�tico de portos da marinha mercante"
  },
  {
    "codigo": "215150",
    "descricao": "Vistoriador naval"
  },
  {
    "codigo": "215205",
    "descricao": "Oficial superior de m�quinas da marinha mercante"
  },
  {
    "codigo": "215210",
    "descricao": "Primeiro oficial de m�quinas da marinha mercante"
  },
  {
    "codigo": "215215",
    "descricao": "Segundo oficial de m�quinas da marinha mercante"
  },
  {
    "codigo": "215220",
    "descricao": "Superintendente t�cnico no transporte aquavi�rio"
  },
  {
    "codigo": "215305",
    "descricao": "Piloto de aeronaves"
  },
  {
    "codigo": "215310",
    "descricao": "Piloto de ensaios em v�o"
  },
  {
    "codigo": "215315",
    "descricao": "Instrutor de v�o"
  },
  {
    "codigo": "221105",
    "descricao": "Bi�logo"
  },
  {
    "codigo": "221205",
    "descricao": "Biom�dico"
  },
  {
    "codigo": "222105",
    "descricao": "Engenheiro agr�cola"
  },
  {
    "codigo": "222110",
    "descricao": "Engenheiro agr�nomo"
  },
  {
    "codigo": "222115",
    "descricao": "Engenheiro de pesca"
  },
  {
    "codigo": "222120",
    "descricao": "Engenheiro florestal"
  },
  {
    "codigo": "222125",
    "descricao": "Tecn�logo em agroneg�cio"
  },
  {
    "codigo": "222205",
    "descricao": "Engenheiro de alimentos"
  },
  {
    "codigo": "222215",
    "descricao": "Tecn�logo em alimentos"
  },
  {
    "codigo": "223204",
    "descricao": "Cirurgi�o dentista - auditor"
  },
  {
    "codigo": "223208",
    "descricao": "Cirurgi�o dentista - cl�nico geral"
  },
  {
    "codigo": "223212",
    "descricao": "Cirurgi�o dentista - endodontista"
  },
  {
    "codigo": "223216",
    "descricao": "Cirurgi�o dentista - epidemiologista"
  },
  {
    "codigo": "223220",
    "descricao": "Cirurgi�o dentista - estomatologista"
  },
  {
    "codigo": "223224",
    "descricao": "Cirurgi�o dentista - implantodontista"
  },
  {
    "codigo": "223228",
    "descricao": "Cirurgi�o dentista - odontogeriatra"
  },
  {
    "codigo": "223232",
    "descricao": "Cirurgi�o dentista - odontologista legal"
  },
  {
    "codigo": "223236",
    "descricao": "Cirurgi�o dentista - odontopediatra"
  },
  {
    "codigo": "223240",
    "descricao": "Cirurgi�o dentista - ortopedista e ortodontista"
  },
  {
    "codigo": "223244",
    "descricao": "Cirurgi�o dentista - patologista bucal"
  },
  {
    "codigo": "223248",
    "descricao": "Cirurgi�o dentista - periodontista"
  },
  {
    "codigo": "223252",
    "descricao": "Cirurgi�o dentista - protesi�logo bucomaxilofacial"
  },
  {
    "codigo": "223256",
    "descricao": "Cirurgi�o dentista - protesista"
  },
  {
    "codigo": "223260",
    "descricao": "Cirurgi�o dentista - radiologista"
  },
  {
    "codigo": "223264",
    "descricao": "Cirurgi�o dentista - reabilitador oral"
  },
  {
    "codigo": "223268",
    "descricao": "Cirurgi�o dentista - traumatologista bucomaxilofacial"
  },
  {
    "codigo": "223272",
    "descricao": "Cirurgi�o dentista de sa�de coletiva"
  },
  {
    "codigo": "223276",
    "descricao": "Cirurgi�o dentista - odontologia do trabalho"
  },
  {
    "codigo": "223280",
    "descricao": "Cirurgi�o dentista - dent�stica"
  },
  {
    "codigo": "223284",
    "descricao": "Cirurgi�o dentista - disfun��o temporomandibular e dor orofacial"
  },
  {
    "codigo": "223288",
    "descricao": "Cirurgi�o dentista - odontologia para pacientes com necessidades especiais"
  },
  {
    "codigo": "223293",
    "descricao": "Cirurgi�o-dentista da estrat�gia de sa�de da fam�lia"
  },
  {
    "codigo": "223305",
    "descricao": "M�dico veterin�rio"
  },
  {
    "codigo": "223310",
    "descricao": "Zootecnista"
  },
  {
    "codigo": "223405",
    "descricao": "Farmac�utico"
  },
  {
    "codigo": "223415",
    "descricao": "Farmac�utico analista cl�nico"
  },
  {
    "codigo": "223420",
    "descricao": "Farmac�utico de alimentos"
  },
  {
    "codigo": "223425",
    "descricao": "Farmac�utico pr�ticas integrativas e complementares"
  },
  {
    "codigo": "223430",
    "descricao": "Farmac�utico em sa�de p�blica"
  },
  {
    "codigo": "223435",
    "descricao": "Farmac�utico industrial"
  },
  {
    "codigo": "223440",
    "descricao": "Farmac�utico toxicologista"
  },
  {
    "codigo": "223445",
    "descricao": "Farmac�utico hospitalar e cl�nico"
  },
  {
    "codigo": "223505",
    "descricao": "Enfermeiro"
  },
  {
    "codigo": "223510",
    "descricao": "Enfermeiro auditor"
  },
  {
    "codigo": "223515",
    "descricao": "Enfermeiro de bordo"
  },
  {
    "codigo": "223520",
    "descricao": "Enfermeiro de centro cir�rgico"
  },
  {
    "codigo": "223525",
    "descricao": "Enfermeiro de terapia intensiva"
  },
  {
    "codigo": "223530",
    "descricao": "Enfermeiro do trabalho"
  },
  {
    "codigo": "223535",
    "descricao": "Enfermeiro nefrologista"
  },
  {
    "codigo": "223540",
    "descricao": "Enfermeiro neonatologista"
  },
  {
    "codigo": "223545",
    "descricao": "Enfermeiro obst�trico"
  },
  {
    "codigo": "223550",
    "descricao": "Enfermeiro psiqui�trico"
  },
  {
    "codigo": "223555",
    "descricao": "Enfermeiro puericultor e pedi�trico"
  },
  {
    "codigo": "223560",
    "descricao": "Enfermeiro sanitarista"
  },
  {
    "codigo": "223565",
    "descricao": "Enfermeiro da estrat�gia de sa�de da fam�lia"
  },
  {
    "codigo": "223570",
    "descricao": "Perfusionista"
  },
  {
    "codigo": "223575",
    "descricao": "Obstetriz"
  },
  {
    "codigo": "223580",
    "descricao": "Enfermeiro estomaterapeuta"
  },
  {
    "codigo": "223585",
    "descricao": "Enfermeiro forense"
  },
  {
    "codigo": "223605",
    "descricao": "Fisioterapeuta geral"
  },
  {
    "codigo": "223625",
    "descricao": "Fisioterapeuta respirat�ria"
  },
  {
    "codigo": "223630",
    "descricao": "Fisioterapeuta neurofuncional"
  },
  {
    "codigo": "223635",
    "descricao": "Fisioterapeuta traumato-ortop�dica funcional"
  },
  {
    "codigo": "223640",
    "descricao": "Fisioterapeuta osteopata"
  },
  {
    "codigo": "223645",
    "descricao": "Fisioterapeuta quiropraxista"
  },
  {
    "codigo": "223650",
    "descricao": "Fisioterapeuta acupunturista"
  },
  {
    "codigo": "223655",
    "descricao": "Fisioterapeuta esportivo"
  },
  {
    "codigo": "223660",
    "descricao": "Fisioterapeuta  do trabalho"
  },
  {
    "codigo": "223705",
    "descricao": "Dietista"
  },
  {
    "codigo": "223710",
    "descricao": "Nutricionista"
  },
  {
    "codigo": "223810",
    "descricao": "Fonoaudi�logo geral"
  },
  {
    "codigo": "223815",
    "descricao": "Fonoaudi�logo educacional"
  },
  {
    "codigo": "223820",
    "descricao": "Fonoaudi�logo em audiologia"
  },
  {
    "codigo": "223825",
    "descricao": "Fonoaudi�logo em disfagia"
  },
  {
    "codigo": "223830",
    "descricao": "Fonoaudi�logo em linguagem"
  },
  {
    "codigo": "223835",
    "descricao": "Fonoaudi�logo em motricidade orofacial"
  },
  {
    "codigo": "223840",
    "descricao": "Fonoaudi�logo em sa�de coletiva"
  },
  {
    "codigo": "223845",
    "descricao": "Fonoaudi�logo em voz"
  },
  {
    "codigo": "223905",
    "descricao": "Terapeuta ocupacional"
  },
  {
    "codigo": "223910",
    "descricao": "Ortoptista"
  },
  {
    "codigo": "223915",
    "descricao": "Psicomotricista"
  },
  {
    "codigo": "224105",
    "descricao": "Avaliador f�sico"
  },
  {
    "codigo": "224110",
    "descricao": "Ludomotricista"
  },
  {
    "codigo": "224115",
    "descricao": "Preparador de atleta"
  },
  {
    "codigo": "224120",
    "descricao": "Preparador f�sico"
  },
  {
    "codigo": "224125",
    "descricao": "T�cnico de desporto individual e coletivo (exceto futebol)"
  },
  {
    "codigo": "224130",
    "descricao": "T�cnico de laborat�rio e fiscaliza��o desportiva"
  },
  {
    "codigo": "224135",
    "descricao": "Treinador profissional de futebol"
  },
  {
    "codigo": "224140",
    "descricao": "Profissional de educa��o f�sica na sa�de"
  },
  {
    "codigo": "225103",
    "descricao": "M�dico infectologista"
  },
  {
    "codigo": "225105",
    "descricao": "M�dico acupunturista"
  },
  {
    "codigo": "225106",
    "descricao": "M�dico legista"
  },
  {
    "codigo": "225109",
    "descricao": "M�dico nefrologista"
  },
  {
    "codigo": "225110",
    "descricao": "M�dico alergista e imunologista"
  },
  {
    "codigo": "225112",
    "descricao": "M�dico neurologista"
  },
  {
    "codigo": "225115",
    "descricao": "M�dico angiologista"
  },
  {
    "codigo": "225118",
    "descricao": "M�dico nutrologista"
  },
  {
    "codigo": "225120",
    "descricao": "M�dico cardiologista"
  },
  {
    "codigo": "225121",
    "descricao": "M�dico oncologista cl�nico"
  },
  {
    "codigo": "225122",
    "descricao": "M�dico cancerologista pedi�trico"
  },
  {
    "codigo": "225124",
    "descricao": "M�dico pediatra"
  },
  {
    "codigo": "225125",
    "descricao": "M�dico cl�nico"
  },
  {
    "codigo": "225127",
    "descricao": "M�dico pneumologista"
  },
  {
    "codigo": "225130",
    "descricao": "M�dico de fam�lia e comunidade"
  },
  {
    "codigo": "225133",
    "descricao": "M�dico psiquiatra"
  },
  {
    "codigo": "225135",
    "descricao": "M�dico dermatologista"
  },
  {
    "codigo": "225136",
    "descricao": "M�dico reumatologista"
  },
  {
    "codigo": "225139",
    "descricao": "M�dico sanitarista"
  },
  {
    "codigo": "225140",
    "descricao": "M�dico do trabalho"
  },
  {
    "codigo": "225142",
    "descricao": "M�dico da estrat�gia de sa�de da fam�lia"
  },
  {
    "codigo": "225145",
    "descricao": "M�dico em medicina de tr�fego"
  },
  {
    "codigo": "225148",
    "descricao": "M�dico anatomopatologista"
  },
  {
    "codigo": "225150",
    "descricao": "M�dico em medicina intensiva"
  },
  {
    "codigo": "225151",
    "descricao": "M�dico anestesiologista"
  },
  {
    "codigo": "225154",
    "descricao": "M�dico antropos�fico"
  },
  {
    "codigo": "225155",
    "descricao": "M�dico endocrinologista e metabologista"
  },
  {
    "codigo": "225160",
    "descricao": "M�dico fisiatra"
  },
  {
    "codigo": "225165",
    "descricao": "M�dico gastroenterologista"
  },
  {
    "codigo": "225170",
    "descricao": "M�dico generalista"
  },
  {
    "codigo": "225175",
    "descricao": "M�dico geneticista"
  },
  {
    "codigo": "225180",
    "descricao": "M�dico geriatra"
  },
  {
    "codigo": "225185",
    "descricao": "M�dico hematologista"
  },
  {
    "codigo": "225195",
    "descricao": "M�dico homeopata"
  },
  {
    "codigo": "225203",
    "descricao": "M�dico em cirurgia vascular"
  },
  {
    "codigo": "225210",
    "descricao": "M�dico cirurgi�o cardiovascular"
  },
  {
    "codigo": "225215",
    "descricao": "M�dico cirurgi�o de cabe�a e pesco�o"
  },
  {
    "codigo": "225220",
    "descricao": "M�dico cirurgi�o do aparelho digestivo"
  },
  {
    "codigo": "225225",
    "descricao": "M�dico cirurgi�o geral"
  },
  {
    "codigo": "225230",
    "descricao": "M�dico cirurgi�o pedi�trico"
  },
  {
    "codigo": "225235",
    "descricao": "M�dico cirurgi�o pl�stico"
  },
  {
    "codigo": "225240",
    "descricao": "M�dico cirurgi�o tor�cico"
  },
  {
    "codigo": "225250",
    "descricao": "M�dico ginecologista e obstetra"
  },
  {
    "codigo": "225255",
    "descricao": "M�dico mastologista"
  },
  {
    "codigo": "225260",
    "descricao": "M�dico neurocirurgi�o"
  },
  {
    "codigo": "225265",
    "descricao": "M�dico oftalmologista"
  },
  {
    "codigo": "225270",
    "descricao": "M�dico ortopedista e traumatologista"
  },
  {
    "codigo": "225275",
    "descricao": "M�dico otorrinolaringologista"
  },
  {
    "codigo": "225280",
    "descricao": "M�dico coloproctologista"
  },
  {
    "codigo": "225285",
    "descricao": "M�dico urologista"
  },
  {
    "codigo": "225290",
    "descricao": "M�dico cancerologista cirurg�co"
  },
  {
    "codigo": "225295",
    "descricao": "M�dico cirurgi�o da m�o"
  },
  {
    "codigo": "225305",
    "descricao": "M�dico citopatologista"
  },
  {
    "codigo": "225310",
    "descricao": "M�dico em endoscopia"
  },
  {
    "codigo": "225315",
    "descricao": "M�dico em medicina nuclear"
  },
  {
    "codigo": "225320",
    "descricao": "M�dico em radiologia e diagn�stico por imagem"
  },
  {
    "codigo": "225325",
    "descricao": "M�dico patologista"
  },
  {
    "codigo": "225330",
    "descricao": "M�dico radioterapeuta"
  },
  {
    "codigo": "225335",
    "descricao": "M�dico patologista cl�nico / medicina laboratorial"
  },
  {
    "codigo": "225340",
    "descricao": "M�dico hemoterapeuta"
  },
  {
    "codigo": "225345",
    "descricao": "M�dico hiperbarista"
  },
  {
    "codigo": "225350",
    "descricao": "M�dico neurofisiologista cl�nico"
  },
  {
    "codigo": "225355",
    "descricao": "M�dico radiologista intervencionista"
  },
  {
    "codigo": "226105",
    "descricao": "Quiropraxista"
  },
  {
    "codigo": "226110",
    "descricao": "Osteopata"
  },
  {
    "codigo": "226305",
    "descricao": "Musicoterapeuta"
  },
  {
    "codigo": "226310",
    "descricao": "Arteterapeuta"
  },
  {
    "codigo": "226315",
    "descricao": "Equoterapeuta"
  },
  {
    "codigo": "226320",
    "descricao": "Natur�logo"
  },
  {
    "codigo": "231105",
    "descricao": "Professor de n�vel superior na educa��o infantil (quatro a seis anos)"
  },
  {
    "codigo": "231110",
    "descricao": "Professor de n�vel superior na educa��o infantil (zero a tr�s anos)"
  },
  {
    "codigo": "231205",
    "descricao": "Professor da  educa��o de jovens e adultos do ensino fundamental (primeira a quarta s�rie)"
  },
  {
    "codigo": "231210",
    "descricao": "Professor de n�vel superior do ensino fundamental (primeira a quarta s�rie)"
  },
  {
    "codigo": "231305",
    "descricao": "Professor de ci�ncias exatas e naturais do ensino fundamental"
  },
  {
    "codigo": "231310",
    "descricao": "Professor de educa��o art�stica do ensino fundamental"
  },
  {
    "codigo": "231315",
    "descricao": "Professor de educa��o f�sica do ensino fundamental"
  },
  {
    "codigo": "231320",
    "descricao": "Professor de geografia do ensino fundamental"
  },
  {
    "codigo": "231325",
    "descricao": "Professor de hist�ria do ensino fundamental"
  },
  {
    "codigo": "231330",
    "descricao": "Professor de l�ngua estrangeira moderna do ensino fundamental"
  },
  {
    "codigo": "231335",
    "descricao": "Professor de l�ngua portuguesa do ensino fundamental"
  },
  {
    "codigo": "231340",
    "descricao": "Professor de matem�tica do ensino fundamental"
  },
  {
    "codigo": "232105",
    "descricao": "Professor de artes no ensino m�dio"
  },
  {
    "codigo": "232110",
    "descricao": "Professor de biologia no ensino m�dio"
  },
  {
    "codigo": "232115",
    "descricao": "Professor de disciplinas pedag�gicas no ensino m�dio"
  },
  {
    "codigo": "232120",
    "descricao": "Professor de educa��o f�sica no ensino m�dio"
  },
  {
    "codigo": "232125",
    "descricao": "Professor de filosofia no ensino m�dio"
  },
  {
    "codigo": "232130",
    "descricao": "Professor de f�sica no ensino m�dio"
  },
  {
    "codigo": "232135",
    "descricao": "Professor de geografia no ensino m�dio"
  },
  {
    "codigo": "232140",
    "descricao": "Professor de hist�ria no ensino m�dio"
  },
  {
    "codigo": "232145",
    "descricao": "Professor de l�ngua e literatura brasileira no ensino m�dio"
  },
  {
    "codigo": "232150",
    "descricao": "Professor de l�ngua estrangeira moderna no ensino m�dio"
  },
  {
    "codigo": "232155",
    "descricao": "Professor de matem�tica no ensino m�dio"
  },
  {
    "codigo": "232160",
    "descricao": "Professor de psicologia no ensino m�dio"
  },
  {
    "codigo": "232165",
    "descricao": "Professor de qu�mica no ensino m�dio"
  },
  {
    "codigo": "232170",
    "descricao": "Professor de sociologia no ensino m�dio"
  },
  {
    "codigo": "233105",
    "descricao": "Professor da �rea de meio ambiente"
  },
  {
    "codigo": "233110",
    "descricao": "Professor de desenho t�cnico"
  },
  {
    "codigo": "233115",
    "descricao": "Professor de t�cnicas agr�colas"
  },
  {
    "codigo": "233120",
    "descricao": "Professor de t�cnicas comerciais e secretariais"
  },
  {
    "codigo": "233125",
    "descricao": "Professor de t�cnicas de enfermagem"
  },
  {
    "codigo": "233130",
    "descricao": "Professor de t�cnicas industriais"
  },
  {
    "codigo": "233135",
    "descricao": "Professor de tecnologia e c�lculo t�cnico"
  },
  {
    "codigo": "233205",
    "descricao": "Instrutor de aprendizagem e treinamento agropecu�rio"
  },
  {
    "codigo": "233210",
    "descricao": "Instrutor de aprendizagem e treinamento industrial"
  },
  {
    "codigo": "233215",
    "descricao": "Instrutor de aprendizagem e treinamento comercial"
  },
  {
    "codigo": "233220",
    "descricao": "Professor instrutor de ensino e aprendizagem agroflorestal"
  },
  {
    "codigo": "233225",
    "descricao": "Professor instrutor de ensino e aprendizagem em servi�os"
  },
  {
    "codigo": "234105",
    "descricao": "Professor de matem�tica aplicada (no ensino superior)"
  },
  {
    "codigo": "234110",
    "descricao": "Professor de matem�tica pura (no ensino superior)"
  },
  {
    "codigo": "234115",
    "descricao": "Professor de estat�stica (no ensino superior)"
  },
  {
    "codigo": "234120",
    "descricao": "Professor de computa��o (no ensino superior)"
  },
  {
    "codigo": "234125",
    "descricao": "Professor de pesquisa operacional (no ensino superior)"
  },
  {
    "codigo": "234205",
    "descricao": "Professor de f�sica (ensino superior)"
  },
  {
    "codigo": "234210",
    "descricao": "Professor de qu�mica (ensino superior)"
  },
  {
    "codigo": "234215",
    "descricao": "Professor de astronomia (ensino superior)"
  },
  {
    "codigo": "234305",
    "descricao": "Professor de arquitetura"
  },
  {
    "codigo": "234310",
    "descricao": "Professor de engenharia"
  },
  {
    "codigo": "234315",
    "descricao": "Professor de geof�sica"
  },
  {
    "codigo": "234320",
    "descricao": "Professor de geologia"
  },
  {
    "codigo": "234405",
    "descricao": "Professor de ci�ncias biol�gicas do ensino superior"
  },
  {
    "codigo": "234410",
    "descricao": "Professor de educa��o f�sica no ensino superior"
  },
  {
    "codigo": "234415",
    "descricao": "Professor de enfermagem do ensino superior"
  },
  {
    "codigo": "234420",
    "descricao": "Professor de farm�cia e bioqu�mica"
  },
  {
    "codigo": "234425",
    "descricao": "Professor de fisioterapia"
  },
  {
    "codigo": "234430",
    "descricao": "Professor de fonoaudiologia"
  },
  {
    "codigo": "234435",
    "descricao": "Professor de medicina"
  },
  {
    "codigo": "234440",
    "descricao": "Professor de medicina veterin�ria"
  },
  {
    "codigo": "234445",
    "descricao": "Professor de nutri��o"
  },
  {
    "codigo": "234450",
    "descricao": "Professor de odontologia"
  },
  {
    "codigo": "234455",
    "descricao": "Professor de terapia ocupacional"
  },
  {
    "codigo": "234460",
    "descricao": "Professor de zootecnia do ensino superior"
  },
  {
    "codigo": "234505",
    "descricao": "Professor de ensino superior na �rea de did�tica"
  },
  {
    "codigo": "234510",
    "descricao": "Professor de ensino superior na �rea de orienta��o educacional"
  },
  {
    "codigo": "234515",
    "descricao": "Professor de ensino superior na �rea de pesquisa educacional"
  },
  {
    "codigo": "234520",
    "descricao": "Professor de ensino superior na �rea de pr�tica de ensino"
  },
  {
    "codigo": "234604",
    "descricao": "Professor de l�ngua alem�"
  },
  {
    "codigo": "234608",
    "descricao": "Professor de l�ngua italiana"
  },
  {
    "codigo": "234612",
    "descricao": "Professor de l�ngua francesa"
  },
  {
    "codigo": "234616",
    "descricao": "Professor de l�ngua inglesa"
  },
  {
    "codigo": "234620",
    "descricao": "Professor de l�ngua espanhola"
  },
  {
    "codigo": "234624",
    "descricao": "Professor de l�ngua portuguesa"
  },
  {
    "codigo": "234628",
    "descricao": "Professor de literatura brasileira"
  },
  {
    "codigo": "234632",
    "descricao": "Professor de literatura portuguesa"
  },
  {
    "codigo": "234636",
    "descricao": "Professor de literatura alem�"
  },
  {
    "codigo": "234640",
    "descricao": "Professor de literatura comparada"
  },
  {
    "codigo": "234644",
    "descricao": "Professor de literatura espanhola"
  },
  {
    "codigo": "234648",
    "descricao": "Professor de literatura francesa"
  },
  {
    "codigo": "234652",
    "descricao": "Professor de literatura inglesa"
  },
  {
    "codigo": "234656",
    "descricao": "Professor de literatura italiana"
  },
  {
    "codigo": "234660",
    "descricao": "Professor de literatura de l�nguas estrangeiras modernas"
  },
  {
    "codigo": "234664",
    "descricao": "Professor de outras l�nguas e literaturas"
  },
  {
    "codigo": "234668",
    "descricao": "Professor de l�nguas estrangeiras modernas"
  },
  {
    "codigo": "234672",
    "descricao": "Professor de ling��stica e ling��stica aplicada"
  },
  {
    "codigo": "234676",
    "descricao": "Professor de filologia e cr�tica textual"
  },
  {
    "codigo": "234680",
    "descricao": "Professor de semi�tica"
  },
  {
    "codigo": "234684",
    "descricao": "Professor de teoria da literatura"
  },
  {
    "codigo": "234689",
    "descricao": "Professor de l�ngua brasileira de sinais (libras)"
  },
  {
    "codigo": "234705",
    "descricao": "Professor de antropologia do ensino superior"
  },
  {
    "codigo": "234710",
    "descricao": "Professor de arquivologia do ensino superior"
  },
  {
    "codigo": "234715",
    "descricao": "Professor de biblioteconomia do ensino superior"
  },
  {
    "codigo": "234720",
    "descricao": "Professor de ci�ncia pol�tica do ensino superior"
  },
  {
    "codigo": "234725",
    "descricao": "Professor de comunica��o social do ensino superior"
  },
  {
    "codigo": "234730",
    "descricao": "Professor de direito do ensino superior"
  },
  {
    "codigo": "234735",
    "descricao": "Professor de filosofia do ensino superior"
  },
  {
    "codigo": "234740",
    "descricao": "Professor de geografia do ensino superior"
  },
  {
    "codigo": "234745",
    "descricao": "Professor de hist�ria do ensino superior"
  },
  {
    "codigo": "234750",
    "descricao": "Professor de jornalismo"
  },
  {
    "codigo": "234755",
    "descricao": "Professor de museologia do ensino superior"
  },
  {
    "codigo": "234760",
    "descricao": "Professor de psicologia do ensino superior"
  },
  {
    "codigo": "234765",
    "descricao": "Professor de servi�o social do ensino superior"
  },
  {
    "codigo": "234770",
    "descricao": "Professor de sociologia do ensino superior"
  },
  {
    "codigo": "234805",
    "descricao": "Professor de economia"
  },
  {
    "codigo": "234810",
    "descricao": "Professor de administra��o"
  },
  {
    "codigo": "234815",
    "descricao": "Professor de contabilidade"
  },
  {
    "codigo": "234905",
    "descricao": "Professor de artes do espet�culo no ensino superior"
  },
  {
    "codigo": "234910",
    "descricao": "Professor de artes visuais no ensino superior (artes pl�sticas e multim�dia)"
  },
  {
    "codigo": "234915",
    "descricao": "Professor de m�sica no ensino superior"
  },
  {
    "codigo": "239205",
    "descricao": "Professor de alunos com defici�ncia auditiva e surdos"
  },
  {
    "codigo": "239210",
    "descricao": "Professor de alunos com defici�ncia f�sica"
  },
  {
    "codigo": "239215",
    "descricao": "Professor de alunos com defici�ncia mental"
  },
  {
    "codigo": "239220",
    "descricao": "Professor de alunos com defici�ncia m�ltipla"
  },
  {
    "codigo": "239225",
    "descricao": "Professor de alunos com defici�ncia visual"
  },
  {
    "codigo": "239405",
    "descricao": "Coordenador pedag�gico"
  },
  {
    "codigo": "239410",
    "descricao": "Orientador educacional"
  },
  {
    "codigo": "239415",
    "descricao": "Pedagogo"
  },
  {
    "codigo": "239420",
    "descricao": "Professor de t�cnicas e recursos audiovisuais"
  },
  {
    "codigo": "239425",
    "descricao": "Psicopedagogo"
  },
  {
    "codigo": "239430",
    "descricao": "Supervisor de ensino"
  },
  {
    "codigo": "239435",
    "descricao": "Designer educacional"
  },
  {
    "codigo": "239440",
    "descricao": "Neuropsicopedagogo clinico"
  },
  {
    "codigo": "239445",
    "descricao": "Neuropsicopedagogo institucional"
  },
  {
    "codigo": "241005",
    "descricao": "Advogado"
  },
  {
    "codigo": "241010",
    "descricao": "Advogado de empresa"
  },
  {
    "codigo": "241015",
    "descricao": "Advogado (direito civil)"
  },
  {
    "codigo": "241020",
    "descricao": "Advogado (direito p�blico)"
  },
  {
    "codigo": "241025",
    "descricao": "Advogado (direito penal)"
  },
  {
    "codigo": "241030",
    "descricao": "Advogado (�reas especiais)"
  },
  {
    "codigo": "241035",
    "descricao": "Advogado (direito do trabalho)"
  },
  {
    "codigo": "241040",
    "descricao": "Consultor jur�dico"
  },
  {
    "codigo": "241205",
    "descricao": "Advogado da uni�o"
  },
  {
    "codigo": "241210",
    "descricao": "Procurador aut�rquico"
  },
  {
    "codigo": "241215",
    "descricao": "Procurador da fazenda nacional"
  },
  {
    "codigo": "241220",
    "descricao": "Procurador do estado"
  },
  {
    "codigo": "241225",
    "descricao": "Procurador do munic�pio"
  },
  {
    "codigo": "241230",
    "descricao": "Procurador federal"
  },
  {
    "codigo": "241235",
    "descricao": "Procurador fundacional"
  },
  {
    "codigo": "241305",
    "descricao": "Oficial de registro de contratos mar�timos"
  },
  {
    "codigo": "241310",
    "descricao": "Oficial do registro civil de pessoas jur�dicas"
  },
  {
    "codigo": "241315",
    "descricao": "Oficial do registro civil de pessoas naturais"
  },
  {
    "codigo": "241320",
    "descricao": "Oficial do registro de distribui��es"
  },
  {
    "codigo": "241325",
    "descricao": "Oficial do registro de im�veis"
  },
  {
    "codigo": "241330",
    "descricao": "Oficial do registro de t�tulos e documentos"
  },
  {
    "codigo": "241335",
    "descricao": "Tabeli�o de notas"
  },
  {
    "codigo": "241340",
    "descricao": "Tabeli�o de protestos"
  },
  {
    "codigo": "241405",
    "descricao": "Conselheiro julgador"
  },
  {
    "codigo": "242205",
    "descricao": "Procurador da rep�blica"
  },
  {
    "codigo": "242210",
    "descricao": "Procurador de justi�a"
  },
  {
    "codigo": "242215",
    "descricao": "Procurador de justi�a militar"
  },
  {
    "codigo": "242220",
    "descricao": "Procurador do trabalho"
  },
  {
    "codigo": "242225",
    "descricao": "Procurador regional da rep�blica"
  },
  {
    "codigo": "242230",
    "descricao": "Procurador regional do trabalho"
  },
  {
    "codigo": "242235",
    "descricao": "Promotor de justi�a"
  },
  {
    "codigo": "242240",
    "descricao": "Subprocurador de justi�a militar"
  },
  {
    "codigo": "242245",
    "descricao": "Subprocurador-geral da rep�blica"
  },
  {
    "codigo": "242250",
    "descricao": "Subprocurador-geral do trabalho"
  },
  {
    "codigo": "242305",
    "descricao": "Delegado de pol�cia"
  },
  {
    "codigo": "242405",
    "descricao": "Defensor p�blico"
  },
  {
    "codigo": "242410",
    "descricao": "Procurador da assist�ncia judici�ria"
  },
  {
    "codigo": "242905",
    "descricao": "Oficial de intelig�ncia"
  },
  {
    "codigo": "242910",
    "descricao": "Oficial t�cnico de intelig�ncia"
  },
  {
    "codigo": "251105",
    "descricao": "Antrop�logo"
  },
  {
    "codigo": "251110",
    "descricao": "Arque�logo"
  },
  {
    "codigo": "251115",
    "descricao": "Cientista pol�tico"
  },
  {
    "codigo": "251120",
    "descricao": "Soci�logo"
  },
  {
    "codigo": "251205",
    "descricao": "Economista"
  },
  {
    "codigo": "251210",
    "descricao": "Economista agroindustrial"
  },
  {
    "codigo": "251215",
    "descricao": "Economista financeiro"
  },
  {
    "codigo": "251220",
    "descricao": "Economista industrial"
  },
  {
    "codigo": "251225",
    "descricao": "Economista do setor p�blico"
  },
  {
    "codigo": "251230",
    "descricao": "Economista ambiental"
  },
  {
    "codigo": "251235",
    "descricao": "Economista regional e urbano"
  },
  {
    "codigo": "251305",
    "descricao": "Ge�grafo"
  },
  {
    "codigo": "251405",
    "descricao": "Fil�sofo"
  },
  {
    "codigo": "251505",
    "descricao": "Psic�logo educacional"
  },
  {
    "codigo": "251510",
    "descricao": "Psic�logo cl�nico"
  },
  {
    "codigo": "251515",
    "descricao": "Psic�logo do esporte"
  },
  {
    "codigo": "251520",
    "descricao": "Psic�logo hospitalar"
  },
  {
    "codigo": "251525",
    "descricao": "Psic�logo jur�dico"
  },
  {
    "codigo": "251530",
    "descricao": "Psic�logo social"
  },
  {
    "codigo": "251535",
    "descricao": "Psic�logo do tr�nsito"
  },
  {
    "codigo": "251540",
    "descricao": "Psic�logo do trabalho"
  },
  {
    "codigo": "251545",
    "descricao": "Neuropsic�logo"
  },
  {
    "codigo": "251550",
    "descricao": "Psicanalista"
  },
  {
    "codigo": "251555",
    "descricao": "Psic�logo acupunturista"
  },
  {
    "codigo": "251605",
    "descricao": "Assistente social"
  },
  {
    "codigo": "251610",
    "descricao": "Economista dom�stico"
  },
  {
    "codigo": "252105",
    "descricao": "Administrador"
  },
  {
    "codigo": "252205",
    "descricao": "Auditor (contadores e afins)"
  },
  {
    "codigo": "252210",
    "descricao": "Contador"
  },
  {
    "codigo": "252215",
    "descricao": "Perito cont�bil"
  },
  {
    "codigo": "252305",
    "descricao": "Secret�ria(o) executiva(o)"
  },
  {
    "codigo": "252310",
    "descricao": "Secret�rio  bil�ng�e"
  },
  {
    "codigo": "252315",
    "descricao": "Secret�ria tril�ng�e"
  },
  {
    "codigo": "252320",
    "descricao": "Tecn�logo em secretariado escolar"
  },
  {
    "codigo": "252405",
    "descricao": "Analista de recursos humanos"
  },
  {
    "codigo": "252505",
    "descricao": "Administrador de fundos e carteiras de investimento"
  },
  {
    "codigo": "252510",
    "descricao": "Analista de c�mbio"
  },
  {
    "codigo": "252515",
    "descricao": "Analista de cobran�a (institui��es financeiras)"
  },
  {
    "codigo": "252525",
    "descricao": "Analista de cr�dito (institui��es financeiras)"
  },
  {
    "codigo": "252530",
    "descricao": "Analista de cr�dito rural"
  },
  {
    "codigo": "252535",
    "descricao": "Analista de leasing"
  },
  {
    "codigo": "252540",
    "descricao": "Analista de produtos banc�rios"
  },
  {
    "codigo": "252545",
    "descricao": "Analista financeiro (institui��es financeiras)"
  },
  {
    "codigo": "252550",
    "descricao": "Profissional de rela��es com investidores"
  },
  {
    "codigo": "252605",
    "descricao": "Gestor em seguran�a"
  },
  {
    "codigo": "252705",
    "descricao": "Analista de pcp (programa��o e controle da produ��o)"
  },
  {
    "codigo": "252710",
    "descricao": "Analista de planejamento de materias"
  },
  {
    "codigo": "252715",
    "descricao": "Analista de logistica"
  },
  {
    "codigo": "252720",
    "descricao": "Analista de projetos logisticos"
  },
  {
    "codigo": "252725",
    "descricao": "Analista de gest�o de estoque"
  },
  {
    "codigo": "253110",
    "descricao": "Redator de publicidade"
  },
  {
    "codigo": "253115",
    "descricao": "Publicit�rio"
  },
  {
    "codigo": "253120",
    "descricao": "Diretor de m�dia (publicidade)"
  },
  {
    "codigo": "253125",
    "descricao": "Diretor de arte (publicidade)"
  },
  {
    "codigo": "253130",
    "descricao": "Diretor de cria��o"
  },
  {
    "codigo": "253135",
    "descricao": "Diretor de contas (publicidade)"
  },
  {
    "codigo": "253140",
    "descricao": "Agenciador de propaganda"
  },
  {
    "codigo": "253205",
    "descricao": "Gerente de capta��o (fundos e investimentos institucionais)"
  },
  {
    "codigo": "253210",
    "descricao": "Gerente de clientes especiais (private)"
  },
  {
    "codigo": "253215",
    "descricao": "Gerente de contas - pessoa f�sica e jur�dica"
  },
  {
    "codigo": "253220",
    "descricao": "Gerente de grandes contas (corporate)"
  },
  {
    "codigo": "253225",
    "descricao": "Operador de neg�cios"
  },
  {
    "codigo": "253305",
    "descricao": "Corretor de valores, ativos financeiros, mercadorias e derivativos"
  },
  {
    "codigo": "253405",
    "descricao": "Analista de m�dias sociais"
  },
  {
    "codigo": "253410",
    "descricao": "Influenciador digital"
  },
  {
    "codigo": "254105",
    "descricao": "Auditor-fiscal da receita federal"
  },
  {
    "codigo": "254110",
    "descricao": "T�cnico da receita federal"
  },
  {
    "codigo": "254205",
    "descricao": "Auditor-fiscal da previd�ncia social"
  },
  {
    "codigo": "254305",
    "descricao": "Auditor-fiscal do trabalho"
  },
  {
    "codigo": "254310",
    "descricao": "Agente de higiene e seguran�a"
  },
  {
    "codigo": "254405",
    "descricao": "Fiscal de tributos estadual"
  },
  {
    "codigo": "254410",
    "descricao": "Fiscal de tributos municipal"
  },
  {
    "codigo": "254415",
    "descricao": "T�cnico de tributos estadual"
  },
  {
    "codigo": "254420",
    "descricao": "T�cnico de tributos municipal"
  },
  {
    "codigo": "254505",
    "descricao": "Fiscal de atividades urbanas"
  },
  {
    "codigo": "261105",
    "descricao": "Arquivista pesquisador (jornalismo)"
  },
  {
    "codigo": "261110",
    "descricao": "Assessor de imprensa"
  },
  {
    "codigo": "261115",
    "descricao": "Diretor de reda��o"
  },
  {
    "codigo": "261120",
    "descricao": "Editor"
  },
  {
    "codigo": "261125",
    "descricao": "Jornalista"
  },
  {
    "codigo": "261130",
    "descricao": "Produtor de texto"
  },
  {
    "codigo": "261135",
    "descricao": "Rep�rter (exclusive r�dio e televis�o)"
  },
  {
    "codigo": "261140",
    "descricao": "Revisor de texto"
  },
  {
    "codigo": "261205",
    "descricao": "Bibliotec�rio"
  },
  {
    "codigo": "261210",
    "descricao": "Documentalista"
  },
  {
    "codigo": "261215",
    "descricao": "Analista de informa��es (pesquisador de informa��es de rede)"
  },
  {
    "codigo": "261305",
    "descricao": "Arquivista"
  },
  {
    "codigo": "261310",
    "descricao": "Muse�logo"
  },
  {
    "codigo": "261405",
    "descricao": "Fil�logo"
  },
  {
    "codigo": "261410",
    "descricao": "Int�rprete"
  },
  {
    "codigo": "261415",
    "descricao": "Ling�ista"
  },
  {
    "codigo": "261420",
    "descricao": "Tradutor"
  },
  {
    "codigo": "261425",
    "descricao": "Int�rprete de l�ngua de sinais"
  },
  {
    "codigo": "261430",
    "descricao": "Audiodescritor"
  },
  {
    "codigo": "261505",
    "descricao": "Autor-roteirista"
  },
  {
    "codigo": "261510",
    "descricao": "Cr�tico"
  },
  {
    "codigo": "261515",
    "descricao": "Escritor de fic��o"
  },
  {
    "codigo": "261520",
    "descricao": "Escritor de n�o fic��o"
  },
  {
    "codigo": "261525",
    "descricao": "Poeta"
  },
  {
    "codigo": "261530",
    "descricao": "Redator de textos t�cnicos"
  },
  {
    "codigo": "261605",
    "descricao": "Editor de jornal"
  },
  {
    "codigo": "261610",
    "descricao": "Editor de livro"
  },
  {
    "codigo": "261615",
    "descricao": "Editor de m�dia eletr�nica"
  },
  {
    "codigo": "261620",
    "descricao": "Editor de revista"
  },
  {
    "codigo": "261625",
    "descricao": "Editor de revista cient�fica"
  },
  {
    "codigo": "261705",
    "descricao": "�ncora de m�dias audiovisuais"
  },
  {
    "codigo": "261710",
    "descricao": "Comentarista de m�dias audiovisuais"
  },
  {
    "codigo": "261715",
    "descricao": "Locutor de m�dias audiovisuais"
  },
  {
    "codigo": "261730",
    "descricao": "Rep�rter de m�dias audiovisuais"
  },
  {
    "codigo": "261805",
    "descricao": "Fot�grafo"
  },
  {
    "codigo": "261810",
    "descricao": "Fot�grafo publicit�rio"
  },
  {
    "codigo": "261815",
    "descricao": "Fot�grafo retratista"
  },
  {
    "codigo": "261820",
    "descricao": "Rep�rter fotogr�fico"
  },
  {
    "codigo": "261905",
    "descricao": "Continuista"
  },
  {
    "codigo": "261910",
    "descricao": "Assistente de dire��o (tv)"
  },
  {
    "codigo": "262105",
    "descricao": "Produtor cultural"
  },
  {
    "codigo": "262110",
    "descricao": "Produtor cinematogr�fico"
  },
  {
    "codigo": "262115",
    "descricao": "Produtor de r�dio"
  },
  {
    "codigo": "262120",
    "descricao": "Produtor de teatro"
  },
  {
    "codigo": "262125",
    "descricao": "Produtor de televis�o"
  },
  {
    "codigo": "262130",
    "descricao": "Tecn�logo em produ��o fonogr�fica"
  },
  {
    "codigo": "262135",
    "descricao": "Tecn�logo em produ��o audiovisual"
  },
  {
    "codigo": "262205",
    "descricao": "Diretor de cinema"
  },
  {
    "codigo": "262210",
    "descricao": "Diretor de programas de r�dio"
  },
  {
    "codigo": "262215",
    "descricao": "Diretor de programas de televis�o"
  },
  {
    "codigo": "262220",
    "descricao": "Diretor teatral"
  },
  {
    "codigo": "262225",
    "descricao": "Diretor de programa��o"
  },
  {
    "codigo": "262230",
    "descricao": "Diretor de produ��o"
  },
  {
    "codigo": "262235",
    "descricao": "Diretor artist�co"
  },
  {
    "codigo": "262305",
    "descricao": "Cen�grafo carnavalesco e festas populares"
  },
  {
    "codigo": "262310",
    "descricao": "Cen�grafo de cinema"
  },
  {
    "codigo": "262315",
    "descricao": "Cen�grafo de eventos"
  },
  {
    "codigo": "262320",
    "descricao": "Cen�grafo de teatro"
  },
  {
    "codigo": "262325",
    "descricao": "Cen�grafo de tv"
  },
  {
    "codigo": "262330",
    "descricao": "Diretor de arte"
  },
  {
    "codigo": "262405",
    "descricao": "Artista (artes visuais)"
  },
  {
    "codigo": "262410",
    "descricao": "Desenhista industrial gr�fico (designer gr�fico)"
  },
  {
    "codigo": "262415",
    "descricao": "Conservador-restaurador de bens  culturais"
  },
  {
    "codigo": "262420",
    "descricao": "Desenhista industrial de produto (designer de produto)"
  },
  {
    "codigo": "262425",
    "descricao": "Desenhista industrial de produto de moda (designer de moda)"
  },
  {
    "codigo": "262505",
    "descricao": "Ator"
  },
  {
    "codigo": "262605",
    "descricao": "Compositor"
  },
  {
    "codigo": "262610",
    "descricao": "M�sico arranjador"
  },
  {
    "codigo": "262615",
    "descricao": "M�sico regente"
  },
  {
    "codigo": "262620",
    "descricao": "Music�logo"
  },
  {
    "codigo": "262705",
    "descricao": "M�sico int�rprete cantor"
  },
  {
    "codigo": "262710",
    "descricao": "M�sico int�rprete instrumentista"
  },
  {
    "codigo": "262805",
    "descricao": "Assistente de coreografia"
  },
  {
    "codigo": "262810",
    "descricao": "Bailarino (exceto dan�as populares)"
  },
  {
    "codigo": "262815",
    "descricao": "Core�grafo"
  },
  {
    "codigo": "262820",
    "descricao": "Dramaturgo de dan�a"
  },
  {
    "codigo": "262825",
    "descricao": "Ensaiador de dan�a"
  },
  {
    "codigo": "262830",
    "descricao": "Professor de dan�a"
  },
  {
    "codigo": "262905",
    "descricao": "Decorador de interiores de n�vel superior"
  },
  {
    "codigo": "263105",
    "descricao": "Ministro de culto religioso"
  },
  {
    "codigo": "263110",
    "descricao": "Mission�rio"
  },
  {
    "codigo": "263115",
    "descricao": "Te�logo"
  },
  {
    "codigo": "271105",
    "descricao": "Chefe de cozinha"
  },
  {
    "codigo": "271110",
    "descricao": "Tecn�logo em gastronomia"
  },
  {
    "codigo": "300105",
    "descricao": "T�cnico em mecatr�nica - automa��o da manufatura"
  },
  {
    "codigo": "300110",
    "descricao": "T�cnico em mecatr�nica - rob�tica"
  },
  {
    "codigo": "300305",
    "descricao": "T�cnico em eletromec�nica"
  },
  {
    "codigo": "301105",
    "descricao": "T�cnico de laborat�rio industrial"
  },
  {
    "codigo": "301110",
    "descricao": "T�cnico de laborat�rio de an�lises f�sico-qu�micas (materiais de constru��o)"
  },
  {
    "codigo": "301115",
    "descricao": "T�cnico qu�mico de petr�leo"
  },
  {
    "codigo": "301205",
    "descricao": "T�cnico de apoio � bioengenharia"
  },
  {
    "codigo": "311105",
    "descricao": "T�cnico qu�mico"
  },
  {
    "codigo": "311110",
    "descricao": "T�cnico de celulose e papel"
  },
  {
    "codigo": "311115",
    "descricao": "T�cnico em curtimento"
  },
  {
    "codigo": "311205",
    "descricao": "T�cnico em petroqu�mica"
  },
  {
    "codigo": "311305",
    "descricao": "T�cnico em materiais, produtos cer�micos e vidros"
  },
  {
    "codigo": "311405",
    "descricao": "T�cnico em borracha"
  },
  {
    "codigo": "311410",
    "descricao": "T�cnico em pl�stico"
  },
  {
    "codigo": "311505",
    "descricao": "T�cnico de controle de meio ambiente"
  },
  {
    "codigo": "311510",
    "descricao": "T�cnico de meteorologia"
  },
  {
    "codigo": "311515",
    "descricao": "T�cnico de utilidade (produ��o e distribui��o de vapor, gases, �leos, combust�veis, energia)"
  },
  {
    "codigo": "311520",
    "descricao": "T�cnico em tratamento de efluentes"
  },
  {
    "codigo": "311605",
    "descricao": "T�cnico t�xtil"
  },
  {
    "codigo": "311610",
    "descricao": "T�cnico t�xtil (tratamentos qu�micos)"
  },
  {
    "codigo": "311615",
    "descricao": "T�cnico t�xtil de fia��o"
  },
  {
    "codigo": "311620",
    "descricao": "T�cnico t�xtil de malharia"
  },
  {
    "codigo": "311625",
    "descricao": "T�cnico t�xtil de tecelagem"
  },
  {
    "codigo": "311705",
    "descricao": "Colorista de papel"
  },
  {
    "codigo": "311710",
    "descricao": "Colorista t�xtil"
  },
  {
    "codigo": "311715",
    "descricao": "Preparador de tintas"
  },
  {
    "codigo": "311720",
    "descricao": "Preparador de tintas (f�brica de tecidos)"
  },
  {
    "codigo": "311725",
    "descricao": "Tingidor de couros e peles"
  },
  {
    "codigo": "312105",
    "descricao": "T�cnico de obras civis"
  },
  {
    "codigo": "312205",
    "descricao": "T�cnico de estradas"
  },
  {
    "codigo": "312210",
    "descricao": "T�cnico de saneamento"
  },
  {
    "codigo": "312305",
    "descricao": "T�cnico em agrimensura"
  },
  {
    "codigo": "312310",
    "descricao": "T�cnico em geod�sia e cartografia"
  },
  {
    "codigo": "312315",
    "descricao": "T�cnico em hidrografia"
  },
  {
    "codigo": "312320",
    "descricao": "Top�grafo"
  },
  {
    "codigo": "313105",
    "descricao": "Eletrot�cnico"
  },
  {
    "codigo": "313110",
    "descricao": "Eletrot�cnico (produ��o de energia)"
  },
  {
    "codigo": "313115",
    "descricao": "Eletrot�cnico na fabrica��o, montagem e instala��o de m�quinas e equipamentos"
  },
  {
    "codigo": "313120",
    "descricao": "T�cnico de manuten��o el�trica"
  },
  {
    "codigo": "313125",
    "descricao": "T�cnico de manuten��o el�trica de m�quina"
  },
  {
    "codigo": "313130",
    "descricao": "T�cnico eletricista"
  },
  {
    "codigo": "313205",
    "descricao": "T�cnico de manuten��o eletr�nica"
  },
  {
    "codigo": "313210",
    "descricao": "T�cnico de manuten��o eletr�nica (circuitos de m�quinas com comando num�rico)"
  },
  {
    "codigo": "313215",
    "descricao": "T�cnico eletr�nico"
  },
  {
    "codigo": "313220",
    "descricao": "T�cnico em manuten��o de equipamentos de inform�tica"
  },
  {
    "codigo": "313305",
    "descricao": "T�cnico de comunica��o de dados"
  },
  {
    "codigo": "313310",
    "descricao": "T�cnico de rede (telecomunica��es)"
  },
  {
    "codigo": "313315",
    "descricao": "T�cnico de telecomunica��es (telefonia)"
  },
  {
    "codigo": "313320",
    "descricao": "T�cnico de transmiss�o (telecomunica��es)"
  },
  {
    "codigo": "313405",
    "descricao": "T�cnico em calibra��o"
  },
  {
    "codigo": "313410",
    "descricao": "T�cnico em instrumenta��o"
  },
  {
    "codigo": "313415",
    "descricao": "Encarregado de manuten��o de instrumentos de controle, medi��o e similares"
  },
  {
    "codigo": "313505",
    "descricao": "T�cnico em fot�nica"
  },
  {
    "codigo": "314105",
    "descricao": "T�cnico em mec�nica de precis�o"
  },
  {
    "codigo": "314110",
    "descricao": "T�cnico mec�nico"
  },
  {
    "codigo": "314115",
    "descricao": "T�cnico mec�nico (calefa��o, ventila��o e refrigera��o)"
  },
  {
    "codigo": "314120",
    "descricao": "T�cnico mec�nico (m�quinas)"
  },
  {
    "codigo": "314125",
    "descricao": "T�cnico mec�nico (motores)"
  },
  {
    "codigo": "314205",
    "descricao": "T�cnico mec�nico na fabrica��o de ferramentas"
  },
  {
    "codigo": "314210",
    "descricao": "T�cnico mec�nico na manuten��o de ferramentas"
  },
  {
    "codigo": "314305",
    "descricao": "T�cnico em automobil�stica"
  },
  {
    "codigo": "314310",
    "descricao": "T�cnico mec�nico (aeronaves)"
  },
  {
    "codigo": "314315",
    "descricao": "T�cnico mec�nico (embarca��es)"
  },
  {
    "codigo": "314405",
    "descricao": "T�cnico de manuten��o de sistemas e instrumentos"
  },
  {
    "codigo": "314410",
    "descricao": "T�cnico em manuten��o de m�quinas"
  },
  {
    "codigo": "314610",
    "descricao": "T�cnico em caldeiraria"
  },
  {
    "codigo": "314615",
    "descricao": "T�cnico em estruturas met�licas"
  },
  {
    "codigo": "314620",
    "descricao": "T�cnico em soldagem"
  },
  {
    "codigo": "314625",
    "descricao": "Tecn�logo em soldagem"
  },
  {
    "codigo": "314705",
    "descricao": "T�cnico de acabamento em siderurgia"
  },
  {
    "codigo": "314710",
    "descricao": "T�cnico de aciaria em siderurgia"
  },
  {
    "codigo": "314715",
    "descricao": "T�cnico de fundi��o em siderurgia"
  },
  {
    "codigo": "314720",
    "descricao": "T�cnico de lamina��o em siderurgia"
  },
  {
    "codigo": "314725",
    "descricao": "T�cnico de redu��o na siderurgia (primeira fus�o)"
  },
  {
    "codigo": "314730",
    "descricao": "T�cnico de refrat�rio em siderurgia"
  },
  {
    "codigo": "314805",
    "descricao": "Inspetor de equipamentos"
  },
  {
    "codigo": "314810",
    "descricao": "Inspetor de fabrica��o"
  },
  {
    "codigo": "314815",
    "descricao": "Inspetor de ensaios n�o destrutivos"
  },
  {
    "codigo": "314825",
    "descricao": "Inspetor de dutos"
  },
  {
    "codigo": "314830",
    "descricao": "Inspetor de controle dimensional"
  },
  {
    "codigo": "314835",
    "descricao": "Inspetor de pintura"
  },
  {
    "codigo": "314840",
    "descricao": "Inspetor de manuten��o"
  },
  {
    "codigo": "314845",
    "descricao": "Inspetor de soldagem"
  },
  {
    "codigo": "316105",
    "descricao": "T�cnico em geof�sica"
  },
  {
    "codigo": "316110",
    "descricao": "T�cnico em geologia"
  },
  {
    "codigo": "316115",
    "descricao": "T�cnico em geoqu�mica"
  },
  {
    "codigo": "316120",
    "descricao": "T�cnico em geotecnia"
  },
  {
    "codigo": "316305",
    "descricao": "T�cnico de minera��o"
  },
  {
    "codigo": "316310",
    "descricao": "T�cnico de minera��o (�leo e petr�leo)"
  },
  {
    "codigo": "316315",
    "descricao": "T�cnico em processamento mineral (exceto petr�leo)"
  },
  {
    "codigo": "316320",
    "descricao": "T�cnico em pesquisa mineral"
  },
  {
    "codigo": "316325",
    "descricao": "T�cnico de produ��o em refino de petr�leo"
  },
  {
    "codigo": "316330",
    "descricao": "T�cnico em planejamento de lavra de minas"
  },
  {
    "codigo": "316335",
    "descricao": "Desincrustador (po�os de petr�leo)"
  },
  {
    "codigo": "316340",
    "descricao": "Cimentador (po�os de petr�leo)"
  },
  {
    "codigo": "317105",
    "descricao": "Desenvolvedor web (t�cnico)"
  },
  {
    "codigo": "317110",
    "descricao": "Desenvolvedor de sistemas de tecnologia da informa��o (t�cnico)"
  },
  {
    "codigo": "317115",
    "descricao": "Programador de m�quinas - ferramenta com comando num�rico"
  },
  {
    "codigo": "317120",
    "descricao": "Desenvolvedor de multim�dia"
  },
  {
    "codigo": "317205",
    "descricao": "Operador de computador"
  },
  {
    "codigo": "317210",
    "descricao": "T�cnico de suporte ao usu�rio de tecnologia da informa��o"
  },
  {
    "codigo": "318005",
    "descricao": "Desenhista t�cnico"
  },
  {
    "codigo": "318010",
    "descricao": "Desenhista copista"
  },
  {
    "codigo": "318015",
    "descricao": "Desenhista detalhista"
  },
  {
    "codigo": "318105",
    "descricao": "Desenhista t�cnico (arquitetura)"
  },
  {
    "codigo": "318110",
    "descricao": "Desenhista t�cnico (cartografia)"
  },
  {
    "codigo": "318115",
    "descricao": "Desenhista t�cnico (constru��o civil)"
  },
  {
    "codigo": "318120",
    "descricao": "Desenhista t�cnico (instala��es hidrossanit�rias)"
  },
  {
    "codigo": "318205",
    "descricao": "Desenhista t�cnico mec�nico"
  },
  {
    "codigo": "318210",
    "descricao": "Desenhista t�cnico aeron�utico"
  },
  {
    "codigo": "318215",
    "descricao": "Desenhista t�cnico naval"
  },
  {
    "codigo": "318305",
    "descricao": "Desenhista t�cnico (eletricidade e eletr�nica)"
  },
  {
    "codigo": "318310",
    "descricao": "Desenhista t�cnico (calefa��o, ventila��o e refrigera��o)"
  },
  {
    "codigo": "318405",
    "descricao": "Desenhista t�cnico (artes gr�ficas)"
  },
  {
    "codigo": "318410",
    "descricao": "Desenhista t�cnico (ilustra��es art�sticas)"
  },
  {
    "codigo": "318415",
    "descricao": "Desenhista t�cnico (ilustra��es t�cnicas)"
  },
  {
    "codigo": "318420",
    "descricao": "Desenhista t�cnico (ind�stria t�xtil)"
  },
  {
    "codigo": "318425",
    "descricao": "Desenhista t�cnico (mobili�rio)"
  },
  {
    "codigo": "318430",
    "descricao": "Desenhista t�cnico de embalagens, maquetes e leiautes"
  },
  {
    "codigo": "318505",
    "descricao": "Desenhista projetista de arquitetura"
  },
  {
    "codigo": "318510",
    "descricao": "Desenhista projetista de constru��o civil"
  },
  {
    "codigo": "318605",
    "descricao": "Desenhista projetista de m�quinas"
  },
  {
    "codigo": "318610",
    "descricao": "Desenhista projetista mec�nico"
  },
  {
    "codigo": "318705",
    "descricao": "Desenhista projetista de eletricidade"
  },
  {
    "codigo": "318710",
    "descricao": "Desenhista projetista eletr�nico"
  },
  {
    "codigo": "318805",
    "descricao": "Projetista de m�veis"
  },
  {
    "codigo": "318810",
    "descricao": "Modelista de roupas"
  },
  {
    "codigo": "318815",
    "descricao": "Modelista de cal�ados"
  },
  {
    "codigo": "319105",
    "descricao": "T�cnico em cal�ados e artefatos de couro"
  },
  {
    "codigo": "319110",
    "descricao": "T�cnico em confec��es do vestu�rio"
  },
  {
    "codigo": "319205",
    "descricao": "T�cnico do mobili�rio"
  },
  {
    "codigo": "320105",
    "descricao": "T�cnico em bioterismo"
  },
  {
    "codigo": "320110",
    "descricao": "T�cnico em histologia"
  },
  {
    "codigo": "321105",
    "descricao": "T�cnico agr�cola"
  },
  {
    "codigo": "321110",
    "descricao": "T�cnico agropecu�rio"
  },
  {
    "codigo": "321205",
    "descricao": "T�cnico em madeira"
  },
  {
    "codigo": "321210",
    "descricao": "T�cnico florestal"
  },
  {
    "codigo": "321305",
    "descricao": "T�cnico em piscicultura"
  },
  {
    "codigo": "321310",
    "descricao": "T�cnico em carcinicultura"
  },
  {
    "codigo": "321315",
    "descricao": "T�cnico em mitilicultura"
  },
  {
    "codigo": "321320",
    "descricao": "T�cnico em ranicultura"
  },
  {
    "codigo": "322105",
    "descricao": "T�cnico em acupuntura"
  },
  {
    "codigo": "322110",
    "descricao": "Pod�logo"
  },
  {
    "codigo": "322115",
    "descricao": "T�cnico em quiropraxia"
  },
  {
    "codigo": "322120",
    "descricao": "Massoterapeuta"
  },
  {
    "codigo": "322125",
    "descricao": "Terapeuta hol�stico"
  },
  {
    "codigo": "322130",
    "descricao": "Esteticista"
  },
  {
    "codigo": "322135",
    "descricao": "Doula"
  },
  {
    "codigo": "322140",
    "descricao": "Instrutor de pilates"
  },
  {
    "codigo": "322205",
    "descricao": "T�cnico de enfermagem"
  },
  {
    "codigo": "322210",
    "descricao": "T�cnico de enfermagem de terapia intensiva"
  },
  {
    "codigo": "322215",
    "descricao": "T�cnico de enfermagem do trabalho"
  },
  {
    "codigo": "322220",
    "descricao": "T�cnico de enfermagem psiqui�trica"
  },
  {
    "codigo": "322225",
    "descricao": "Instrumentador cir�rgico"
  },
  {
    "codigo": "322230",
    "descricao": "Auxiliar de enfermagem"
  },
  {
    "codigo": "322235",
    "descricao": "Auxiliar de enfermagem do trabalho"
  },
  {
    "codigo": "322240",
    "descricao": "Auxiliar de sa�de (navega��o mar�tima)"
  },
  {
    "codigo": "322245",
    "descricao": "T�cnico de enfermagem da estrat�gia de sa�de da fam�lia"
  },
  {
    "codigo": "322250",
    "descricao": "Auxiliar de enfermagem da estrat�gia de sa�de da fam�lia"
  },
  {
    "codigo": "322255",
    "descricao": "T�cnico em agente comunit�rio de sa�de"
  },
  {
    "codigo": "322305",
    "descricao": "T�cnico em �ptica e optometria"
  },
  {
    "codigo": "322405",
    "descricao": "T�cnico em sa�de bucal"
  },
  {
    "codigo": "322410",
    "descricao": "Prot�tico dent�rio"
  },
  {
    "codigo": "322415",
    "descricao": "Auxiliar em sa�de bucal"
  },
  {
    "codigo": "322420",
    "descricao": "Auxiliar de pr�tese dent�ria"
  },
  {
    "codigo": "322425",
    "descricao": "T�cnico em sa�de bucal da estrat�gia de sa�de da fam�lia"
  },
  {
    "codigo": "322430",
    "descricao": "Auxiliar em sa�de bucal da estrat�gia de sa�de da fam�lia"
  },
  {
    "codigo": "322505",
    "descricao": "T�cnico de ortopedia"
  },
  {
    "codigo": "322605",
    "descricao": "T�cnico de imobiliza��o ortop�dica"
  },
  {
    "codigo": "323105",
    "descricao": "T�cnico em pecu�ria"
  },
  {
    "codigo": "324105",
    "descricao": "T�cnico em m�todos eletrogr�ficos em encefalografia"
  },
  {
    "codigo": "324110",
    "descricao": "T�cnico em m�todos gr�ficos em cardiologia"
  },
  {
    "codigo": "324115",
    "descricao": "T�cnico em radiologia e imagenologia"
  },
  {
    "codigo": "324120",
    "descricao": "Tecn�logo em radiologia"
  },
  {
    "codigo": "324125",
    "descricao": "Tecn�logo oft�lmico"
  },
  {
    "codigo": "324130",
    "descricao": "T�cnico em espirometria"
  },
  {
    "codigo": "324135",
    "descricao": "T�cnico em polissonografia"
  },
  {
    "codigo": "324140",
    "descricao": "Dosimetrista cl�nico"
  },
  {
    "codigo": "324205",
    "descricao": "T�cnico em patologia cl�nica"
  },
  {
    "codigo": "324215",
    "descricao": "Citot�cnico"
  },
  {
    "codigo": "324220",
    "descricao": "T�cnico em hemoterapia"
  },
  {
    "codigo": "325005",
    "descricao": "En�logo"
  },
  {
    "codigo": "325010",
    "descricao": "Aromista"
  },
  {
    "codigo": "325015",
    "descricao": "Perfumista"
  },
  {
    "codigo": "325105",
    "descricao": "Auxiliar t�cnico em laborat�rio de farm�cia"
  },
  {
    "codigo": "325110",
    "descricao": "T�cnico em laborat�rio de farm�cia"
  },
  {
    "codigo": "325115",
    "descricao": "T�cnico em farm�cia"
  },
  {
    "codigo": "325205",
    "descricao": "T�cnico de alimentos"
  },
  {
    "codigo": "325210",
    "descricao": "T�cnico em nutri��o e diet�tica"
  },
  {
    "codigo": "325305",
    "descricao": "T�cnico em biotecnologia"
  },
  {
    "codigo": "325310",
    "descricao": "T�cnico em imunobiol�gicos"
  },
  {
    "codigo": "328105",
    "descricao": "Embalsamador"
  },
  {
    "codigo": "328110",
    "descricao": "Taxidermista"
  },
  {
    "codigo": "331105",
    "descricao": "Professor de n�vel m�dio na educa��o infantil"
  },
  {
    "codigo": "331110",
    "descricao": "Auxiliar de desenvolvimento infantil"
  },
  {
    "codigo": "331205",
    "descricao": "Professor de n�vel m�dio no ensino fundamental"
  },
  {
    "codigo": "331305",
    "descricao": "Professor de n�vel m�dio no ensino profissionalizante"
  },
  {
    "codigo": "332105",
    "descricao": "Professor leigo no ensino fundamental"
  },
  {
    "codigo": "332205",
    "descricao": "Professor pr�tico no ensino profissionalizante"
  },
  {
    "codigo": "333105",
    "descricao": "Instrutor de auto-escola"
  },
  {
    "codigo": "333110",
    "descricao": "Instrutor de cursos livres"
  },
  {
    "codigo": "333115",
    "descricao": "Professores de cursos livres"
  },
  {
    "codigo": "334105",
    "descricao": "Inspetor de alunos de escola privada"
  },
  {
    "codigo": "334110",
    "descricao": "Inspetor de alunos de escola p�blica"
  },
  {
    "codigo": "334115",
    "descricao": "Monitor de transporte escolar"
  },
  {
    "codigo": "341105",
    "descricao": "Piloto comercial (exceto linhas a�reas)"
  },
  {
    "codigo": "341110",
    "descricao": "Piloto comercial de helic�ptero (exceto linhas a�reas)"
  },
  {
    "codigo": "341115",
    "descricao": "Mec�nico de v�o"
  },
  {
    "codigo": "341120",
    "descricao": "Piloto agr�cola"
  },
  {
    "codigo": "341205",
    "descricao": "Contramestre de cabotagem"
  },
  {
    "codigo": "341210",
    "descricao": "Mestre de cabotagem"
  },
  {
    "codigo": "341215",
    "descricao": "Mestre fluvial"
  },
  {
    "codigo": "341220",
    "descricao": "Patr�o de pesca de alto-mar"
  },
  {
    "codigo": "341225",
    "descricao": "Patr�o de pesca na navega��o interior"
  },
  {
    "codigo": "341230",
    "descricao": "Piloto fluvial"
  },
  {
    "codigo": "341235",
    "descricao": "T�cnico em sinaliza��o n�utica"
  },
  {
    "codigo": "341240",
    "descricao": "T�cnicos em manobras em equipamentos de conv�s"
  },
  {
    "codigo": "341245",
    "descricao": "T�cnico em sinais navais"
  },
  {
    "codigo": "341250",
    "descricao": "Auxiliar t�cnico de sinaliza��o nautica"
  },
  {
    "codigo": "341305",
    "descricao": "Condutor maquinista motorista fluvial"
  },
  {
    "codigo": "341310",
    "descricao": "Condutor de m�quinas"
  },
  {
    "codigo": "341315",
    "descricao": "Eletricista de bordo"
  },
  {
    "codigo": "341320",
    "descricao": "Condutor de m�quinas (bombeador)"
  },
  {
    "codigo": "341325",
    "descricao": "Condutor de m�quinas (mec�nico)"
  },
  {
    "codigo": "342105",
    "descricao": "Analista de transporte em com�rcio exterior"
  },
  {
    "codigo": "342110",
    "descricao": "Operador de transporte multimodal"
  },
  {
    "codigo": "342115",
    "descricao": "Controlador de servi�os de m�quinas e ve�culos"
  },
  {
    "codigo": "342120",
    "descricao": "Afretador"
  },
  {
    "codigo": "342125",
    "descricao": "Tecn�logo em log�stica de transporte"
  },
  {
    "codigo": "342205",
    "descricao": "Ajudante de despachante aduaneiro"
  },
  {
    "codigo": "342210",
    "descricao": "Despachante aduaneiro"
  },
  {
    "codigo": "342215",
    "descricao": "Analista de desembara�o aduaneiro"
  },
  {
    "codigo": "342305",
    "descricao": "Chefe de servi�o de transporte rodovi�rio (passageiros e cargas)"
  },
  {
    "codigo": "342310",
    "descricao": "Inspetor de servi�os de transportes rodovi�rios (passageiros e cargas)"
  },
  {
    "codigo": "342315",
    "descricao": "Supervisor de carga e descarga"
  },
  {
    "codigo": "342405",
    "descricao": "Agente de esta��o (ferrovia e metr�)"
  },
  {
    "codigo": "342410",
    "descricao": "Operador de centro de controle (ferrovia e metr�)"
  },
  {
    "codigo": "342505",
    "descricao": "Controlador de tr�fego a�reo"
  },
  {
    "codigo": "342510",
    "descricao": "Despachante operacional de v�o"
  },
  {
    "codigo": "342515",
    "descricao": "Fiscal de avia��o civil (fac)"
  },
  {
    "codigo": "342530",
    "descricao": "Inspetor de avia��o civil"
  },
  {
    "codigo": "342535",
    "descricao": "Operador de atendimento aerovi�rio"
  },
  {
    "codigo": "342540",
    "descricao": "Supervisor da administra��o de aeroportos"
  },
  {
    "codigo": "342545",
    "descricao": "Supervisor de empresa a�rea em aeroportos"
  },
  {
    "codigo": "342550",
    "descricao": "Agente de prote��o de avia��o civil"
  },
  {
    "codigo": "342555",
    "descricao": "Fiscal de pista de aeroporto"
  },
  {
    "codigo": "342560",
    "descricao": "Operador de rampa ( transporte a�reo)"
  },
  {
    "codigo": "342605",
    "descricao": "Chefe de esta��o portu�ria"
  },
  {
    "codigo": "342610",
    "descricao": "Supervisor de opera��es portu�rias"
  },
  {
    "codigo": "351105",
    "descricao": "T�cnico de contabilidade"
  },
  {
    "codigo": "351110",
    "descricao": "Chefe de contabilidade (t�cnico)"
  },
  {
    "codigo": "351115",
    "descricao": "Consultor cont�bil (t�cnico)"
  },
  {
    "codigo": "351305",
    "descricao": "T�cnico em administra��o"
  },
  {
    "codigo": "351310",
    "descricao": "T�cnico em administra��o de com�rcio exterior"
  },
  {
    "codigo": "351315",
    "descricao": "Agente de recrutamento e sele��o"
  },
  {
    "codigo": "351405",
    "descricao": "Escrevente"
  },
  {
    "codigo": "351410",
    "descricao": "Escriv�o judicial"
  },
  {
    "codigo": "351415",
    "descricao": "Escriv�o extra - judicial"
  },
  {
    "codigo": "351420",
    "descricao": "Escriv�o de pol�cia"
  },
  {
    "codigo": "351425",
    "descricao": "Oficial de justi�a"
  },
  {
    "codigo": "351430",
    "descricao": "Auxiliar de servi�os jur�dicos"
  },
  {
    "codigo": "351435",
    "descricao": "Mediador de conflitos"
  },
  {
    "codigo": "351440",
    "descricao": "�rbitro extrajudicial"
  },
  {
    "codigo": "351505",
    "descricao": "T�cnico em secretariado"
  },
  {
    "codigo": "351510",
    "descricao": "Taqu�grafo"
  },
  {
    "codigo": "351515",
    "descricao": "Estenotipista"
  },
  {
    "codigo": "351605",
    "descricao": "T�cnico em seguran�a do trabalho"
  },
  {
    "codigo": "351610",
    "descricao": "T�cnico em higiene ocupacional"
  },
  {
    "codigo": "351705",
    "descricao": "Analista de seguros (t�cnico)"
  },
  {
    "codigo": "351710",
    "descricao": "Analista de sinistros"
  },
  {
    "codigo": "351715",
    "descricao": "Assistente comercial de seguros"
  },
  {
    "codigo": "351720",
    "descricao": "Assistente t�cnico de seguros"
  },
  {
    "codigo": "351725",
    "descricao": "Inspetor de risco"
  },
  {
    "codigo": "351730",
    "descricao": "Inspetor de sinistros"
  },
  {
    "codigo": "351735",
    "descricao": "T�cnico de resseguros"
  },
  {
    "codigo": "351740",
    "descricao": "T�cnico de seguros"
  },
  {
    "codigo": "351805",
    "descricao": "Detetive profissional"
  },
  {
    "codigo": "351810",
    "descricao": "Investigador de pol�cia"
  },
  {
    "codigo": "351815",
    "descricao": "Papiloscopista policial"
  },
  {
    "codigo": "351905",
    "descricao": "Agente de intelig�ncia"
  },
  {
    "codigo": "351910",
    "descricao": "Agente t�cnico de intelig�ncia"
  },
  {
    "codigo": "352205",
    "descricao": "Agente de defesa ambiental"
  },
  {
    "codigo": "352210",
    "descricao": "Agente de sa�de p�blica"
  },
  {
    "codigo": "352305",
    "descricao": "Metrologista"
  },
  {
    "codigo": "352310",
    "descricao": "Agente fiscal de qualidade"
  },
  {
    "codigo": "352315",
    "descricao": "Agente fiscal metrol�gico"
  },
  {
    "codigo": "352320",
    "descricao": "Agente fiscal t�xtil"
  },
  {
    "codigo": "352405",
    "descricao": "Agente de direitos autorais"
  },
  {
    "codigo": "352410",
    "descricao": "Avaliador de produtos dos meios de comunica��o"
  },
  {
    "codigo": "352420",
    "descricao": "T�cnico em direitos autorais"
  },
  {
    "codigo": "353205",
    "descricao": "T�cnico de opera��es e servi�os banc�rios - c�mbio"
  },
  {
    "codigo": "353210",
    "descricao": "T�cnico de opera��es e servi�os banc�rios - cr�dito imobili�rio"
  },
  {
    "codigo": "353215",
    "descricao": "T�cnico de opera��es e servi�os banc�rios - cr�dito rural"
  },
  {
    "codigo": "353220",
    "descricao": "T�cnico de opera��es e servi�os banc�rios - leasing"
  },
  {
    "codigo": "353225",
    "descricao": "T�cnico de opera��es e servi�os banc�rios - renda fixa e vari�vel"
  },
  {
    "codigo": "353230",
    "descricao": "Tesoureiro de banco"
  },
  {
    "codigo": "353235",
    "descricao": "Chefe de servi�os banc�rios"
  },
  {
    "codigo": "354120",
    "descricao": "Agente de vendas de servi�os"
  },
  {
    "codigo": "354125",
    "descricao": "Assistente de vendas"
  },
  {
    "codigo": "354130",
    "descricao": "Promotor de vendas especializado"
  },
  {
    "codigo": "354135",
    "descricao": "T�cnico de vendas"
  },
  {
    "codigo": "354140",
    "descricao": "T�cnico em atendimento e vendas"
  },
  {
    "codigo": "354145",
    "descricao": "Vendedor pracista"
  },
  {
    "codigo": "354150",
    "descricao": "Propagandista de produtos famac�uticos"
  },
  {
    "codigo": "354205",
    "descricao": "Comprador"
  },
  {
    "codigo": "354210",
    "descricao": "Supervisor de compras"
  },
  {
    "codigo": "354305",
    "descricao": "Analista de exporta��o e importa��o"
  },
  {
    "codigo": "354405",
    "descricao": "Leiloeiro"
  },
  {
    "codigo": "354410",
    "descricao": "Avaliador de im�veis"
  },
  {
    "codigo": "354415",
    "descricao": "Avaliador de bens m�veis"
  },
  {
    "codigo": "354505",
    "descricao": "Corretor de seguros"
  },
  {
    "codigo": "354605",
    "descricao": "Corretor de im�veis"
  },
  {
    "codigo": "354610",
    "descricao": "Corretor de gr�os"
  },
  {
    "codigo": "354705",
    "descricao": "Representante comercial aut�nomo"
  },
  {
    "codigo": "354805",
    "descricao": "T�cnico em turismo"
  },
  {
    "codigo": "354810",
    "descricao": "Operador de turismo"
  },
  {
    "codigo": "354815",
    "descricao": "Agente de viagem"
  },
  {
    "codigo": "354820",
    "descricao": "Organizador de evento"
  },
  {
    "codigo": "354825",
    "descricao": "Cerimonialista"
  },
  {
    "codigo": "371105",
    "descricao": "Auxiliar de biblioteca"
  },
  {
    "codigo": "371110",
    "descricao": "T�cnico em biblioteconomia"
  },
  {
    "codigo": "371205",
    "descricao": "Colecionador de selos e moedas"
  },
  {
    "codigo": "371210",
    "descricao": "T�cnico em museologia"
  },
  {
    "codigo": "371305",
    "descricao": "T�cnico em programa��o visual"
  },
  {
    "codigo": "371310",
    "descricao": "T�cnico gr�fico"
  },
  {
    "codigo": "371405",
    "descricao": "Recreador de acantonamento"
  },
  {
    "codigo": "371410",
    "descricao": "Recreador"
  },
  {
    "codigo": "372105",
    "descricao": "Diretor de fotografia"
  },
  {
    "codigo": "372110",
    "descricao": "Iluminador (televis�o)"
  },
  {
    "codigo": "372115",
    "descricao": "Operador de c�mera de televis�o"
  },
  {
    "codigo": "372205",
    "descricao": "Operador de rede de teleprocessamento"
  },
  {
    "codigo": "372210",
    "descricao": "Radiotelegrafista"
  },
  {
    "codigo": "373105",
    "descricao": "Operador de m�dia audiovisual"
  },
  {
    "codigo": "373130",
    "descricao": "T�cnico de sistemas audiovisuais"
  },
  {
    "codigo": "373135",
    "descricao": "Operador de controle mestre"
  },
  {
    "codigo": "373140",
    "descricao": "Coordenador de programa��o"
  },
  {
    "codigo": "373145",
    "descricao": "Assistente de opera��es audiovisuais"
  },
  {
    "codigo": "373220",
    "descricao": "Supervisor t�cnico operacional de sistemas de televis�o e produtoras de v�deo"
  },
  {
    "codigo": "373225",
    "descricao": "Supervisor de opera��es (m�dias audiovisuais)"
  },
  {
    "codigo": "373230",
    "descricao": "Supervisor t�cnico (m�dias audiovisuais)"
  },
  {
    "codigo": "374105",
    "descricao": "T�cnico em grava��o de �udio"
  },
  {
    "codigo": "374110",
    "descricao": "T�cnico em instala��o de equipamentos de �udio"
  },
  {
    "codigo": "374115",
    "descricao": "T�cnico em masteriza��o de �udio"
  },
  {
    "codigo": "374120",
    "descricao": "Projetista de som"
  },
  {
    "codigo": "374125",
    "descricao": "T�cnico em sonoriza��o"
  },
  {
    "codigo": "374130",
    "descricao": "T�cnico em mixagem de �udio"
  },
  {
    "codigo": "374135",
    "descricao": "Projetista de sistemas de �udio"
  },
  {
    "codigo": "374140",
    "descricao": "Microfonista"
  },
  {
    "codigo": "374145",
    "descricao": "Dj (disc jockey)"
  },
  {
    "codigo": "374150",
    "descricao": "Sonoplasta"
  },
  {
    "codigo": "374155",
    "descricao": "Analista musical"
  },
  {
    "codigo": "374205",
    "descricao": "Cenot�cnico (cinema, v�deo, televis�o, teatro e espet�culos)"
  },
  {
    "codigo": "374210",
    "descricao": "Maquinista de cinema e v�deo"
  },
  {
    "codigo": "374215",
    "descricao": "Maquinista de teatro e espet�culos"
  },
  {
    "codigo": "374305",
    "descricao": "Operador de projetor cinematogr�fico"
  },
  {
    "codigo": "374310",
    "descricao": "Operador-mantenedor de projetor cinematogr�fico"
  },
  {
    "codigo": "374405",
    "descricao": "Editor de m�dia audiovisual"
  },
  {
    "codigo": "374410",
    "descricao": "Finalizador de filmes"
  },
  {
    "codigo": "374415",
    "descricao": "Finalizador de v�deo"
  },
  {
    "codigo": "374420",
    "descricao": "Montador de filmes"
  },
  {
    "codigo": "374425",
    "descricao": "Diretor de imagens (tv)"
  },
  {
    "codigo": "375105",
    "descricao": "Designer de interiores"
  },
  {
    "codigo": "375110",
    "descricao": "Designer de vitrines"
  },
  {
    "codigo": "375115",
    "descricao": "Visual merchandiser"
  },
  {
    "codigo": "375120",
    "descricao": "Decorador de eventos"
  },
  {
    "codigo": "375125",
    "descricao": "Produtor de moda"
  },
  {
    "codigo": "375130",
    "descricao": "Profissional de organiza��o (personal organizer)"
  },
  {
    "codigo": "376105",
    "descricao": "Dan�arino tradicional"
  },
  {
    "codigo": "376110",
    "descricao": "Dan�arino popular"
  },
  {
    "codigo": "376205",
    "descricao": "Acrobata"
  },
  {
    "codigo": "376210",
    "descricao": "Artista a�reo"
  },
  {
    "codigo": "376215",
    "descricao": "Artista de circo (outros)"
  },
  {
    "codigo": "376220",
    "descricao": "Contorcionista"
  },
  {
    "codigo": "376225",
    "descricao": "Domador de animais (circense)"
  },
  {
    "codigo": "376230",
    "descricao": "Equilibrista"
  },
  {
    "codigo": "376235",
    "descricao": "M�gico"
  },
  {
    "codigo": "376240",
    "descricao": "Malabarista"
  },
  {
    "codigo": "376245",
    "descricao": "Palha�o"
  },
  {
    "codigo": "376250",
    "descricao": "Titeriteiro"
  },
  {
    "codigo": "376255",
    "descricao": "Trapezista"
  },
  {
    "codigo": "376305",
    "descricao": "Apresentador de eventos"
  },
  {
    "codigo": "376310",
    "descricao": "Apresentador de festas populares"
  },
  {
    "codigo": "376315",
    "descricao": "Apresentador de programas de r�dio"
  },
  {
    "codigo": "376320",
    "descricao": "Apresentador de programas de televis�o"
  },
  {
    "codigo": "376325",
    "descricao": "Apresentador de circo"
  },
  {
    "codigo": "376330",
    "descricao": "Mestre de cerimonias"
  },
  {
    "codigo": "376405",
    "descricao": "Modelo art�stico"
  },
  {
    "codigo": "376410",
    "descricao": "Modelo de modas"
  },
  {
    "codigo": "376415",
    "descricao": "Modelo publicit�rio"
  },
  {
    "codigo": "377105",
    "descricao": "Atleta profissional (outras modalidades)"
  },
  {
    "codigo": "377110",
    "descricao": "Atleta profissional de futebol"
  },
  {
    "codigo": "377115",
    "descricao": "Atleta profissional de golfe"
  },
  {
    "codigo": "377120",
    "descricao": "Atleta profissional de luta"
  },
  {
    "codigo": "377125",
    "descricao": "Atleta profissional de t�nis"
  },
  {
    "codigo": "377130",
    "descricao": "J�quei"
  },
  {
    "codigo": "377135",
    "descricao": "Piloto de competi��o automobil�stica"
  },
  {
    "codigo": "377140",
    "descricao": "Profissional de atletismo"
  },
  {
    "codigo": "377145",
    "descricao": "Pugilista"
  },
  {
    "codigo": "377205",
    "descricao": "�rbitro desportivo"
  },
  {
    "codigo": "377210",
    "descricao": "�rbitro de atletismo"
  },
  {
    "codigo": "377215",
    "descricao": "�rbitro de basquete"
  },
  {
    "codigo": "377220",
    "descricao": "�rbitro de futebol"
  },
  {
    "codigo": "377225",
    "descricao": "�rbitro de futebol de sal�o"
  },
  {
    "codigo": "377230",
    "descricao": "�rbitro de jud�"
  },
  {
    "codigo": "377235",
    "descricao": "�rbitro de karat�"
  },
  {
    "codigo": "377240",
    "descricao": "�rbitro de pol� aqu�tico"
  },
  {
    "codigo": "377245",
    "descricao": "�rbitro de v�lei"
  },
  {
    "codigo": "391105",
    "descricao": "Cronoanalista"
  },
  {
    "codigo": "391110",
    "descricao": "Cronometrista"
  },
  {
    "codigo": "391115",
    "descricao": "Controlador de entrada e sa�da"
  },
  {
    "codigo": "391120",
    "descricao": "Planejista"
  },
  {
    "codigo": "391125",
    "descricao": "T�cnico de planejamento de produ��o"
  },
  {
    "codigo": "391130",
    "descricao": "T�cnico de planejamento e programa��o da manuten��o"
  },
  {
    "codigo": "391135",
    "descricao": "T�cnico de mat�ria-prima e material"
  },
  {
    "codigo": "391140",
    "descricao": "Analista de manuten��o (equipamentos a�reos)"
  },
  {
    "codigo": "391145",
    "descricao": "Analista de planejamento de manuten��o"
  },
  {
    "codigo": "391205",
    "descricao": "Inspetor de qualidade"
  },
  {
    "codigo": "391210",
    "descricao": "T�cnico de garantia da qualidade"
  },
  {
    "codigo": "391215",
    "descricao": "Operador de inspe��o de qualidade"
  },
  {
    "codigo": "391220",
    "descricao": "T�cnico de painel de controle"
  },
  {
    "codigo": "391225",
    "descricao": "Escolhedor de papel"
  },
  {
    "codigo": "391230",
    "descricao": "T�cnico operacional de servi�os de correios"
  },
  {
    "codigo": "395105",
    "descricao": "T�cnico de apoio em pesquisa e desenvolvimento (exceto agropecu�rio e florestal)"
  },
  {
    "codigo": "395110",
    "descricao": "T�cnico de apoio em pesquisa e desenvolvimento agropecu�rio florestal"
  },
  {
    "codigo": "410105",
    "descricao": "Supervisor administrativo"
  },
  {
    "codigo": "410205",
    "descricao": "Supervisor de almoxarifado"
  },
  {
    "codigo": "410210",
    "descricao": "Supervisor de c�mbio"
  },
  {
    "codigo": "410215",
    "descricao": "Supervisor de contas a pagar"
  },
  {
    "codigo": "410220",
    "descricao": "Supervisor de controle patrimonial"
  },
  {
    "codigo": "410225",
    "descricao": "Supervisor de cr�dito e cobran�a"
  },
  {
    "codigo": "410230",
    "descricao": "Supervisor de or�amento"
  },
  {
    "codigo": "410235",
    "descricao": "Supervisor de tesouraria"
  },
  {
    "codigo": "410240",
    "descricao": "Supervisor de log�stica"
  },
  {
    "codigo": "411005",
    "descricao": "Auxiliar de escrit�rio"
  },
  {
    "codigo": "411010",
    "descricao": "Assistente administrativo"
  },
  {
    "codigo": "411015",
    "descricao": "Atendente de judici�rio"
  },
  {
    "codigo": "411020",
    "descricao": "Auxiliar de judici�rio"
  },
  {
    "codigo": "411025",
    "descricao": "Auxiliar de cart�rio"
  },
  {
    "codigo": "411030",
    "descricao": "Auxiliar de pessoal"
  },
  {
    "codigo": "411035",
    "descricao": "Auxiliar de estat�stica"
  },
  {
    "codigo": "411040",
    "descricao": "Auxiliar de seguros"
  },
  {
    "codigo": "411045",
    "descricao": "Auxiliar de servi�os de importa��o e exporta��o"
  },
  {
    "codigo": "411050",
    "descricao": "Agente de microcr�dito"
  },
  {
    "codigo": "411055",
    "descricao": "Captador de recursos"
  },
  {
    "codigo": "412105",
    "descricao": "Datil�grafo"
  },
  {
    "codigo": "412110",
    "descricao": "Digitador"
  },
  {
    "codigo": "412115",
    "descricao": "Operador de mensagens de telecomunica��es (correios)"
  },
  {
    "codigo": "412120",
    "descricao": "Supervisor de digita��o e opera��o"
  },
  {
    "codigo": "412205",
    "descricao": "Cont�nuo"
  },
  {
    "codigo": "413105",
    "descricao": "Analista de folha de pagamento"
  },
  {
    "codigo": "413110",
    "descricao": "Auxiliar de contabilidade"
  },
  {
    "codigo": "413115",
    "descricao": "Auxiliar de faturamento"
  },
  {
    "codigo": "413205",
    "descricao": "Atendente de ag�ncia"
  },
  {
    "codigo": "413210",
    "descricao": "Caixa de banco"
  },
  {
    "codigo": "413215",
    "descricao": "Compensador de banco"
  },
  {
    "codigo": "413220",
    "descricao": "Conferente de servi�os banc�rios"
  },
  {
    "codigo": "413225",
    "descricao": "Escritur�rio de banco"
  },
  {
    "codigo": "413230",
    "descricao": "Operador de cobran�a banc�ria"
  },
  {
    "codigo": "414105",
    "descricao": "Almoxarife"
  },
  {
    "codigo": "414110",
    "descricao": "Armazenista"
  },
  {
    "codigo": "414115",
    "descricao": "Balanceiro"
  },
  {
    "codigo": "414120",
    "descricao": "Conferente mercadoria (exceto carga e descarga)"
  },
  {
    "codigo": "414125",
    "descricao": "Estoquista"
  },
  {
    "codigo": "414135",
    "descricao": "Expedidor de mercadorias"
  },
  {
    "codigo": "414140",
    "descricao": "Auxiliar de logistica"
  },
  {
    "codigo": "414205",
    "descricao": "Apontador de m�o-de-obra"
  },
  {
    "codigo": "414210",
    "descricao": "Apontador de produ��o"
  },
  {
    "codigo": "414215",
    "descricao": "Conferente de carga e descarga"
  },
  {
    "codigo": "415105",
    "descricao": "Arquivista de documentos"
  },
  {
    "codigo": "415115",
    "descricao": "Codificador de dados"
  },
  {
    "codigo": "415120",
    "descricao": "Fitotec�rio"
  },
  {
    "codigo": "415125",
    "descricao": "Kardexista"
  },
  {
    "codigo": "415130",
    "descricao": "Operador de m�quina copiadora (exceto operador de gr�fica r�pida)"
  },
  {
    "codigo": "415205",
    "descricao": "Carteiro"
  },
  {
    "codigo": "415210",
    "descricao": "Operador de triagem e transbordo"
  },
  {
    "codigo": "415215",
    "descricao": "Entregador de publica��es"
  },
  {
    "codigo": "415305",
    "descricao": "Registrador de c�ncer"
  },
  {
    "codigo": "415310",
    "descricao": "Analista de informa��o em sa�de"
  },
  {
    "codigo": "420105",
    "descricao": "Supervisor de caixas e bilheteiros (exceto caixa de banco)"
  },
  {
    "codigo": "420110",
    "descricao": "Supervisor de cobran�a"
  },
  {
    "codigo": "420115",
    "descricao": "Supervisor de coletadores de apostas e de jogos"
  },
  {
    "codigo": "420120",
    "descricao": "Supervisor de entrevistadores e recenseadores"
  },
  {
    "codigo": "420125",
    "descricao": "Supervisor de recepcionistas"
  },
  {
    "codigo": "420130",
    "descricao": "Supervisor de telefonistas"
  },
  {
    "codigo": "420135",
    "descricao": "Supervisor de telemarketing e atendimento"
  },
  {
    "codigo": "421105",
    "descricao": "Atendente comercial (ag�ncia postal)"
  },
  {
    "codigo": "421110",
    "descricao": "Bilheteiro de transportes coletivos"
  },
  {
    "codigo": "421115",
    "descricao": "Bilheteiro no servi�o de divers�es"
  },
  {
    "codigo": "421120",
    "descricao": "Emissor de passagens"
  },
  {
    "codigo": "421125",
    "descricao": "Operador de caixa"
  },
  {
    "codigo": "421205",
    "descricao": "Recebedor de apostas (loteria)"
  },
  {
    "codigo": "421210",
    "descricao": "Recebedor de apostas (turfe)"
  },
  {
    "codigo": "421305",
    "descricao": "Cobrador externo"
  },
  {
    "codigo": "421310",
    "descricao": "Cobrador interno"
  },
  {
    "codigo": "421315",
    "descricao": "Localizador (cobrador)"
  },
  {
    "codigo": "422105",
    "descricao": "Recepcionista, em geral"
  },
  {
    "codigo": "422110",
    "descricao": "Recepcionista de consult�rio m�dico ou dent�rio"
  },
  {
    "codigo": "422115",
    "descricao": "Recepcionista de seguro sa�de"
  },
  {
    "codigo": "422120",
    "descricao": "Recepcionista de hotel"
  },
  {
    "codigo": "422125",
    "descricao": "Recepcionista de banco"
  },
  {
    "codigo": "422130",
    "descricao": "Concierge"
  },
  {
    "codigo": "422205",
    "descricao": "Telefonista"
  },
  {
    "codigo": "422210",
    "descricao": "Teleoperador"
  },
  {
    "codigo": "422220",
    "descricao": "Operador de r�dio-chamada"
  },
  {
    "codigo": "422305",
    "descricao": "Operador de telemarketing ativo"
  },
  {
    "codigo": "422310",
    "descricao": "Operador de telemarketing ativo e receptivo"
  },
  {
    "codigo": "422315",
    "descricao": "Operador de telemarketing receptivo"
  },
  {
    "codigo": "422320",
    "descricao": "Operador de telemarketing t�cnico"
  },
  {
    "codigo": "422330",
    "descricao": "Teleatendente de emerg�ncia"
  },
  {
    "codigo": "422335",
    "descricao": "Monitor de teleatendimento"
  },
  {
    "codigo": "423105",
    "descricao": "Despachante documentalista"
  },
  {
    "codigo": "423110",
    "descricao": "Despachante de tr�nsito"
  },
  {
    "codigo": "423115",
    "descricao": "Vistoriador veicular"
  },
  {
    "codigo": "424105",
    "descricao": "Entrevistador censit�rio e de pesquisas amostrais"
  },
  {
    "codigo": "424110",
    "descricao": "Entrevistador de pesquisa de opini�o e m�dia"
  },
  {
    "codigo": "424115",
    "descricao": "Entrevistador de pesquisas de mercado"
  },
  {
    "codigo": "424120",
    "descricao": "Entrevistador de pre�os"
  },
  {
    "codigo": "424125",
    "descricao": "Escritur�rio  em  estat�stica"
  },
  {
    "codigo": "424130",
    "descricao": "Entrevistador social"
  },
  {
    "codigo": "424205",
    "descricao": "Coordenador de provas (concurso, avalia��o, exame)"
  },
  {
    "codigo": "424210",
    "descricao": "Aplicador de provas (concurso, avalia��o,exame)"
  },
  {
    "codigo": "510105",
    "descricao": "Supervisor de transportes"
  },
  {
    "codigo": "510110",
    "descricao": "Administrador de edif�cios"
  },
  {
    "codigo": "510115",
    "descricao": "Supervisor de andar"
  },
  {
    "codigo": "510120",
    "descricao": "Chefe de portaria de hotel"
  },
  {
    "codigo": "510130",
    "descricao": "Chefe de bar"
  },
  {
    "codigo": "510135",
    "descricao": "Ma�tre"
  },
  {
    "codigo": "510205",
    "descricao": "Supervisor de lavanderia"
  },
  {
    "codigo": "510305",
    "descricao": "Supervisor de bombeiros"
  },
  {
    "codigo": "510310",
    "descricao": "Supervisor de vigilantes"
  },
  {
    "codigo": "511105",
    "descricao": "Comiss�rio de v�o"
  },
  {
    "codigo": "511110",
    "descricao": "Comiss�rio de trem"
  },
  {
    "codigo": "511115",
    "descricao": "Taifeiro (exceto militares)"
  },
  {
    "codigo": "511205",
    "descricao": "Fiscal de transportes coletivos (exceto trem)"
  },
  {
    "codigo": "511210",
    "descricao": "Despachante de transportes coletivos (exceto trem)"
  },
  {
    "codigo": "511215",
    "descricao": "Cobrador de transportes coletivos (exceto trem)"
  },
  {
    "codigo": "511220",
    "descricao": "Bilheteiro (esta��es de metr�, ferrovi�rias e assemelhadas)"
  },
  {
    "codigo": "511405",
    "descricao": "Guia de turismo"
  },
  {
    "codigo": "511505",
    "descricao": "Condutor de turismo de aventura"
  },
  {
    "codigo": "511510",
    "descricao": "Condutor de turismo de pesca"
  },
  {
    "codigo": "511515",
    "descricao": "Condutor turismo n�utico"
  },
  {
    "codigo": "512105",
    "descricao": "Empregado  dom�stico  nos servi�os gerais"
  },
  {
    "codigo": "512110",
    "descricao": "Empregado dom�stico  arrumador"
  },
  {
    "codigo": "512115",
    "descricao": "Empregado dom�stico  faxineiro"
  },
  {
    "codigo": "512120",
    "descricao": "Empregado dom�stico diarista"
  },
  {
    "codigo": "513105",
    "descricao": "Mordomo de resid�ncia"
  },
  {
    "codigo": "513110",
    "descricao": "Mordomo de hotelaria"
  },
  {
    "codigo": "513115",
    "descricao": "Governanta de hotelaria"
  },
  {
    "codigo": "513205",
    "descricao": "Cozinheiro geral"
  },
  {
    "codigo": "513210",
    "descricao": "Cozinheiro do servi�o dom�stico"
  },
  {
    "codigo": "513215",
    "descricao": "Cozinheiro industrial"
  },
  {
    "codigo": "513220",
    "descricao": "Cozinheiro de hospital"
  },
  {
    "codigo": "513225",
    "descricao": "Cozinheiro de embarca��es"
  },
  {
    "codigo": "513305",
    "descricao": "Camareiro de teatro"
  },
  {
    "codigo": "513310",
    "descricao": "Camareiro de televis�o"
  },
  {
    "codigo": "513315",
    "descricao": "Camareiro  de hotel"
  },
  {
    "codigo": "513320",
    "descricao": "Camareiro de embarca��es"
  },
  {
    "codigo": "513325",
    "descricao": "Guarda-roupeiro de cinema"
  },
  {
    "codigo": "513405",
    "descricao": "Gar�om"
  },
  {
    "codigo": "513410",
    "descricao": "Sommelier"
  },
  {
    "codigo": "513415",
    "descricao": "Cumim"
  },
  {
    "codigo": "513420",
    "descricao": "Barman"
  },
  {
    "codigo": "513425",
    "descricao": "Copeiro"
  },
  {
    "codigo": "513430",
    "descricao": "Copeiro de hospital"
  },
  {
    "codigo": "513435",
    "descricao": "Atendente de lanchonete"
  },
  {
    "codigo": "513440",
    "descricao": "Barista"
  },
  {
    "codigo": "513505",
    "descricao": "Auxiliar nos servi�os de alimenta��o"
  },
  {
    "codigo": "513605",
    "descricao": "Churrasqueiro"
  },
  {
    "codigo": "513610",
    "descricao": "Pizzaiolo"
  },
  {
    "codigo": "513615",
    "descricao": "Sushiman"
  },
  {
    "codigo": "514105",
    "descricao": "Ascensorista"
  },
  {
    "codigo": "514110",
    "descricao": "Garagista"
  },
  {
    "codigo": "514115",
    "descricao": "Sacrist�o"
  },
  {
    "codigo": "514120",
    "descricao": "Zelador de edif�cio"
  },
  {
    "codigo": "514205",
    "descricao": "Coletor de lixo domiciliar"
  },
  {
    "codigo": "514215",
    "descricao": "Varredor de rua"
  },
  {
    "codigo": "514225",
    "descricao": "Trabalhador de servi�os de limpeza e conserva��o de �reas p�blicas"
  },
  {
    "codigo": "514230",
    "descricao": "Coletor de res�duos s�lidos de servi�os de sa�de"
  },
  {
    "codigo": "514305",
    "descricao": "Limpador de vidros"
  },
  {
    "codigo": "514310",
    "descricao": "Auxiliar de manuten��o predial"
  },
  {
    "codigo": "514315",
    "descricao": "Limpador de fachadas"
  },
  {
    "codigo": "514320",
    "descricao": "Faxineiro"
  },
  {
    "codigo": "514325",
    "descricao": "Trabalhador da manuten��o de edifica��es"
  },
  {
    "codigo": "514330",
    "descricao": "Limpador de piscinas"
  },
  {
    "codigo": "515105",
    "descricao": "Agente comunit�rio de sa�de"
  },
  {
    "codigo": "515110",
    "descricao": "Atendente de enfermagem"
  },
  {
    "codigo": "515115",
    "descricao": "Parteira leiga"
  },
  {
    "codigo": "515120",
    "descricao": "Visitador sanit�rio"
  },
  {
    "codigo": "515125",
    "descricao": "Agente ind�gena de sa�de"
  },
  {
    "codigo": "515130",
    "descricao": "Agente ind�gena de saneamento"
  },
  {
    "codigo": "515135",
    "descricao": "Socorrista (exceto m�dicos e enfermeiros)"
  },
  {
    "codigo": "515140",
    "descricao": "Agente de combate �s endemias"
  },
  {
    "codigo": "515205",
    "descricao": "Auxiliar de banco de sangue"
  },
  {
    "codigo": "515210",
    "descricao": "Auxiliar de farm�cia de manipula��o"
  },
  {
    "codigo": "515215",
    "descricao": "Auxiliar de laborat�rio de an�lises cl�nicas"
  },
  {
    "codigo": "515220",
    "descricao": "Auxiliar de laborat�rio de imunobiol�gicos"
  },
  {
    "codigo": "515225",
    "descricao": "Auxiliar de produ��o farmac�utica"
  },
  {
    "codigo": "515305",
    "descricao": "Educador social"
  },
  {
    "codigo": "515310",
    "descricao": "Agente de a��o social"
  },
  {
    "codigo": "515315",
    "descricao": "Monitor de dependente qu�mico"
  },
  {
    "codigo": "515320",
    "descricao": "Conselheiro tutelar"
  },
  {
    "codigo": "515325",
    "descricao": "S�cioeducador"
  },
  {
    "codigo": "515330",
    "descricao": "Monitor de ressocializa��o prisional"
  },
  {
    "codigo": "516105",
    "descricao": "Barbeiro"
  },
  {
    "codigo": "516110",
    "descricao": "Cabeleireiro"
  },
  {
    "codigo": "516120",
    "descricao": "Manicure/pedicure"
  },
  {
    "codigo": "516125",
    "descricao": "Maquiador"
  },
  {
    "codigo": "516130",
    "descricao": "Maquiador de caracteriza��o"
  },
  {
    "codigo": "516145",
    "descricao": "Designer de unhas"
  },
  {
    "codigo": "516150",
    "descricao": "Designer de sobrancelhas"
  },
  {
    "codigo": "516155",
    "descricao": "Designer de c�lios"
  },
  {
    "codigo": "516205",
    "descricao": "Bab�"
  },
  {
    "codigo": "516210",
    "descricao": "Cuidador de idosos"
  },
  {
    "codigo": "516215",
    "descricao": "M�e social"
  },
  {
    "codigo": "516220",
    "descricao": "Cuidador em sa�de"
  },
  {
    "codigo": "516305",
    "descricao": "Lavadeiro, em geral"
  },
  {
    "codigo": "516310",
    "descricao": "Lavador de roupas  a maquina"
  },
  {
    "codigo": "516315",
    "descricao": "Lavador de artefatos de tape�aria"
  },
  {
    "codigo": "516320",
    "descricao": "Limpador a seco, � m�quina"
  },
  {
    "codigo": "516325",
    "descricao": "Passador de roupas em geral"
  },
  {
    "codigo": "516330",
    "descricao": "Tingidor de roupas"
  },
  {
    "codigo": "516335",
    "descricao": "Conferente-expedidor de roupas (lavanderias)"
  },
  {
    "codigo": "516340",
    "descricao": "Atendente de lavanderia"
  },
  {
    "codigo": "516345",
    "descricao": "Auxiliar de lavanderia"
  },
  {
    "codigo": "516405",
    "descricao": "Lavador de roupas"
  },
  {
    "codigo": "516410",
    "descricao": "Limpador de roupas a seco, � m�o"
  },
  {
    "codigo": "516415",
    "descricao": "Passador de roupas, � m�o"
  },
  {
    "codigo": "516505",
    "descricao": "Agente funer�rio"
  },
  {
    "codigo": "516605",
    "descricao": "Operador de forno (servi�os funer�rios)"
  },
  {
    "codigo": "516610",
    "descricao": "Sepultador"
  },
  {
    "codigo": "516705",
    "descricao": "Astr�logo"
  },
  {
    "codigo": "516710",
    "descricao": "Numer�logo"
  },
  {
    "codigo": "516805",
    "descricao": "Esot�rico"
  },
  {
    "codigo": "516810",
    "descricao": "Paranormal"
  },
  {
    "codigo": "516905",
    "descricao": "Tatuador"
  },
  {
    "codigo": "516910",
    "descricao": "Micropigmentador"
  },
  {
    "codigo": "516915",
    "descricao": "Body piercer"
  },
  {
    "codigo": "517105",
    "descricao": "Bombeiro de aer�dromo"
  },
  {
    "codigo": "517110",
    "descricao": "Bombeiro civil"
  },
  {
    "codigo": "517115",
    "descricao": "Salva-vidas"
  },
  {
    "codigo": "517120",
    "descricao": "Brigadista florestal"
  },
  {
    "codigo": "517125",
    "descricao": "Chefe de brigada"
  },
  {
    "codigo": "517130",
    "descricao": "Agente de prote��o e defesa civil"
  },
  {
    "codigo": "517205",
    "descricao": "Agente de pol�cia federal"
  },
  {
    "codigo": "517210",
    "descricao": "Policial rodovi�rio federal"
  },
  {
    "codigo": "517215",
    "descricao": "Guarda-civil municipal"
  },
  {
    "codigo": "517220",
    "descricao": "Agente de tr�nsito"
  },
  {
    "codigo": "517225",
    "descricao": "Policial legislativo"
  },
  {
    "codigo": "517230",
    "descricao": "Policial penal"
  },
  {
    "codigo": "517235",
    "descricao": "Guarda portu�rio"
  },
  {
    "codigo": "517305",
    "descricao": "Vigilante de prote��o de aeroporto"
  },
  {
    "codigo": "517310",
    "descricao": "Agente de seguran�a"
  },
  {
    "codigo": "517320",
    "descricao": "Vigia florestal"
  },
  {
    "codigo": "517325",
    "descricao": "Vigia portu�rio"
  },
  {
    "codigo": "517330",
    "descricao": "Vigilante"
  },
  {
    "codigo": "517405",
    "descricao": "Porteiro (hotel)"
  },
  {
    "codigo": "517410",
    "descricao": "Porteiro de edif�cios"
  },
  {
    "codigo": "517415",
    "descricao": "Agente de portaria"
  },
  {
    "codigo": "517420",
    "descricao": "Vigia"
  },
  {
    "codigo": "517425",
    "descricao": "Fiscal de loja"
  },
  {
    "codigo": "519105",
    "descricao": "Ciclista mensageiro"
  },
  {
    "codigo": "519110",
    "descricao": "Motofretista"
  },
  {
    "codigo": "519115",
    "descricao": "Mototaxista"
  },
  {
    "codigo": "519205",
    "descricao": "Catador de material recicl�vel"
  },
  {
    "codigo": "519210",
    "descricao": "Selecionador de material recicl�vel"
  },
  {
    "codigo": "519215",
    "descricao": "Operador de prensa de material recicl�vel"
  },
  {
    "codigo": "519305",
    "descricao": "Auxiliar de veterin�rio"
  },
  {
    "codigo": "519310",
    "descricao": "Esteticista de animais dom�sticos"
  },
  {
    "codigo": "519315",
    "descricao": "Banhista de animais dom�sticos"
  },
  {
    "codigo": "519320",
    "descricao": "Tosador de animais dom�sticos"
  },
  {
    "codigo": "519805",
    "descricao": "Profissional do sexo"
  },
  {
    "codigo": "519905",
    "descricao": "Cartazeiro"
  },
  {
    "codigo": "519910",
    "descricao": "Controlador de pragas"
  },
  {
    "codigo": "519915",
    "descricao": "Engraxate"
  },
  {
    "codigo": "519920",
    "descricao": "Gandula"
  },
  {
    "codigo": "519925",
    "descricao": "Guardador de ve�culos"
  },
  {
    "codigo": "519930",
    "descricao": "Lavador de garrafas, vidros e outros utens�lios"
  },
  {
    "codigo": "519935",
    "descricao": "Lavador de ve�culos"
  },
  {
    "codigo": "519940",
    "descricao": "Leiturista"
  },
  {
    "codigo": "519945",
    "descricao": "Recepcionista de casas de espet�culos"
  },
  {
    "codigo": "520105",
    "descricao": "Supervisor de vendas de servi�os"
  },
  {
    "codigo": "520110",
    "descricao": "Supervisor de vendas comercial"
  },
  {
    "codigo": "521105",
    "descricao": "Vendedor em com�rcio atacadista"
  },
  {
    "codigo": "521110",
    "descricao": "Vendedor de com�rcio varejista"
  },
  {
    "codigo": "521115",
    "descricao": "Promotor de vendas"
  },
  {
    "codigo": "521120",
    "descricao": "Demonstrador de mercadorias"
  },
  {
    "codigo": "521125",
    "descricao": "Repositor de mercadorias"
  },
  {
    "codigo": "521130",
    "descricao": "Atendente de farm�cia - balconista"
  },
  {
    "codigo": "521135",
    "descricao": "Frentista"
  },
  {
    "codigo": "521140",
    "descricao": "Atendente de lojas e mercados"
  },
  {
    "codigo": "523105",
    "descricao": "Instalador de cortinas e persianas, portas sanfonadas e boxe"
  },
  {
    "codigo": "523110",
    "descricao": "Instalador de som e acess�rios de ve�culos"
  },
  {
    "codigo": "523115",
    "descricao": "Chaveiro"
  },
  {
    "codigo": "523120",
    "descricao": "Aplicador de vinil autoadesivo"
  },
  {
    "codigo": "523125",
    "descricao": "Estampador de placa de identifica��o veicular (epiv)"
  },
  {
    "codigo": "524105",
    "descricao": "Vendedor em domic�lio"
  },
  {
    "codigo": "524205",
    "descricao": "Feirante"
  },
  {
    "codigo": "524210",
    "descricao": "Jornaleiro (em banca de jornal)"
  },
  {
    "codigo": "524215",
    "descricao": "Vendedor  permission�rio"
  },
  {
    "codigo": "524305",
    "descricao": "Vendedor ambulante"
  },
  {
    "codigo": "524310",
    "descricao": "Pipoqueiro ambulante"
  },
  {
    "codigo": "524315",
    "descricao": "Baiana de acaraj�"
  },
  {
    "codigo": "611005",
    "descricao": "Produtor agropecu�rio, em geral"
  },
  {
    "codigo": "612005",
    "descricao": "Produtor agr�cola polivalente"
  },
  {
    "codigo": "612105",
    "descricao": "Produtor de arroz"
  },
  {
    "codigo": "612110",
    "descricao": "Produtor de cana-de-a��car"
  },
  {
    "codigo": "612115",
    "descricao": "Produtor de cereais de inverno"
  },
  {
    "codigo": "612120",
    "descricao": "Produtor de gram�neas forrageiras"
  },
  {
    "codigo": "612125",
    "descricao": "Produtor de milho e sorgo"
  },
  {
    "codigo": "612205",
    "descricao": "Produtor de algod�o"
  },
  {
    "codigo": "612210",
    "descricao": "Produtor de curau�"
  },
  {
    "codigo": "612215",
    "descricao": "Produtor de juta"
  },
  {
    "codigo": "612220",
    "descricao": "Produtor de rami"
  },
  {
    "codigo": "612225",
    "descricao": "Produtor de sisal"
  },
  {
    "codigo": "612305",
    "descricao": "Produtor na olericultura de legumes"
  },
  {
    "codigo": "612310",
    "descricao": "Produtor na olericultura de ra�zes, bulbos e tub�rculos"
  },
  {
    "codigo": "612315",
    "descricao": "Produtor na olericultura de talos, folhas e flores"
  },
  {
    "codigo": "612320",
    "descricao": "Produtor na olericultura de frutos e sementes"
  },
  {
    "codigo": "612405",
    "descricao": "Produtor de flores de corte"
  },
  {
    "codigo": "612410",
    "descricao": "Produtor de flores em vaso"
  },
  {
    "codigo": "612415",
    "descricao": "Produtor de forra��es"
  },
  {
    "codigo": "612420",
    "descricao": "Produtor de plantas ornamentais"
  },
  {
    "codigo": "612505",
    "descricao": "Produtor de �rvores frut�feras"
  },
  {
    "codigo": "612510",
    "descricao": "Produtor de esp�cies frut�feras rasteiras"
  },
  {
    "codigo": "612515",
    "descricao": "Produtor de esp�cies frut�feras trepadeiras"
  },
  {
    "codigo": "612605",
    "descricao": "Cafeicultor"
  },
  {
    "codigo": "612610",
    "descricao": "Produtor de cacau"
  },
  {
    "codigo": "612615",
    "descricao": "Produtor de erva-mate"
  },
  {
    "codigo": "612620",
    "descricao": "Produtor de fumo"
  },
  {
    "codigo": "612625",
    "descricao": "Produtor de guaran�"
  },
  {
    "codigo": "612705",
    "descricao": "Produtor da cultura de amendoim"
  },
  {
    "codigo": "612710",
    "descricao": "Produtor da cultura de canola"
  },
  {
    "codigo": "612715",
    "descricao": "Produtor da cultura de coco-da-baia"
  },
  {
    "codigo": "612720",
    "descricao": "Produtor da cultura de dend�"
  },
  {
    "codigo": "612725",
    "descricao": "Produtor da cultura de girassol"
  },
  {
    "codigo": "612730",
    "descricao": "Produtor da cultura de linho"
  },
  {
    "codigo": "612735",
    "descricao": "Produtor da cultura de mamona"
  },
  {
    "codigo": "612740",
    "descricao": "Produtor da cultura de soja"
  },
  {
    "codigo": "612805",
    "descricao": "Produtor de especiarias"
  },
  {
    "codigo": "612810",
    "descricao": "Produtor de plantas arom�ticas e medicinais"
  },
  {
    "codigo": "613005",
    "descricao": "Criador em pecu�ria polivalente"
  },
  {
    "codigo": "613010",
    "descricao": "Criador de animais dom�sticos"
  },
  {
    "codigo": "613105",
    "descricao": "Criador de asininos e muares"
  },
  {
    "codigo": "613110",
    "descricao": "Criador de bovinos (corte)"
  },
  {
    "codigo": "613115",
    "descricao": "Criador de bovinos (leite)"
  },
  {
    "codigo": "613120",
    "descricao": "Criador de bubalinos (corte)"
  },
  {
    "codigo": "613125",
    "descricao": "Criador de bubalinos (leite)"
  },
  {
    "codigo": "613130",
    "descricao": "Criador de eq��nos"
  },
  {
    "codigo": "613205",
    "descricao": "Criador de caprinos"
  },
  {
    "codigo": "613210",
    "descricao": "Criador de ovinos"
  },
  {
    "codigo": "613215",
    "descricao": "Criador de su�nos"
  },
  {
    "codigo": "613305",
    "descricao": "Avicultor"
  },
  {
    "codigo": "613310",
    "descricao": "Cunicultor"
  },
  {
    "codigo": "613405",
    "descricao": "Apicultor"
  },
  {
    "codigo": "613410",
    "descricao": "Criador de animais produtores de veneno"
  },
  {
    "codigo": "613415",
    "descricao": "Minhocultor"
  },
  {
    "codigo": "613420",
    "descricao": "Sericultor"
  },
  {
    "codigo": "620105",
    "descricao": "Supervisor de explora��o agr�cola"
  },
  {
    "codigo": "620110",
    "descricao": "Supervisor de explora��o agropecu�ria"
  },
  {
    "codigo": "620115",
    "descricao": "Supervisor de explora��o pecu�ria"
  },
  {
    "codigo": "621005",
    "descricao": "Trabalhador agropecu�rio em geral"
  },
  {
    "codigo": "622005",
    "descricao": "Caseiro (agricultura)"
  },
  {
    "codigo": "622010",
    "descricao": "Jardineiro"
  },
  {
    "codigo": "622015",
    "descricao": "Trabalhador na produ��o de mudas e sementes"
  },
  {
    "codigo": "622020",
    "descricao": "Trabalhador volante da agricultura"
  },
  {
    "codigo": "622105",
    "descricao": "Trabalhador da cultura de arroz"
  },
  {
    "codigo": "622110",
    "descricao": "Trabalhador da cultura de cana-de-a��car"
  },
  {
    "codigo": "622115",
    "descricao": "Trabalhador da cultura de milho e sorgo"
  },
  {
    "codigo": "622120",
    "descricao": "Trabalhador da cultura de trigo, aveia, cevada e triticale"
  },
  {
    "codigo": "622205",
    "descricao": "Trabalhador da cultura de algod�o"
  },
  {
    "codigo": "622210",
    "descricao": "Trabalhador da cultura de sisal"
  },
  {
    "codigo": "622215",
    "descricao": "Trabalhador da cultura do rami"
  },
  {
    "codigo": "622305",
    "descricao": "Trabalhador na olericultura (frutos e sementes)"
  },
  {
    "codigo": "622310",
    "descricao": "Trabalhador na olericultura (legumes)"
  },
  {
    "codigo": "622315",
    "descricao": "Trabalhador na olericultura (ra�zes, bulbos e tub�rculos)"
  },
  {
    "codigo": "622320",
    "descricao": "Trabalhador na olericultura (talos, folhas e flores)"
  },
  {
    "codigo": "622405",
    "descricao": "Trabalhador no cultivo de flores e folhagens de corte"
  },
  {
    "codigo": "622410",
    "descricao": "Trabalhador no cultivo de flores em vaso"
  },
  {
    "codigo": "622415",
    "descricao": "Trabalhador no cultivo de forra��es"
  },
  {
    "codigo": "622420",
    "descricao": "Trabalhador no cultivo de mudas"
  },
  {
    "codigo": "622425",
    "descricao": "Trabalhador no cultivo de plantas ornamentais"
  },
  {
    "codigo": "622505",
    "descricao": "Trabalhador no cultivo de �rvores frut�feras"
  },
  {
    "codigo": "622510",
    "descricao": "Trabalhador no cultivo de esp�cies frut�feras rasteiras"
  },
  {
    "codigo": "622515",
    "descricao": "Trabalhador no cultivo de trepadeiras frut�feras"
  },
  {
    "codigo": "622605",
    "descricao": "Trabalhador da cultura de cacau"
  },
  {
    "codigo": "622610",
    "descricao": "Trabalhador da cultura de caf�"
  },
  {
    "codigo": "622615",
    "descricao": "Trabalhador da cultura de erva-mate"
  },
  {
    "codigo": "622620",
    "descricao": "Trabalhador da cultura de fumo"
  },
  {
    "codigo": "622625",
    "descricao": "Trabalhador da cultura de guaran�"
  },
  {
    "codigo": "622705",
    "descricao": "Trabalhador na cultura de amendoim"
  },
  {
    "codigo": "622710",
    "descricao": "Trabalhador na cultura de canola"
  },
  {
    "codigo": "622715",
    "descricao": "Trabalhador na cultura de coco-da-ba�a"
  },
  {
    "codigo": "622720",
    "descricao": "Trabalhador na cultura de dend�"
  },
  {
    "codigo": "622725",
    "descricao": "Trabalhador na cultura de mamona"
  },
  {
    "codigo": "622730",
    "descricao": "Trabalhador na cultura de soja"
  },
  {
    "codigo": "622735",
    "descricao": "Trabalhador na cultura do girassol"
  },
  {
    "codigo": "622740",
    "descricao": "Trabalhador na cultura do linho"
  },
  {
    "codigo": "622805",
    "descricao": "Trabalhador da cultura de especiarias"
  },
  {
    "codigo": "622810",
    "descricao": "Trabalhador da cultura de plantas arom�ticas e medicinais"
  },
  {
    "codigo": "623005",
    "descricao": "Adestrador de animais"
  },
  {
    "codigo": "623010",
    "descricao": "Inseminador"
  },
  {
    "codigo": "623015",
    "descricao": "Trabalhador de pecu�ria polivalente"
  },
  {
    "codigo": "623020",
    "descricao": "Tratador de animais"
  },
  {
    "codigo": "623025",
    "descricao": "Casqueador de animais"
  },
  {
    "codigo": "623030",
    "descricao": "Ferrador de animais"
  },
  {
    "codigo": "623105",
    "descricao": "Trabalhador da pecu�ria (asininos e muares)"
  },
  {
    "codigo": "623110",
    "descricao": "Trabalhador da pecu�ria (bovinos corte)"
  },
  {
    "codigo": "623115",
    "descricao": "Trabalhador da pecu�ria (bovinos leite)"
  },
  {
    "codigo": "623120",
    "descricao": "Trabalhador da pecu�ria (bubalinos)"
  },
  {
    "codigo": "623125",
    "descricao": "Trabalhador da pecu�ria (eq�inos)"
  },
  {
    "codigo": "623205",
    "descricao": "Trabalhador da caprinocultura"
  },
  {
    "codigo": "623210",
    "descricao": "Trabalhador da ovinocultura"
  },
  {
    "codigo": "623215",
    "descricao": "Trabalhador da suinocultura"
  },
  {
    "codigo": "623305",
    "descricao": "Trabalhador da avicultura de corte"
  },
  {
    "codigo": "623310",
    "descricao": "Trabalhador da avicultura de postura"
  },
  {
    "codigo": "623315",
    "descricao": "Operador de incubadora"
  },
  {
    "codigo": "623320",
    "descricao": "Trabalhador da cunicultura"
  },
  {
    "codigo": "623325",
    "descricao": "Sexador"
  },
  {
    "codigo": "623405",
    "descricao": "Trabalhador em criat�rios de animais produtores de veneno"
  },
  {
    "codigo": "623410",
    "descricao": "Trabalhador na apicultura"
  },
  {
    "codigo": "623415",
    "descricao": "Trabalhador na minhocultura"
  },
  {
    "codigo": "623420",
    "descricao": "Trabalhador na sericicultura"
  },
  {
    "codigo": "630105",
    "descricao": "Supervisor da aq�icultura"
  },
  {
    "codigo": "630110",
    "descricao": "Supervisor da �rea florestal"
  },
  {
    "codigo": "631005",
    "descricao": "Catador de caranguejos e siris"
  },
  {
    "codigo": "631010",
    "descricao": "Catador de mariscos"
  },
  {
    "codigo": "631015",
    "descricao": "Pescador artesanal de lagostas"
  },
  {
    "codigo": "631020",
    "descricao": "Pescador artesanal de peixes e camar�es"
  },
  {
    "codigo": "631105",
    "descricao": "Pescador artesanal de �gua doce"
  },
  {
    "codigo": "631205",
    "descricao": "Pescador industrial"
  },
  {
    "codigo": "631210",
    "descricao": "Pescador profissional"
  },
  {
    "codigo": "631305",
    "descricao": "Criador de camar�es"
  },
  {
    "codigo": "631310",
    "descricao": "Criador de jacar�s"
  },
  {
    "codigo": "631315",
    "descricao": "Criador de mexilh�es"
  },
  {
    "codigo": "631320",
    "descricao": "Criador de ostras"
  },
  {
    "codigo": "631325",
    "descricao": "Criador de peixes"
  },
  {
    "codigo": "631330",
    "descricao": "Criador de quel�nios"
  },
  {
    "codigo": "631335",
    "descricao": "Criador de r�s"
  },
  {
    "codigo": "631405",
    "descricao": "Gelador industrial"
  },
  {
    "codigo": "631410",
    "descricao": "Gelador profissional"
  },
  {
    "codigo": "631415",
    "descricao": "Proeiro"
  },
  {
    "codigo": "631420",
    "descricao": "Redeiro (pesca)"
  },
  {
    "codigo": "632005",
    "descricao": "Guia florestal"
  },
  {
    "codigo": "632010",
    "descricao": "Raizeiro"
  },
  {
    "codigo": "632015",
    "descricao": "Viveirista florestal"
  },
  {
    "codigo": "632105",
    "descricao": "Classificador de toras"
  },
  {
    "codigo": "632110",
    "descricao": "Cubador de madeira"
  },
  {
    "codigo": "632115",
    "descricao": "Identificador florestal"
  },
  {
    "codigo": "632120",
    "descricao": "Operador de motosserra"
  },
  {
    "codigo": "632125",
    "descricao": "Trabalhador de extra��o florestal, em geral"
  },
  {
    "codigo": "632205",
    "descricao": "Seringueiro"
  },
  {
    "codigo": "632210",
    "descricao": "Trabalhador da explora��o de esp�cies produtoras de gomas n�o el�sticas"
  },
  {
    "codigo": "632215",
    "descricao": "Trabalhador da explora��o de resinas"
  },
  {
    "codigo": "632305",
    "descricao": "Trabalhador da explora��o de andiroba"
  },
  {
    "codigo": "632310",
    "descricao": "Trabalhador da explora��o de baba�u"
  },
  {
    "codigo": "632315",
    "descricao": "Trabalhador da explora��o de bacaba"
  },
  {
    "codigo": "632320",
    "descricao": "Trabalhador da explora��o de buriti"
  },
  {
    "codigo": "632325",
    "descricao": "Trabalhador da explora��o de carna�ba"
  },
  {
    "codigo": "632330",
    "descricao": "Trabalhador da explora��o de coco-da-praia"
  },
  {
    "codigo": "632335",
    "descricao": "Trabalhador da explora��o de copa�ba"
  },
  {
    "codigo": "632340",
    "descricao": "Trabalhador da explora��o de malva (p�ina)"
  },
  {
    "codigo": "632345",
    "descricao": "Trabalhador da explora��o de murumuru"
  },
  {
    "codigo": "632350",
    "descricao": "Trabalhador da explora��o de oiticica"
  },
  {
    "codigo": "632355",
    "descricao": "Trabalhador da explora��o de ouricuri"
  },
  {
    "codigo": "632360",
    "descricao": "Trabalhador da explora��o de pequi"
  },
  {
    "codigo": "632365",
    "descricao": "Trabalhador da explora��o de pia�ava"
  },
  {
    "codigo": "632370",
    "descricao": "Trabalhador da explora��o de tucum"
  },
  {
    "codigo": "632405",
    "descricao": "Trabalhador da explora��o de a�a�"
  },
  {
    "codigo": "632410",
    "descricao": "Trabalhador da explora��o de castanha"
  },
  {
    "codigo": "632415",
    "descricao": "Trabalhador da explora��o de pinh�o"
  },
  {
    "codigo": "632420",
    "descricao": "Trabalhador da explora��o de pupunha"
  },
  {
    "codigo": "632505",
    "descricao": "Trabalhador da explora��o de �rvores e arbustos produtores de subst�ncias arom�t., Medic. E t�xicas"
  },
  {
    "codigo": "632510",
    "descricao": "Trabalhador da explora��o de cip�s produtores de subst�ncias arom�ticas, medicinais e t�xicas"
  },
  {
    "codigo": "632515",
    "descricao": "Trabalhador da explora��o de madeiras tanantes"
  },
  {
    "codigo": "632520",
    "descricao": "Trabalhador da explora��o de ra�zes produtoras de subst�ncias arom�ticas, medicinais e t�xicas"
  },
  {
    "codigo": "632525",
    "descricao": "Trabalhador da extra��o de subst�ncias arom�ticas, medicinais e t�xicas, em geral"
  },
  {
    "codigo": "632605",
    "descricao": "Carvoeiro"
  },
  {
    "codigo": "632610",
    "descricao": "Carbonizador"
  },
  {
    "codigo": "632615",
    "descricao": "Ajudante de carvoaria"
  },
  {
    "codigo": "641005",
    "descricao": "Operador de colheitadeira"
  },
  {
    "codigo": "641010",
    "descricao": "Operador de m�quinas de beneficiamento de produtos agr�colas"
  },
  {
    "codigo": "641015",
    "descricao": "Tratorista agr�cola"
  },
  {
    "codigo": "642005",
    "descricao": "Operador de colhedor florestal"
  },
  {
    "codigo": "642010",
    "descricao": "Operador de m�quinas florestais est�ticas"
  },
  {
    "codigo": "642015",
    "descricao": "Operador de trator florestal"
  },
  {
    "codigo": "643005",
    "descricao": "Trabalhador na opera��o de sistema de irriga��o localizada (microaspers�o e gotejamento)"
  },
  {
    "codigo": "643010",
    "descricao": "Trabalhador na opera��o de sistema de irriga��o por aspers�o (piv� central)"
  },
  {
    "codigo": "643015",
    "descricao": "Trabalhador na opera��o de sistemas convencionais de irriga��o por aspers�o"
  },
  {
    "codigo": "643020",
    "descricao": "Trabalhador na opera��o de sistemas de irriga��o e aspers�o (alto propelido)"
  },
  {
    "codigo": "643025",
    "descricao": "Trabalhador na opera��o de sistemas de irriga��o por superf�cie e drenagem"
  },
  {
    "codigo": "710105",
    "descricao": "Supervisor de apoio operacional na minera��o"
  },
  {
    "codigo": "710110",
    "descricao": "Supervisor de extra��o de sal"
  },
  {
    "codigo": "710115",
    "descricao": "Supervisor de perfura��o e desmonte"
  },
  {
    "codigo": "710120",
    "descricao": "Supervisor de produ��o na minera��o"
  },
  {
    "codigo": "710125",
    "descricao": "Supervisor de transporte na minera��o"
  },
  {
    "codigo": "710205",
    "descricao": "Mestre (constru��o civil)"
  },
  {
    "codigo": "710210",
    "descricao": "Mestre de linhas (ferrovias)"
  },
  {
    "codigo": "710215",
    "descricao": "Inspetor de terraplenagem"
  },
  {
    "codigo": "710220",
    "descricao": "Supervisor de usina de concreto"
  },
  {
    "codigo": "710225",
    "descricao": "Fiscal de p�tio de usina de concreto"
  },
  {
    "codigo": "711105",
    "descricao": "Amostrador de min�rios"
  },
  {
    "codigo": "711110",
    "descricao": "Canteiro"
  },
  {
    "codigo": "711115",
    "descricao": "Destro�ador de pedra"
  },
  {
    "codigo": "711120",
    "descricao": "Detonador"
  },
  {
    "codigo": "711125",
    "descricao": "Escorador de minas"
  },
  {
    "codigo": "711130",
    "descricao": "Mineiro"
  },
  {
    "codigo": "711205",
    "descricao": "Operador de caminh�o (minas e pedreiras)"
  },
  {
    "codigo": "711210",
    "descricao": "Operador de carregadeira"
  },
  {
    "codigo": "711215",
    "descricao": "Operador de m�quina cortadora (minas e pedreiras)"
  },
  {
    "codigo": "711220",
    "descricao": "Operador de m�quina de extra��o cont�nua (minas de carv�o)"
  },
  {
    "codigo": "711225",
    "descricao": "Operador de m�quina perfuradora (minas e pedreiras)"
  },
  {
    "codigo": "711230",
    "descricao": "Operador de m�quina perfuratriz"
  },
  {
    "codigo": "711235",
    "descricao": "Operador de motoniveladora (extra��o de minerais s�lidos)"
  },
  {
    "codigo": "711240",
    "descricao": "Operador de schutthecar"
  },
  {
    "codigo": "711245",
    "descricao": "Operador de trator (minas e pedreiras)"
  },
  {
    "codigo": "711305",
    "descricao": "Operador de sonda de percuss�o"
  },
  {
    "codigo": "711310",
    "descricao": "Operador de sonda rotativa"
  },
  {
    "codigo": "711315",
    "descricao": "Sondador (po�os de petr�leo e g�s)"
  },
  {
    "codigo": "711320",
    "descricao": "Sondador de po�os (exceto de petr�leo e g�s)"
  },
  {
    "codigo": "711325",
    "descricao": "Plataformista (petr�leo)"
  },
  {
    "codigo": "711330",
    "descricao": "Torrista (petr�leo)"
  },
  {
    "codigo": "711405",
    "descricao": "Garimpeiro"
  },
  {
    "codigo": "711410",
    "descricao": "Operador de salina (sal marinho)"
  },
  {
    "codigo": "712105",
    "descricao": "Moleiro de min�rios"
  },
  {
    "codigo": "712110",
    "descricao": "Operador de aparelho de flota��o"
  },
  {
    "codigo": "712115",
    "descricao": "Operador de aparelho de precipita��o (minas de ouro ou prata)"
  },
  {
    "codigo": "712120",
    "descricao": "Operador de britador de mand�bulas"
  },
  {
    "codigo": "712125",
    "descricao": "Operador de espessador"
  },
  {
    "codigo": "712130",
    "descricao": "Operador de jig (minas)"
  },
  {
    "codigo": "712135",
    "descricao": "Operador de peneiras hidr�ulicas"
  },
  {
    "codigo": "712205",
    "descricao": "Cortador de pedras"
  },
  {
    "codigo": "712210",
    "descricao": "Gravador de inscri��es em pedra"
  },
  {
    "codigo": "712215",
    "descricao": "Gravador de relevos em pedra"
  },
  {
    "codigo": "712220",
    "descricao": "Polidor de pedras"
  },
  {
    "codigo": "712225",
    "descricao": "Torneiro (lavra de pedra)"
  },
  {
    "codigo": "712230",
    "descricao": "Tra�ador de pedras"
  },
  {
    "codigo": "715105",
    "descricao": "Operador de bate-estacas"
  },
  {
    "codigo": "715110",
    "descricao": "Operador de compactadora de solos"
  },
  {
    "codigo": "715115",
    "descricao": "Operador de escavadeira"
  },
  {
    "codigo": "715120",
    "descricao": "Operador de m�quina de abrir valas"
  },
  {
    "codigo": "715125",
    "descricao": "Operador de m�quinas de constru��o civil e minera��o"
  },
  {
    "codigo": "715130",
    "descricao": "Operador de motoniveladora"
  },
  {
    "codigo": "715135",
    "descricao": "Operador de p� carregadeira"
  },
  {
    "codigo": "715140",
    "descricao": "Operador de pavimentadora (asfalto, concreto e materiais similares)"
  },
  {
    "codigo": "715145",
    "descricao": "Operador de trator de l�mina"
  },
  {
    "codigo": "715205",
    "descricao": "Calceteiro"
  },
  {
    "codigo": "715210",
    "descricao": "Pedreiro"
  },
  {
    "codigo": "715215",
    "descricao": "Pedreiro (chamin�s industriais)"
  },
  {
    "codigo": "715220",
    "descricao": "Pedreiro (material refrat�rio)"
  },
  {
    "codigo": "715225",
    "descricao": "Pedreiro (minera��o)"
  },
  {
    "codigo": "715230",
    "descricao": "Pedreiro de edifica��es"
  },
  {
    "codigo": "715305",
    "descricao": "Armador de estrutura de concreto"
  },
  {
    "codigo": "715310",
    "descricao": "Moldador de corpos de prova em usinas de concreto"
  },
  {
    "codigo": "715315",
    "descricao": "Armador de estrutura de concreto armado"
  },
  {
    "codigo": "715405",
    "descricao": "Operador de betoneira"
  },
  {
    "codigo": "715410",
    "descricao": "Operador de bomba de concreto"
  },
  {
    "codigo": "715415",
    "descricao": "Operador de central de concreto"
  },
  {
    "codigo": "715420",
    "descricao": "Operador de usina de asfalto"
  },
  {
    "codigo": "715505",
    "descricao": "Carpinteiro"
  },
  {
    "codigo": "715510",
    "descricao": "Carpinteiro (esquadrias)"
  },
  {
    "codigo": "715515",
    "descricao": "Carpinteiro (cen�rios)"
  },
  {
    "codigo": "715520",
    "descricao": "Carpinteiro (minera��o)"
  },
  {
    "codigo": "715525",
    "descricao": "Carpinteiro de obras"
  },
  {
    "codigo": "715530",
    "descricao": "Carpinteiro (telhados)"
  },
  {
    "codigo": "715535",
    "descricao": "Carpinteiro de f�rmas para concreto"
  },
  {
    "codigo": "715540",
    "descricao": "Carpinteiro de obras civis de arte (pontes, t�neis, barragens)"
  },
  {
    "codigo": "715545",
    "descricao": "Montador de andaimes (edifica��es)"
  },
  {
    "codigo": "715605",
    "descricao": "Eletricista de instala��es (cen�rios)"
  },
  {
    "codigo": "715610",
    "descricao": "Eletricista de instala��es (edif�cios)"
  },
  {
    "codigo": "715615",
    "descricao": "Eletricista de instala��es"
  },
  {
    "codigo": "715705",
    "descricao": "Aplicador de asfalto impermeabilizante (coberturas)"
  },
  {
    "codigo": "715710",
    "descricao": "Instalador de isolantes ac�sticos"
  },
  {
    "codigo": "715715",
    "descricao": "Instalador de isolantes t�rmicos (refrigera��o e climatiza��o)"
  },
  {
    "codigo": "715720",
    "descricao": "Instalador de isolantes t�rmicos de caldeira e tubula��es"
  },
  {
    "codigo": "715725",
    "descricao": "Instalador de material isolante, a m�o (edifica��es)"
  },
  {
    "codigo": "715730",
    "descricao": "Instalador de material isolante, � m�quina (edifica��es)"
  },
  {
    "codigo": "716105",
    "descricao": "Acabador de superf�cies de concreto"
  },
  {
    "codigo": "716110",
    "descricao": "Revestidor de superf�cies de concreto"
  },
  {
    "codigo": "716205",
    "descricao": "Telhador (telhas de argila e materiais similares)"
  },
  {
    "codigo": "716210",
    "descricao": "Telhador (telhas de cimento-amianto)"
  },
  {
    "codigo": "716215",
    "descricao": "Telhador (telhas met�licas)"
  },
  {
    "codigo": "716220",
    "descricao": "Telhador (telhas pl�sticas)"
  },
  {
    "codigo": "716305",
    "descricao": "Vidraceiro"
  },
  {
    "codigo": "716310",
    "descricao": "Vidraceiro (edifica��es)"
  },
  {
    "codigo": "716315",
    "descricao": "Vidraceiro (vitrais)"
  },
  {
    "codigo": "716405",
    "descricao": "Gesseiro"
  },
  {
    "codigo": "716505",
    "descricao": "Assoalhador"
  },
  {
    "codigo": "716510",
    "descricao": "Assentador de revestimentos cer�micos"
  },
  {
    "codigo": "716515",
    "descricao": "Pastilheiro"
  },
  {
    "codigo": "716520",
    "descricao": "Lustrador de piso"
  },
  {
    "codigo": "716525",
    "descricao": "Marmorista (constru��o)"
  },
  {
    "codigo": "716530",
    "descricao": "Mosa�sta"
  },
  {
    "codigo": "716535",
    "descricao": "Taqueiro"
  },
  {
    "codigo": "716540",
    "descricao": "Rejuntador de revestimentos"
  },
  {
    "codigo": "716605",
    "descricao": "Calafetador"
  },
  {
    "codigo": "716610",
    "descricao": "Pintor de obras"
  },
  {
    "codigo": "716615",
    "descricao": "Revestidor de interiores (papel, material pl�stico e emborrachados)"
  },
  {
    "codigo": "717005",
    "descricao": "Demolidor de edifica��es"
  },
  {
    "codigo": "717010",
    "descricao": "Operador de martelete"
  },
  {
    "codigo": "717015",
    "descricao": "Poceiro (edifica��es)"
  },
  {
    "codigo": "717020",
    "descricao": "Servente de obras"
  },
  {
    "codigo": "717025",
    "descricao": "Vibradorista"
  },
  {
    "codigo": "720105",
    "descricao": "Mestre (afiador de ferramentas)"
  },
  {
    "codigo": "720110",
    "descricao": "Mestre de caldeiraria"
  },
  {
    "codigo": "720115",
    "descricao": "Mestre de ferramentaria"
  },
  {
    "codigo": "720120",
    "descricao": "Mestre de forjaria"
  },
  {
    "codigo": "720125",
    "descricao": "Mestre de fundi��o"
  },
  {
    "codigo": "720130",
    "descricao": "Mestre de galvanoplastia"
  },
  {
    "codigo": "720135",
    "descricao": "Mestre de pintura (tratamento de superf�cies)"
  },
  {
    "codigo": "720140",
    "descricao": "Mestre de soldagem"
  },
  {
    "codigo": "720145",
    "descricao": "Mestre de trefila��o de metais"
  },
  {
    "codigo": "720150",
    "descricao": "Mestre de usinagem"
  },
  {
    "codigo": "720155",
    "descricao": "Mestre serralheiro"
  },
  {
    "codigo": "720160",
    "descricao": "Supervisor de controle de tratamento t�rmico"
  },
  {
    "codigo": "720205",
    "descricao": "Mestre (constru��o naval)"
  },
  {
    "codigo": "720210",
    "descricao": "Mestre (ind�stria de automotores e material de transportes)"
  },
  {
    "codigo": "720215",
    "descricao": "Mestre (ind�stria de m�quinas e outros equipamentos mec�nicos)"
  },
  {
    "codigo": "720220",
    "descricao": "Mestre de constru��o de fornos"
  },
  {
    "codigo": "721105",
    "descricao": "Ferramenteiro"
  },
  {
    "codigo": "721110",
    "descricao": "Ferramenteiro de mandris, calibradores e outros dispositivos"
  },
  {
    "codigo": "721115",
    "descricao": "Modelador de metais (fundi��o)"
  },
  {
    "codigo": "721205",
    "descricao": "Operador de m�quina de eletroeros�o"
  },
  {
    "codigo": "721210",
    "descricao": "Operador de m�quinas operatrizes"
  },
  {
    "codigo": "721215",
    "descricao": "Operador de m�quinas-ferramenta convencionais"
  },
  {
    "codigo": "721220",
    "descricao": "Operador de usinagem convencional por abras�o"
  },
  {
    "codigo": "721225",
    "descricao": "Preparador de m�quinas-ferramenta"
  },
  {
    "codigo": "721305",
    "descricao": "Afiador de cardas"
  },
  {
    "codigo": "721310",
    "descricao": "Afiador de cutelaria"
  },
  {
    "codigo": "721315",
    "descricao": "Afiador de ferramentas"
  },
  {
    "codigo": "721320",
    "descricao": "Afiador de serras"
  },
  {
    "codigo": "721325",
    "descricao": "Polidor de metais"
  },
  {
    "codigo": "721405",
    "descricao": "Operador de centro de usinagem com comando num�rico"
  },
  {
    "codigo": "721410",
    "descricao": "Operador de fresadora com comando num�rico"
  },
  {
    "codigo": "721415",
    "descricao": "Operador de mandriladora com comando num�rico"
  },
  {
    "codigo": "721420",
    "descricao": "Operador de m�quina eletroeros�o, � fio, com comando num�rico"
  },
  {
    "codigo": "721425",
    "descricao": "Operador de retificadora com comando num�rico"
  },
  {
    "codigo": "721430",
    "descricao": "Operador de torno com comando num�rico"
  },
  {
    "codigo": "722105",
    "descricao": "Forjador"
  },
  {
    "codigo": "722110",
    "descricao": "Forjador a martelo"
  },
  {
    "codigo": "722115",
    "descricao": "Forjador prensista"
  },
  {
    "codigo": "722205",
    "descricao": "Fundidor de metais"
  },
  {
    "codigo": "722210",
    "descricao": "Operador de lingotamento"
  },
  {
    "codigo": "722215",
    "descricao": "Operador de acabamento de pe�as fundidas"
  },
  {
    "codigo": "722220",
    "descricao": "Operador de m�quina de fundi��o"
  },
  {
    "codigo": "722230",
    "descricao": "Operador de vazamento"
  },
  {
    "codigo": "722235",
    "descricao": "Preparador de panelas"
  },
  {
    "codigo": "722305",
    "descricao": "Macheiro, a m�o"
  },
  {
    "codigo": "722310",
    "descricao": "Macheiro, a  m�quina"
  },
  {
    "codigo": "722315",
    "descricao": "Moldador, a  m�o"
  },
  {
    "codigo": "722320",
    "descricao": "Moldador, a  m�quina"
  },
  {
    "codigo": "722325",
    "descricao": "Operador de equipamentos de prepara��o de areia"
  },
  {
    "codigo": "722330",
    "descricao": "Operador de m�quina de moldar automatizada"
  },
  {
    "codigo": "722405",
    "descricao": "Cableador"
  },
  {
    "codigo": "722410",
    "descricao": "Estirador de tubos de metal sem costura"
  },
  {
    "codigo": "722415",
    "descricao": "Trefilador de metais, � m�quina"
  },
  {
    "codigo": "723105",
    "descricao": "Cementador de metais"
  },
  {
    "codigo": "723110",
    "descricao": "Normalizador de metais e de comp�sitos"
  },
  {
    "codigo": "723115",
    "descricao": "Operador de equipamento para resfriamento"
  },
  {
    "codigo": "723120",
    "descricao": "Operador de forno de tratamento t�rmico de metais"
  },
  {
    "codigo": "723125",
    "descricao": "Temperador de metais e de comp�sitos"
  },
  {
    "codigo": "723205",
    "descricao": "Decapador"
  },
  {
    "codigo": "723210",
    "descricao": "Fosfatizador"
  },
  {
    "codigo": "723215",
    "descricao": "Galvanizador"
  },
  {
    "codigo": "723220",
    "descricao": "Metalizador a pistola"
  },
  {
    "codigo": "723225",
    "descricao": "Metalizador (banho quente)"
  },
  {
    "codigo": "723230",
    "descricao": "Operador de m�quina recobridora de arame"
  },
  {
    "codigo": "723235",
    "descricao": "Operador de zincagem (processo eletrol�tico)"
  },
  {
    "codigo": "723240",
    "descricao": "Oxidador"
  },
  {
    "codigo": "723305",
    "descricao": "Operador de equipamento de secagem de pintura"
  },
  {
    "codigo": "723310",
    "descricao": "Pintor a pincel e rolo (exceto obras e estruturas met�licas)"
  },
  {
    "codigo": "723315",
    "descricao": "Pintor de estruturas met�licas"
  },
  {
    "codigo": "723320",
    "descricao": "Pintor de ve�culos (fabrica��o)"
  },
  {
    "codigo": "723325",
    "descricao": "Pintor por imers�o"
  },
  {
    "codigo": "723330",
    "descricao": "Pintor, a  pistola (exceto obras e estruturas met�licas)"
  },
  {
    "codigo": "724105",
    "descricao": "Assentador de canaliza��o (edifica��es)"
  },
  {
    "codigo": "724110",
    "descricao": "Encanador"
  },
  {
    "codigo": "724115",
    "descricao": "Instalador de tubula��es"
  },
  {
    "codigo": "724120",
    "descricao": "Instalador de tubula��es (aeronaves)"
  },
  {
    "codigo": "724125",
    "descricao": "Instalador de tubula��es (embarca��es)"
  },
  {
    "codigo": "724130",
    "descricao": "Instalador de tubula��es de g�s combust�vel (produ��o e distribui��o)"
  },
  {
    "codigo": "724135",
    "descricao": "Instalador de tubula��es de vapor (produ��o e distribui��o)"
  },
  {
    "codigo": "724205",
    "descricao": "Montador de estruturas met�licas"
  },
  {
    "codigo": "724210",
    "descricao": "Montador de estruturas met�licas de embarca��es"
  },
  {
    "codigo": "724215",
    "descricao": "Rebitador a  martelo pneum�tico"
  },
  {
    "codigo": "724220",
    "descricao": "Preparador de estruturas met�licas"
  },
  {
    "codigo": "724225",
    "descricao": "Riscador de estruturas met�licas"
  },
  {
    "codigo": "724230",
    "descricao": "Rebitador, a  m�o"
  },
  {
    "codigo": "724305",
    "descricao": "Brasador"
  },
  {
    "codigo": "724310",
    "descricao": "Oxicortador a m�o e a  m�quina"
  },
  {
    "codigo": "724315",
    "descricao": "Soldador"
  },
  {
    "codigo": "724320",
    "descricao": "Soldador a  oxig�s"
  },
  {
    "codigo": "724325",
    "descricao": "Soldador el�trico"
  },
  {
    "codigo": "724405",
    "descricao": "Caldeireiro (chapas de cobre)"
  },
  {
    "codigo": "724410",
    "descricao": "Caldeireiro (chapas de ferro e a�o)"
  },
  {
    "codigo": "724415",
    "descricao": "Chapeador"
  },
  {
    "codigo": "724420",
    "descricao": "Chapeador de carrocerias met�licas (fabrica��o)"
  },
  {
    "codigo": "724425",
    "descricao": "Chapeador naval"
  },
  {
    "codigo": "724430",
    "descricao": "Chapeador de aeronaves"
  },
  {
    "codigo": "724435",
    "descricao": "Funileiro industrial"
  },
  {
    "codigo": "724440",
    "descricao": "Serralheiro"
  },
  {
    "codigo": "724505",
    "descricao": "Operador de m�quina de cilindrar chapas"
  },
  {
    "codigo": "724510",
    "descricao": "Operador de m�quina de dobrar chapas"
  },
  {
    "codigo": "724515",
    "descricao": "Prensista (operador de prensa)"
  },
  {
    "codigo": "724605",
    "descricao": "Operador de la�os de cabos de a�o"
  },
  {
    "codigo": "724610",
    "descricao": "Tran�ador de cabos de a�o"
  },
  {
    "codigo": "725005",
    "descricao": "Ajustador ferramenteiro"
  },
  {
    "codigo": "725010",
    "descricao": "Ajustador mec�nico"
  },
  {
    "codigo": "725015",
    "descricao": "Ajustador mec�nico (usinagem em bancada e em m�quinas-ferramentas)"
  },
  {
    "codigo": "725020",
    "descricao": "Ajustador mec�nico em bancada"
  },
  {
    "codigo": "725025",
    "descricao": "Ajustador naval (reparo e constru��o)"
  },
  {
    "codigo": "725030",
    "descricao": "Operador de manuten��o e recarga de extintor de inc�ndio"
  },
  {
    "codigo": "725105",
    "descricao": "Montador de m�quinas, motores e acess�rios (montagem em s�rie)"
  },
  {
    "codigo": "725205",
    "descricao": "Montador de m�quinas"
  },
  {
    "codigo": "725210",
    "descricao": "Montador de m�quinas gr�ficas"
  },
  {
    "codigo": "725215",
    "descricao": "Montador de m�quinas operatrizes para madeira"
  },
  {
    "codigo": "725220",
    "descricao": "Montador de m�quinas t�xteis"
  },
  {
    "codigo": "725225",
    "descricao": "Montador de m�quinas-ferramentas (usinagem de metais)"
  },
  {
    "codigo": "725305",
    "descricao": "Montador de equipamento de levantamento"
  },
  {
    "codigo": "725310",
    "descricao": "Montador de m�quinas agr�colas"
  },
  {
    "codigo": "725315",
    "descricao": "Montador de m�quinas de minas e pedreiras"
  },
  {
    "codigo": "725320",
    "descricao": "Montador de m�quinas de terraplenagem"
  },
  {
    "codigo": "725405",
    "descricao": "Mec�nico montador de motores de aeronaves"
  },
  {
    "codigo": "725410",
    "descricao": "Mec�nico montador de motores de embarca��es"
  },
  {
    "codigo": "725415",
    "descricao": "Mec�nico montador de motores de explos�o e diesel"
  },
  {
    "codigo": "725420",
    "descricao": "Mec�nico montador de turboalimentadores"
  },
  {
    "codigo": "725505",
    "descricao": "Montador de ve�culos (linha de montagem)"
  },
  {
    "codigo": "725510",
    "descricao": "Operador de time de montagem"
  },
  {
    "codigo": "725605",
    "descricao": "Montador de estruturas de aeronaves"
  },
  {
    "codigo": "725610",
    "descricao": "Montador de sistemas de combust�vel de aeronaves"
  },
  {
    "codigo": "725705",
    "descricao": "Mec�nico de refrigera��o"
  },
  {
    "codigo": "730105",
    "descricao": "Supervisor de montagem e instala��o eletroeletr�nica"
  },
  {
    "codigo": "731105",
    "descricao": "Montador de equipamentos eletr�nicos (aparelhos m�dicos)"
  },
  {
    "codigo": "731110",
    "descricao": "Montador de equipamentos eletr�nicos (computadores e equipamentos auxiliares)"
  },
  {
    "codigo": "731115",
    "descricao": "Montador de equipamentos el�tricos (instrumentos de medi��o)"
  },
  {
    "codigo": "731120",
    "descricao": "Montador de equipamentos el�tricos (aparelhos eletrodom�sticos)"
  },
  {
    "codigo": "731125",
    "descricao": "Montador de equipamentos el�tricos (centrais el�tricas)"
  },
  {
    "codigo": "731130",
    "descricao": "Montador de equipamentos el�tricos (motores e d�namos)"
  },
  {
    "codigo": "731135",
    "descricao": "Montador de equipamentos el�tricos"
  },
  {
    "codigo": "731140",
    "descricao": "Montador de equipamentos eletr�nicos (instala��es de sinaliza��o)"
  },
  {
    "codigo": "731145",
    "descricao": "Montador de equipamentos eletr�nicos (m�quinas industriais)"
  },
  {
    "codigo": "731150",
    "descricao": "Montador de equipamentos eletr�nicos"
  },
  {
    "codigo": "731155",
    "descricao": "Montador de equipamentos el�tricos (elevadores e equipamentos similares)"
  },
  {
    "codigo": "731160",
    "descricao": "Montador de equipamentos el�tricos (transformadores)"
  },
  {
    "codigo": "731165",
    "descricao": "Bobinador eletricista, � m�o"
  },
  {
    "codigo": "731170",
    "descricao": "Bobinador eletricista, � m�quina"
  },
  {
    "codigo": "731175",
    "descricao": "Operador de linha de montagem (aparelhos el�tricos)"
  },
  {
    "codigo": "731180",
    "descricao": "Operador de linha de montagem (aparelhos eletr�nicos)"
  },
  {
    "codigo": "731205",
    "descricao": "Montador de equipamentos eletr�nicos (esta��o de r�dio, tv e equipamentos de radar)"
  },
  {
    "codigo": "731305",
    "descricao": "Instalador-reparador de equipamentos de comuta��o em telefonia"
  },
  {
    "codigo": "731310",
    "descricao": "Instalador-reparador de equipamentos de energia em telefonia"
  },
  {
    "codigo": "731315",
    "descricao": "Instalador-reparador de equipamentos de transmiss�o em telefonia"
  },
  {
    "codigo": "731320",
    "descricao": "Instalador-reparador de linhas e aparelhos de telecomunica��es"
  },
  {
    "codigo": "731325",
    "descricao": "Instalador-reparador de redes e cabos telef�nicos"
  },
  {
    "codigo": "731330",
    "descricao": "Reparador de aparelhos de telecomunica��es em laborat�rio"
  },
  {
    "codigo": "732105",
    "descricao": "Eletricista de manuten��o de linhas el�tricas, telef�nicas e de comunica��o de dados"
  },
  {
    "codigo": "732110",
    "descricao": "Emendador de cabos el�tricos e telef�nicos (a�reos e subterr�neos)"
  },
  {
    "codigo": "732115",
    "descricao": "Examinador de cabos, linhas el�tricas e telef�nicas"
  },
  {
    "codigo": "732120",
    "descricao": "Instalador de linhas el�tricas de alta e baixa - tens�o (rede a�rea e subterr�nea)"
  },
  {
    "codigo": "732125",
    "descricao": "Instalador eletricista (tra��o de ve�culos)"
  },
  {
    "codigo": "732130",
    "descricao": "Instalador-reparador de redes telef�nicas e de comunica��o de dados"
  },
  {
    "codigo": "732135",
    "descricao": "Ligador de linhas telef�nicas"
  },
  {
    "codigo": "732140",
    "descricao": "Instalador de sistemas fotovoltaicos"
  },
  {
    "codigo": "740105",
    "descricao": "Supervisor da mec�nica de precis�o"
  },
  {
    "codigo": "740110",
    "descricao": "Supervisor de fabrica��o de instrumentos musicais"
  },
  {
    "codigo": "741105",
    "descricao": "Ajustador de instrumentos de precis�o"
  },
  {
    "codigo": "741110",
    "descricao": "Montador de instrumentos de �ptica"
  },
  {
    "codigo": "741115",
    "descricao": "Montador de instrumentos de precis�o"
  },
  {
    "codigo": "741120",
    "descricao": "Relojoeiro (fabrica��o)"
  },
  {
    "codigo": "741125",
    "descricao": "Relojoeiro (repara��o)"
  },
  {
    "codigo": "742105",
    "descricao": "Afinador de instrumentos musicais"
  },
  {
    "codigo": "742110",
    "descricao": "Confeccionador de acorde�o"
  },
  {
    "codigo": "742115",
    "descricao": "Confeccionador de instrumentos de corda"
  },
  {
    "codigo": "742120",
    "descricao": "Confeccionador de instrumentos de percuss�o (pele, couro ou pl�stico)"
  },
  {
    "codigo": "742125",
    "descricao": "Confeccionador de instrumentos de sopro (madeira)"
  },
  {
    "codigo": "742130",
    "descricao": "Confeccionador de instrumentos de sopro (metal)"
  },
  {
    "codigo": "742135",
    "descricao": "Confeccionador de �rg�o"
  },
  {
    "codigo": "742140",
    "descricao": "Confeccionador de piano"
  },
  {
    "codigo": "750105",
    "descricao": "Supervisor de joalheria"
  },
  {
    "codigo": "750205",
    "descricao": "Supervisor da ind�stria de minerais n�o met�licos (exceto os derivados de petr�leo e carv�o)"
  },
  {
    "codigo": "751005",
    "descricao": "Engastador (j�ias)"
  },
  {
    "codigo": "751010",
    "descricao": "Joalheiro"
  },
  {
    "codigo": "751015",
    "descricao": "Joalheiro (repara��es)"
  },
  {
    "codigo": "751020",
    "descricao": "Lapidador (j�ias)"
  },
  {
    "codigo": "751105",
    "descricao": "Bate-folha a  m�quina"
  },
  {
    "codigo": "751110",
    "descricao": "Fundidor (joalheria e ourivesaria)"
  },
  {
    "codigo": "751115",
    "descricao": "Gravador (joalheria e ourivesaria)"
  },
  {
    "codigo": "751120",
    "descricao": "Laminador de metais preciosos a  m�o"
  },
  {
    "codigo": "751125",
    "descricao": "Ourives"
  },
  {
    "codigo": "751130",
    "descricao": "Trefilador (joalheria e ourivesaria)"
  },
  {
    "codigo": "752105",
    "descricao": "Artes�o modelador (vidros)"
  },
  {
    "codigo": "752110",
    "descricao": "Moldador (vidros)"
  },
  {
    "codigo": "752115",
    "descricao": "Soprador de vidro"
  },
  {
    "codigo": "752120",
    "descricao": "Transformador de tubos de vidro"
  },
  {
    "codigo": "752205",
    "descricao": "Aplicador serigr�fico em vidros"
  },
  {
    "codigo": "752210",
    "descricao": "Cortador de vidro"
  },
  {
    "codigo": "752215",
    "descricao": "Gravador de vidro a  �gua-forte"
  },
  {
    "codigo": "752220",
    "descricao": "Gravador de vidro a  esmeril"
  },
  {
    "codigo": "752225",
    "descricao": "Gravador de vidro a  jato de areia"
  },
  {
    "codigo": "752230",
    "descricao": "Lapidador de vidros e cristais"
  },
  {
    "codigo": "752235",
    "descricao": "Surfassagista"
  },
  {
    "codigo": "752305",
    "descricao": "Ceramista"
  },
  {
    "codigo": "752310",
    "descricao": "Ceramista (torno de pedal e motor)"
  },
  {
    "codigo": "752315",
    "descricao": "Ceramista (torno semi-autom�tico)"
  },
  {
    "codigo": "752320",
    "descricao": "Ceramista modelador"
  },
  {
    "codigo": "752325",
    "descricao": "Ceramista moldador"
  },
  {
    "codigo": "752330",
    "descricao": "Ceramista prensador"
  },
  {
    "codigo": "752405",
    "descricao": "Decorador de cer�mica"
  },
  {
    "codigo": "752410",
    "descricao": "Decorador de vidro"
  },
  {
    "codigo": "752415",
    "descricao": "Decorador de vidro � pincel"
  },
  {
    "codigo": "752420",
    "descricao": "Operador de esmaltadeira"
  },
  {
    "codigo": "752425",
    "descricao": "Operador de espelhamento"
  },
  {
    "codigo": "752430",
    "descricao": "Pintor de cer�mica, a  pincel"
  },
  {
    "codigo": "760105",
    "descricao": "Contramestre de acabamento (ind�stria t�xtil)"
  },
  {
    "codigo": "760110",
    "descricao": "Contramestre de fia��o (ind�stria t�xtil)"
  },
  {
    "codigo": "760115",
    "descricao": "Contramestre de malharia (ind�stria t�xtil)"
  },
  {
    "codigo": "760120",
    "descricao": "Contramestre de tecelagem (ind�stria t�xtil)"
  },
  {
    "codigo": "760125",
    "descricao": "Mestre (ind�stria t�xtil e de confec��es)"
  },
  {
    "codigo": "760205",
    "descricao": "Supervisor de curtimento"
  },
  {
    "codigo": "760305",
    "descricao": "Encarregado de corte na confec��o do vestu�rio"
  },
  {
    "codigo": "760310",
    "descricao": "Encarregado de costura na confec��o do vestu�rio"
  },
  {
    "codigo": "760405",
    "descricao": "Supervisor  (ind�stria de cal�ados e artefatos de couro)"
  },
  {
    "codigo": "760505",
    "descricao": "Supervisor da confec��o de artefatos de tecidos, couros e afins"
  },
  {
    "codigo": "760605",
    "descricao": "Supervisor das artes gr�ficas  (ind�stria editorial e gr�fica)"
  },
  {
    "codigo": "761005",
    "descricao": "Operador polivalente da ind�stria t�xtil"
  },
  {
    "codigo": "761105",
    "descricao": "Classificador de fibras t�xteis"
  },
  {
    "codigo": "761110",
    "descricao": "Lavador de l�"
  },
  {
    "codigo": "761205",
    "descricao": "Operador de abertura (fia��o)"
  },
  {
    "codigo": "761210",
    "descricao": "Operador de binadeira"
  },
  {
    "codigo": "761215",
    "descricao": "Operador de bobinadeira"
  },
  {
    "codigo": "761220",
    "descricao": "Operador de cardas"
  },
  {
    "codigo": "761225",
    "descricao": "Operador de conicaleira"
  },
  {
    "codigo": "761230",
    "descricao": "Operador de filat�rio"
  },
  {
    "codigo": "761235",
    "descricao": "Operador de laminadeira e reunideira"
  },
  {
    "codigo": "761240",
    "descricao": "Operador de ma�aroqueira"
  },
  {
    "codigo": "761245",
    "descricao": "Operador de open-end"
  },
  {
    "codigo": "761250",
    "descricao": "Operador de passador (fia��o)"
  },
  {
    "codigo": "761255",
    "descricao": "Operador de penteadeira"
  },
  {
    "codigo": "761260",
    "descricao": "Operador de retorcedeira"
  },
  {
    "codigo": "761303",
    "descricao": "Tecel�o (redes)"
  },
  {
    "codigo": "761306",
    "descricao": "Tecel�o (rendas e bordados)"
  },
  {
    "codigo": "761309",
    "descricao": "Tecel�o (tear autom�tico)"
  },
  {
    "codigo": "761312",
    "descricao": "Tecel�o (tear jacquard)"
  },
  {
    "codigo": "761315",
    "descricao": "Tecel�o (tear mec�nico de maquineta)"
  },
  {
    "codigo": "761318",
    "descricao": "Tecel�o (tear mec�nico de xadrez)"
  },
  {
    "codigo": "761321",
    "descricao": "Tecel�o (tear mec�nico liso)"
  },
  {
    "codigo": "761324",
    "descricao": "Tecel�o (tear mec�nico, exceto jacquard)"
  },
  {
    "codigo": "761327",
    "descricao": "Tecel�o de malhas, a  m�quina"
  },
  {
    "codigo": "761330",
    "descricao": "Tecel�o de malhas (m�quina circular)"
  },
  {
    "codigo": "761333",
    "descricao": "Tecel�o de malhas (m�quina retil�nea)"
  },
  {
    "codigo": "761336",
    "descricao": "Tecel�o de meias, a  m�quina"
  },
  {
    "codigo": "761339",
    "descricao": "Tecel�o de meias (m�quina circular)"
  },
  {
    "codigo": "761342",
    "descricao": "Tecel�o de meias (m�quina retil�nea)"
  },
  {
    "codigo": "761345",
    "descricao": "Tecel�o de tapetes, a  m�quina"
  },
  {
    "codigo": "761348",
    "descricao": "Operador de engomadeira de urdume"
  },
  {
    "codigo": "761351",
    "descricao": "Operador de espuladeira"
  },
  {
    "codigo": "761354",
    "descricao": "Operador de m�quina de cordoalha"
  },
  {
    "codigo": "761357",
    "descricao": "Operador de urdideira"
  },
  {
    "codigo": "761360",
    "descricao": "Passamaneiro a  m�quina"
  },
  {
    "codigo": "761363",
    "descricao": "Remetedor de fios"
  },
  {
    "codigo": "761366",
    "descricao": "Picotador de cart�es jacquard"
  },
  {
    "codigo": "761405",
    "descricao": "Alvejador (tecidos)"
  },
  {
    "codigo": "761410",
    "descricao": "Estampador de tecido"
  },
  {
    "codigo": "761415",
    "descricao": "Operador de calandras (tecidos)"
  },
  {
    "codigo": "761420",
    "descricao": "Operador de chamuscadeira de tecidos"
  },
  {
    "codigo": "761425",
    "descricao": "Operador de impermeabilizador de tecidos"
  },
  {
    "codigo": "761430",
    "descricao": "Operador de m�quina de lavar fios e tecidos"
  },
  {
    "codigo": "761435",
    "descricao": "Operador de rameuse"
  },
  {
    "codigo": "761805",
    "descricao": "Inspetor de estamparia (produ��o t�xtil)"
  },
  {
    "codigo": "761810",
    "descricao": "Revisor de fios (produ��o t�xtil)"
  },
  {
    "codigo": "761815",
    "descricao": "Revisor de tecidos acabados"
  },
  {
    "codigo": "761820",
    "descricao": "Revisor de tecidos crus"
  },
  {
    "codigo": "762005",
    "descricao": "Trabalhador polivalente do curtimento de couros e peles"
  },
  {
    "codigo": "762105",
    "descricao": "Classificador de peles"
  },
  {
    "codigo": "762110",
    "descricao": "Descarnador de couros e peles, � maquina"
  },
  {
    "codigo": "762115",
    "descricao": "Estirador de couros e peles (prepara��o)"
  },
  {
    "codigo": "762120",
    "descricao": "Fuloneiro"
  },
  {
    "codigo": "762125",
    "descricao": "Rachador de couros e peles"
  },
  {
    "codigo": "762205",
    "descricao": "Curtidor (couros e peles)"
  },
  {
    "codigo": "762210",
    "descricao": "Classificador de couros"
  },
  {
    "codigo": "762215",
    "descricao": "Enxugador de couros"
  },
  {
    "codigo": "762220",
    "descricao": "Rebaixador de couros"
  },
  {
    "codigo": "762305",
    "descricao": "Estirador de couros e peles (acabamento)"
  },
  {
    "codigo": "762310",
    "descricao": "Fuloneiro no acabamento de couros e peles"
  },
  {
    "codigo": "762315",
    "descricao": "Lixador de couros e peles"
  },
  {
    "codigo": "762320",
    "descricao": "Matizador de couros e peles"
  },
  {
    "codigo": "762325",
    "descricao": "Operador de m�quinas do acabamento de couros e peles"
  },
  {
    "codigo": "762330",
    "descricao": "Prensador de couros e peles"
  },
  {
    "codigo": "762335",
    "descricao": "Palecionador de couros e peles"
  },
  {
    "codigo": "762340",
    "descricao": "Preparador de couros curtidos"
  },
  {
    "codigo": "762345",
    "descricao": "Vaqueador de couros e peles"
  },
  {
    "codigo": "763005",
    "descricao": "Alfaiate"
  },
  {
    "codigo": "763010",
    "descricao": "Costureira de pe�as sob encomenda"
  },
  {
    "codigo": "763015",
    "descricao": "Costureira de repara��o de roupas"
  },
  {
    "codigo": "763020",
    "descricao": "Costureiro de roupa de couro e pele"
  },
  {
    "codigo": "763105",
    "descricao": "Auxiliar de corte (prepara��o da confec��o de roupas)"
  },
  {
    "codigo": "763110",
    "descricao": "Cortador de roupas"
  },
  {
    "codigo": "763115",
    "descricao": "Enfestador de roupas"
  },
  {
    "codigo": "763120",
    "descricao": "Riscador de roupas"
  },
  {
    "codigo": "763125",
    "descricao": "Ajudante de confec��o"
  },
  {
    "codigo": "763205",
    "descricao": "Costureiro de roupas de couro e pele, a  m�quina na  confec��o em s�rie"
  },
  {
    "codigo": "763210",
    "descricao": "Costureiro na confec��o em s�rie"
  },
  {
    "codigo": "763215",
    "descricao": "Costureiro, a  m�quina  na confec��o em s�rie"
  },
  {
    "codigo": "763305",
    "descricao": "Arrematadeira"
  },
  {
    "codigo": "763310",
    "descricao": "Bordador, � m�quina"
  },
  {
    "codigo": "763315",
    "descricao": "Marcador de pe�as confeccionadas para bordar"
  },
  {
    "codigo": "763320",
    "descricao": "Operador de m�quina de costura de acabamento"
  },
  {
    "codigo": "763325",
    "descricao": "Passadeira de pe�as confeccionadas"
  },
  {
    "codigo": "764005",
    "descricao": "Trabalhador polivalente da confec��o de cal�ados"
  },
  {
    "codigo": "764105",
    "descricao": "Cortador de cal�ados, a  m�quina (exceto solas e palmilhas)"
  },
  {
    "codigo": "764110",
    "descricao": "Cortador de solas e palmilhas, a  m�quina"
  },
  {
    "codigo": "764115",
    "descricao": "Preparador de cal�ados"
  },
  {
    "codigo": "764120",
    "descricao": "Preparador de solas e palmilhas"
  },
  {
    "codigo": "764205",
    "descricao": "Costurador de cal�ados, a  m�quina"
  },
  {
    "codigo": "764210",
    "descricao": "Montador de cal�ados"
  },
  {
    "codigo": "764305",
    "descricao": "Acabador de cal�ados"
  },
  {
    "codigo": "765005",
    "descricao": "Confeccionador de artefatos de couro (exceto sapatos)"
  },
  {
    "codigo": "765010",
    "descricao": "Chapeleiro de senhoras"
  },
  {
    "codigo": "765015",
    "descricao": "Boneleiro"
  },
  {
    "codigo": "765105",
    "descricao": "Cortador de artefatos de couro (exceto roupas e cal�ados)"
  },
  {
    "codigo": "765110",
    "descricao": "Cortador de tape�aria"
  },
  {
    "codigo": "765205",
    "descricao": "Colchoeiro (confec��o de colch�es)"
  },
  {
    "codigo": "765215",
    "descricao": "Confeccionador de brinquedos de pano"
  },
  {
    "codigo": "765225",
    "descricao": "Confeccionador de velas n�uticas, barracas e toldos"
  },
  {
    "codigo": "765230",
    "descricao": "Estofador de avi�es"
  },
  {
    "codigo": "765235",
    "descricao": "Estofador de m�veis"
  },
  {
    "codigo": "765240",
    "descricao": "Tapeceiro de autos"
  },
  {
    "codigo": "765310",
    "descricao": "Costurador de artefatos de couro, a  m�quina (exceto roupas e cal�ados)"
  },
  {
    "codigo": "765315",
    "descricao": "Montador de artefatos de couro (exceto roupas e cal�ados)"
  },
  {
    "codigo": "765405",
    "descricao": "Trabalhador do acabamento de artefatos de tecidos e couros"
  },
  {
    "codigo": "766105",
    "descricao": "Copiador de chapa"
  },
  {
    "codigo": "766115",
    "descricao": "Gravador de matriz para flexografia (clicherista)"
  },
  {
    "codigo": "766120",
    "descricao": "Editor de texto e imagem"
  },
  {
    "codigo": "766125",
    "descricao": "Montador de fotolito (anal�gico e digital)"
  },
  {
    "codigo": "766130",
    "descricao": "Gravador de matriz para rotogravura (eletromec�nico e qu�mico)"
  },
  {
    "codigo": "766135",
    "descricao": "Gravador de matriz calcogr�fica"
  },
  {
    "codigo": "766140",
    "descricao": "Gravador de matriz serigr�fica"
  },
  {
    "codigo": "766145",
    "descricao": "Operador de sistemas de prova (anal�gico e digital)"
  },
  {
    "codigo": "766150",
    "descricao": "Operador de processo de tratamento de imagem"
  },
  {
    "codigo": "766155",
    "descricao": "Programador visual gr�fico"
  },
  {
    "codigo": "766205",
    "descricao": "Impressor (serigrafia)"
  },
  {
    "codigo": "766210",
    "descricao": "Impressor calcogr�fico"
  },
  {
    "codigo": "766215",
    "descricao": "Impressor de ofsete (plano e rotativo)"
  },
  {
    "codigo": "766220",
    "descricao": "Impressor de rotativa"
  },
  {
    "codigo": "766225",
    "descricao": "Impressor de rotogravura"
  },
  {
    "codigo": "766230",
    "descricao": "Impressor digital"
  },
  {
    "codigo": "766235",
    "descricao": "Impressor flexogr�fico"
  },
  {
    "codigo": "766240",
    "descricao": "Impressor letterset"
  },
  {
    "codigo": "766245",
    "descricao": "Impressor tampogr�fico"
  },
  {
    "codigo": "766250",
    "descricao": "Impressor tipogr�fico"
  },
  {
    "codigo": "766305",
    "descricao": "Acabador de embalagens (flex�veis e cartot�cnicas)"
  },
  {
    "codigo": "766310",
    "descricao": "Impressor de corte e vinco"
  },
  {
    "codigo": "766315",
    "descricao": "Operador de acabamento (ind�stria gr�fica)"
  },
  {
    "codigo": "766320",
    "descricao": "Operador de guilhotina (corte de papel)"
  },
  {
    "codigo": "766325",
    "descricao": "Preparador de matrizes de corte e vinco"
  },
  {
    "codigo": "766405",
    "descricao": "Laboratorista fotogr�fico"
  },
  {
    "codigo": "766410",
    "descricao": "Revelador de filmes fotogr�ficos, em preto e branco"
  },
  {
    "codigo": "766415",
    "descricao": "Revelador de filmes fotogr�ficos, em cores"
  },
  {
    "codigo": "766420",
    "descricao": "Auxiliar de radiologia (revela��o fotogr�fica)"
  },
  {
    "codigo": "768105",
    "descricao": "Tecel�o (tear manual)"
  },
  {
    "codigo": "768110",
    "descricao": "Tecel�o de tapetes, a  m�o"
  },
  {
    "codigo": "768115",
    "descricao": "Tricoteiro, � m�o"
  },
  {
    "codigo": "768120",
    "descricao": "Redeiro"
  },
  {
    "codigo": "768125",
    "descricao": "Chapeleiro (chap�us de palha)"
  },
  {
    "codigo": "768130",
    "descricao": "Crocheteiro, a  m�o"
  },
  {
    "codigo": "768205",
    "descricao": "Bordador, a  m�o"
  },
  {
    "codigo": "768210",
    "descricao": "Cerzidor"
  },
  {
    "codigo": "768305",
    "descricao": "Art�fice do couro"
  },
  {
    "codigo": "768310",
    "descricao": "Cortador de cal�ados, a  m�o (exceto solas)"
  },
  {
    "codigo": "768315",
    "descricao": "Costurador de artefatos de couro, a  m�o (exceto roupas e cal�ados)"
  },
  {
    "codigo": "768320",
    "descricao": "Sapateiro (cal�ados sob medida)"
  },
  {
    "codigo": "768325",
    "descricao": "Seleiro"
  },
  {
    "codigo": "768605",
    "descricao": "Tip�grafo"
  },
  {
    "codigo": "768610",
    "descricao": "Linotipista"
  },
  {
    "codigo": "768615",
    "descricao": "Monotipista"
  },
  {
    "codigo": "768620",
    "descricao": "Paginador"
  },
  {
    "codigo": "768625",
    "descricao": "Pintor de letreiros"
  },
  {
    "codigo": "768630",
    "descricao": "Confeccionador de carimbos de borracha"
  },
  {
    "codigo": "768705",
    "descricao": "Gravador, � m�o (encaderna��o)"
  },
  {
    "codigo": "768710",
    "descricao": "Restaurador de livros"
  },
  {
    "codigo": "770105",
    "descricao": "Mestre (ind�stria de madeira e mobili�rio)"
  },
  {
    "codigo": "770110",
    "descricao": "Mestre carpinteiro"
  },
  {
    "codigo": "771105",
    "descricao": "Marceneiro"
  },
  {
    "codigo": "771110",
    "descricao": "Modelador de madeira"
  },
  {
    "codigo": "771115",
    "descricao": "Maquetista na marcenaria"
  },
  {
    "codigo": "771120",
    "descricao": "Tanoeiro"
  },
  {
    "codigo": "772105",
    "descricao": "Classificador de madeira"
  },
  {
    "codigo": "772110",
    "descricao": "Impregnador de madeira"
  },
  {
    "codigo": "772115",
    "descricao": "Secador de madeira"
  },
  {
    "codigo": "773105",
    "descricao": "Cortador de laminados de madeira"
  },
  {
    "codigo": "773110",
    "descricao": "Operador de serras no desdobramento de madeira"
  },
  {
    "codigo": "773115",
    "descricao": "Serrador de bordas no desdobramento de madeira"
  },
  {
    "codigo": "773120",
    "descricao": "Serrador de madeira"
  },
  {
    "codigo": "773125",
    "descricao": "Serrador de madeira (serra circular m�ltipla)"
  },
  {
    "codigo": "773130",
    "descricao": "Serrador de madeira (serra de fita m�ltipla)"
  },
  {
    "codigo": "773205",
    "descricao": "Operador de m�quina intercaladora de placas (compensados)"
  },
  {
    "codigo": "773210",
    "descricao": "Prensista de aglomerados"
  },
  {
    "codigo": "773215",
    "descricao": "Prensista de compensados"
  },
  {
    "codigo": "773220",
    "descricao": "Preparador de aglomerantes"
  },
  {
    "codigo": "773305",
    "descricao": "Operador de desempenadeira na usinagem convencional de madeira"
  },
  {
    "codigo": "773310",
    "descricao": "Operador de entalhadeira (usinagem de madeira)"
  },
  {
    "codigo": "773315",
    "descricao": "Operador de fresadora (usinagem de madeira)"
  },
  {
    "codigo": "773320",
    "descricao": "Operador de lixadeira (usinagem de madeira)"
  },
  {
    "codigo": "773325",
    "descricao": "Operador de m�quina de usinagem madeira, em geral"
  },
  {
    "codigo": "773330",
    "descricao": "Operador de molduradora (usinagem de madeira)"
  },
  {
    "codigo": "773335",
    "descricao": "Operador de plaina desengrossadeira"
  },
  {
    "codigo": "773340",
    "descricao": "Operador de serras (usinagem de madeira)"
  },
  {
    "codigo": "773345",
    "descricao": "Operador de torno autom�tico (usinagem de madeira)"
  },
  {
    "codigo": "773350",
    "descricao": "Operador de tupia (usinagem de madeira)"
  },
  {
    "codigo": "773355",
    "descricao": "Torneiro na usinagem convencional de madeira"
  },
  {
    "codigo": "773405",
    "descricao": "Operador de m�quina bordatriz"
  },
  {
    "codigo": "773410",
    "descricao": "Operador de m�quina de cortina d��gua (produ��o de m�veis)"
  },
  {
    "codigo": "773415",
    "descricao": "Operador de m�quina de usinagem de madeira (produ��o em s�rie)"
  },
  {
    "codigo": "773420",
    "descricao": "Operador de prensa de alta freq��ncia na usinagem de madeira"
  },
  {
    "codigo": "773505",
    "descricao": "Operador de centro de usinagem de madeira (cnc)"
  },
  {
    "codigo": "773510",
    "descricao": "Operador de m�quinas de usinar madeira (cnc)"
  },
  {
    "codigo": "774105",
    "descricao": "Montador de m�veis e artefatos de madeira"
  },
  {
    "codigo": "775105",
    "descricao": "Entalhador  de madeira"
  },
  {
    "codigo": "775110",
    "descricao": "Folheador de m�veis de madeira"
  },
  {
    "codigo": "775115",
    "descricao": "Lustrador de pe�as de madeira"
  },
  {
    "codigo": "775120",
    "descricao": "Marcheteiro"
  },
  {
    "codigo": "776405",
    "descricao": "Cesteiro"
  },
  {
    "codigo": "776410",
    "descricao": "Confeccionador de escovas, pinc�is e produtos similares (a m�o)"
  },
  {
    "codigo": "776415",
    "descricao": "Confeccionador de escovas, pinc�is e produtos similares (a m�quina)"
  },
  {
    "codigo": "776420",
    "descricao": "Confeccionador de m�veis de vime, junco e bambu"
  },
  {
    "codigo": "776425",
    "descricao": "Esteireiro"
  },
  {
    "codigo": "776430",
    "descricao": "Vassoureiro"
  },
  {
    "codigo": "777105",
    "descricao": "Carpinteiro naval (constru��o de pequenas embarca��es)"
  },
  {
    "codigo": "777110",
    "descricao": "Carpinteiro naval (embarca��es)"
  },
  {
    "codigo": "777115",
    "descricao": "Carpinteiro naval (estaleiros)"
  },
  {
    "codigo": "777205",
    "descricao": "Carpinteiro de carretas"
  },
  {
    "codigo": "777210",
    "descricao": "Carpinteiro de carrocerias"
  },
  {
    "codigo": "780105",
    "descricao": "Supervisor de embalagem e etiquetagem"
  },
  {
    "codigo": "781105",
    "descricao": "Condutor de processos robotizados de pintura"
  },
  {
    "codigo": "781110",
    "descricao": "Condutor de processos robotizados de soldagem"
  },
  {
    "codigo": "781305",
    "descricao": "Operador de ve�culos subaqu�ticos controlados remotamente"
  },
  {
    "codigo": "781310",
    "descricao": "Operador de aeronaves n�o tripuladas"
  },
  {
    "codigo": "781705",
    "descricao": "Mergulhador profissional (raso e profundo)"
  },
  {
    "codigo": "782105",
    "descricao": "Operador de draga"
  },
  {
    "codigo": "782110",
    "descricao": "Operador de guindaste (fixo)"
  },
  {
    "codigo": "782115",
    "descricao": "Operador de guindaste m�vel"
  },
  {
    "codigo": "782120",
    "descricao": "Operador de m�quina rodoferrovi�ria"
  },
  {
    "codigo": "782125",
    "descricao": "Operador de monta-cargas (constru��o civil)"
  },
  {
    "codigo": "782130",
    "descricao": "Operador de ponte rolante"
  },
  {
    "codigo": "782135",
    "descricao": "Operador de p�rtico rolante"
  },
  {
    "codigo": "782140",
    "descricao": "Operador de talha el�trica"
  },
  {
    "codigo": "782145",
    "descricao": "Sinaleiro (ponte-rolante)"
  },
  {
    "codigo": "782205",
    "descricao": "Guincheiro (constru��o civil)"
  },
  {
    "codigo": "782210",
    "descricao": "Operador de docagem"
  },
  {
    "codigo": "782220",
    "descricao": "Operador de empilhadeira"
  },
  {
    "codigo": "782305",
    "descricao": "Motorista de carro de passeio"
  },
  {
    "codigo": "782310",
    "descricao": "Motorista de furg�o ou ve�culo similar"
  },
  {
    "codigo": "782315",
    "descricao": "Motorista de t�xi"
  },
  {
    "codigo": "782320",
    "descricao": "Condutor de ambul�ncia"
  },
  {
    "codigo": "782405",
    "descricao": "Motorista de �nibus rodovi�rio"
  },
  {
    "codigo": "782410",
    "descricao": "Motorista de �nibus urbano"
  },
  {
    "codigo": "782415",
    "descricao": "Motorista de tr�lebus"
  },
  {
    "codigo": "782505",
    "descricao": "Caminhoneiro aut�nomo (rotas regionais e internacionais)"
  },
  {
    "codigo": "782510",
    "descricao": "Motorista de caminh�o (rotas regionais e internacionais)"
  },
  {
    "codigo": "782515",
    "descricao": "Motorista operacional de guincho"
  },
  {
    "codigo": "782605",
    "descricao": "Operador de trem de metr�"
  },
  {
    "codigo": "782610",
    "descricao": "Maquinista de trem"
  },
  {
    "codigo": "782615",
    "descricao": "Maquinista de trem metropolitano"
  },
  {
    "codigo": "782620",
    "descricao": "Motorneiro"
  },
  {
    "codigo": "782625",
    "descricao": "Auxiliar de maquinista de trem"
  },
  {
    "codigo": "782630",
    "descricao": "Operador de telef�rico (passageiros)"
  },
  {
    "codigo": "782705",
    "descricao": "Marinheiro de conv�s (mar�timo e fluvi�rio)"
  },
  {
    "codigo": "782710",
    "descricao": "Marinheiro de m�quinas"
  },
  {
    "codigo": "782715",
    "descricao": "Mo�o de conv�s (mar�timo e fluvi�rio)"
  },
  {
    "codigo": "782720",
    "descricao": "Mo�o de m�quinas (mar�timo e fluvi�rio)"
  },
  {
    "codigo": "782725",
    "descricao": "Marinheiro de esporte e recreio"
  },
  {
    "codigo": "782730",
    "descricao": "Marinheiro auxiliar de conv�s (mar�timo e aquaviario)"
  },
  {
    "codigo": "782735",
    "descricao": "Marinheiro auxiliar de m�quinas (mar�timo e aquavi�rio)"
  },
  {
    "codigo": "782805",
    "descricao": "Condutor de ve�culos de tra��o animal (ruas e estradas)"
  },
  {
    "codigo": "782810",
    "descricao": "Tropeiro"
  },
  {
    "codigo": "782815",
    "descricao": "Boiadeiro"
  },
  {
    "codigo": "782820",
    "descricao": "Condutor de ve�culos a pedais"
  },
  {
    "codigo": "783105",
    "descricao": "Agente de p�tio"
  },
  {
    "codigo": "783110",
    "descricao": "Manobrador"
  },
  {
    "codigo": "783205",
    "descricao": "Carregador (aeronaves)"
  },
  {
    "codigo": "783210",
    "descricao": "Carregador (armaz�m)"
  },
  {
    "codigo": "783215",
    "descricao": "Carregador (ve�culos de transportes terrestres)"
  },
  {
    "codigo": "783220",
    "descricao": "Estivador"
  },
  {
    "codigo": "783225",
    "descricao": "Ajudante de motorista"
  },
  {
    "codigo": "783230",
    "descricao": "Bloqueiro (trabalhador portu�rio)"
  },
  {
    "codigo": "783235",
    "descricao": "Trabalhador portu�rio de capatazia"
  },
  {
    "codigo": "783240",
    "descricao": "Amarrador e desamarrado de embarca��es"
  },
  {
    "codigo": "784105",
    "descricao": "Embalador, a m�o"
  },
  {
    "codigo": "784110",
    "descricao": "Embalador, a m�quina"
  },
  {
    "codigo": "784115",
    "descricao": "Operador de m�quina de etiquetar"
  },
  {
    "codigo": "784120",
    "descricao": "Operador de m�quina de envasar l�quidos"
  },
  {
    "codigo": "784125",
    "descricao": "Operador de prensa de enfardamento"
  },
  {
    "codigo": "784205",
    "descricao": "Alimentador de linha de produ��o"
  },
  {
    "codigo": "791105",
    "descricao": "Artes�o bordador"
  },
  {
    "codigo": "791110",
    "descricao": "Artes�o ceramista"
  },
  {
    "codigo": "791115",
    "descricao": "Artes�o com material recicl�vel"
  },
  {
    "codigo": "791120",
    "descricao": "Artes�o confeccionador de bioj�ias e ecoj�ias"
  },
  {
    "codigo": "791125",
    "descricao": "Artes�o do couro"
  },
  {
    "codigo": "791130",
    "descricao": "Artes�o escultor"
  },
  {
    "codigo": "791135",
    "descricao": "Artes�o moveleiro (exceto reciclado)"
  },
  {
    "codigo": "791140",
    "descricao": "Artes�o tecel�o"
  },
  {
    "codigo": "791145",
    "descricao": "Artes�o tran�ador"
  },
  {
    "codigo": "791150",
    "descricao": "Artes�o crocheteiro"
  },
  {
    "codigo": "791155",
    "descricao": "Artes�o tricoteiro"
  },
  {
    "codigo": "791160",
    "descricao": "Artes�o rendeiro"
  },
  {
    "codigo": "810105",
    "descricao": "Mestre (ind�stria petroqu�mica e carboqu�mica)"
  },
  {
    "codigo": "810110",
    "descricao": "Mestre de produ��o qu�mica"
  },
  {
    "codigo": "810205",
    "descricao": "Mestre (ind�stria de borracha e pl�stico)"
  },
  {
    "codigo": "810305",
    "descricao": "Mestre de produ��o farmac�utica"
  },
  {
    "codigo": "811005",
    "descricao": "Operador de processos qu�micos e petroqu�micos"
  },
  {
    "codigo": "811010",
    "descricao": "Operador de sala de controle de instala��es qu�micas, petroqu�micas e afins"
  },
  {
    "codigo": "811105",
    "descricao": "Moleiro (tratamentos qu�micos e afins)"
  },
  {
    "codigo": "811110",
    "descricao": "Operador de m�quina misturadeira (tratamentos qu�micos e afins)"
  },
  {
    "codigo": "811115",
    "descricao": "Operador de britadeira (tratamentos qu�micos e afins)"
  },
  {
    "codigo": "811120",
    "descricao": "Operador de concentra��o"
  },
  {
    "codigo": "811125",
    "descricao": "Trabalhador da fabrica��o de resinas e vernizes"
  },
  {
    "codigo": "811130",
    "descricao": "Trabalhador de fabrica��o de tintas"
  },
  {
    "codigo": "811205",
    "descricao": "Operador de calcina��o (tratamento qu�mico e afins)"
  },
  {
    "codigo": "811215",
    "descricao": "Operador de tratamento qu�mico de materiais radioativos"
  },
  {
    "codigo": "811305",
    "descricao": "Operador de centrifugadora (tratamentos qu�micos e afins)"
  },
  {
    "codigo": "811310",
    "descricao": "Operador de explora��o de petr�leo"
  },
  {
    "codigo": "811315",
    "descricao": "Operador de filtro de secagem (minera��o)"
  },
  {
    "codigo": "811320",
    "descricao": "Operador de filtro de tambor rotativo (tratamentos qu�micos e afins)"
  },
  {
    "codigo": "811325",
    "descricao": "Operador de filtro-esteira (minera��o)"
  },
  {
    "codigo": "811330",
    "descricao": "Operador de filtro-prensa (tratamentos qu�micos e afins)"
  },
  {
    "codigo": "811335",
    "descricao": "Operador de filtros de parafina (tratamentos qu�micos e afins)"
  },
  {
    "codigo": "811405",
    "descricao": "Destilador de madeira"
  },
  {
    "codigo": "811410",
    "descricao": "Destilador de produtos qu�micos (exceto petr�leo)"
  },
  {
    "codigo": "811415",
    "descricao": "Operador de alambique de funcionamento cont�nuo (produtos qu�micos, exceto petr�leo)"
  },
  {
    "codigo": "811420",
    "descricao": "Operador de aparelho de rea��o e convers�o (produtos qu�micos, exceto petr�leo)"
  },
  {
    "codigo": "811425",
    "descricao": "Operador de equipamento de destila��o de �lcool"
  },
  {
    "codigo": "811430",
    "descricao": "Operador de evaporador na destila��o"
  },
  {
    "codigo": "811505",
    "descricao": "Operador de painel de controle (refina��o de petr�leo)"
  },
  {
    "codigo": "811510",
    "descricao": "Operador de transfer�ncia e estocagem - na refina��o do petr�leo"
  },
  {
    "codigo": "811605",
    "descricao": "Operador de britador de coque"
  },
  {
    "codigo": "811610",
    "descricao": "Operador de carro de apagamento e coque"
  },
  {
    "codigo": "811615",
    "descricao": "Operador de destila��o e subprodutos de coque"
  },
  {
    "codigo": "811620",
    "descricao": "Operador de enfornamento e desenfornamento de coque"
  },
  {
    "codigo": "811625",
    "descricao": "Operador de exaustor (coqueria)"
  },
  {
    "codigo": "811630",
    "descricao": "Operador de painel de controle"
  },
  {
    "codigo": "811635",
    "descricao": "Operador de preserva��o e controle t�rmico"
  },
  {
    "codigo": "811640",
    "descricao": "Operador de reator de coque de petr�leo"
  },
  {
    "codigo": "811645",
    "descricao": "Operador de refrigera��o (coqueria)"
  },
  {
    "codigo": "811650",
    "descricao": "Operador de sistema de revers�o (coqueria)"
  },
  {
    "codigo": "811705",
    "descricao": "Bamburista"
  },
  {
    "codigo": "811710",
    "descricao": "Calandrista de borracha"
  },
  {
    "codigo": "811715",
    "descricao": "Confeccionador de pneum�ticos"
  },
  {
    "codigo": "811725",
    "descricao": "Confeccionador de velas por imers�o"
  },
  {
    "codigo": "811735",
    "descricao": "Confeccionador de velas por moldagem"
  },
  {
    "codigo": "811745",
    "descricao": "Laminador de pl�stico"
  },
  {
    "codigo": "811750",
    "descricao": "Moldador de borracha por compress�o"
  },
  {
    "codigo": "811760",
    "descricao": "Moldador de pl�stico por compress�o"
  },
  {
    "codigo": "811770",
    "descricao": "Moldador de pl�stico por inje��o"
  },
  {
    "codigo": "811775",
    "descricao": "Trefilador de borracha"
  },
  {
    "codigo": "811805",
    "descricao": "Operador de m�quina de produtos farmac�uticos"
  },
  {
    "codigo": "811810",
    "descricao": "Drageador (medicamentos)"
  },
  {
    "codigo": "811815",
    "descricao": "Operador de m�quina de fabrica��o de cosm�ticos"
  },
  {
    "codigo": "811820",
    "descricao": "Operador de m�quina de fabrica��o de produtos de higiene e limpeza (sab�o, sabonete, detergente, absorvente, fraldas cotonetes e outros)"
  },
  {
    "codigo": "812105",
    "descricao": "Pirot�cnico"
  },
  {
    "codigo": "812110",
    "descricao": "Trabalhador da fabrica��o de muni��o e explosivos"
  },
  {
    "codigo": "813105",
    "descricao": "Cilindrista (petroqu�mica e afins)"
  },
  {
    "codigo": "813110",
    "descricao": "Operador de calandra (qu�mica, petroqu�mica e afins)"
  },
  {
    "codigo": "813115",
    "descricao": "Operador de extrusora (qu�mica, petroqu�mica e afins)"
  },
  {
    "codigo": "813120",
    "descricao": "Operador de processo (qu�mica, petroqu�mica e afins)"
  },
  {
    "codigo": "813125",
    "descricao": "Operador de produ��o (qu�mica, petroqu�mica e afins)"
  },
  {
    "codigo": "813130",
    "descricao": "T�cnico de opera��o (qu�mica, petroqu�mica e afins)"
  },
  {
    "codigo": "818105",
    "descricao": "Assistente de laborat�rio industrial"
  },
  {
    "codigo": "818110",
    "descricao": "Auxiliar de laborat�rio de an�lises f�sico-qu�micas"
  },
  {
    "codigo": "820105",
    "descricao": "Mestre de siderurgia"
  },
  {
    "codigo": "820110",
    "descricao": "Mestre de aciaria"
  },
  {
    "codigo": "820115",
    "descricao": "Mestre de alto-forno"
  },
  {
    "codigo": "820120",
    "descricao": "Mestre de forno el�trico"
  },
  {
    "codigo": "820125",
    "descricao": "Mestre de lamina��o"
  },
  {
    "codigo": "820205",
    "descricao": "Supervisor de fabrica��o de produtos cer�micos, porcelanatos e afins"
  },
  {
    "codigo": "820210",
    "descricao": "Supervisor de fabrica��o de produtos de vidro"
  },
  {
    "codigo": "821105",
    "descricao": "Operador de centro de controle ( sinteriza��o)"
  },
  {
    "codigo": "821110",
    "descricao": "Operador de m�quina de sinterizar"
  },
  {
    "codigo": "821205",
    "descricao": "Forneiro e operador (alto-forno)"
  },
  {
    "codigo": "821210",
    "descricao": "Forneiro e operador (conversor a oxig�nio)"
  },
  {
    "codigo": "821215",
    "descricao": "Forneiro e operador (forno el�trico)"
  },
  {
    "codigo": "821220",
    "descricao": "Forneiro e operador (refino de metais n�o-ferrosos)"
  },
  {
    "codigo": "821225",
    "descricao": "Forneiro e operador de forno de redu��o direta"
  },
  {
    "codigo": "821230",
    "descricao": "Operador de aciaria (basculamento de convertedor)"
  },
  {
    "codigo": "821235",
    "descricao": "Operador de aciaria (dessulfura��o de gusa)"
  },
  {
    "codigo": "821240",
    "descricao": "Operador de aciaria (recebimento de gusa)"
  },
  {
    "codigo": "821245",
    "descricao": "Operador de �rea de corrida"
  },
  {
    "codigo": "821250",
    "descricao": "Operador de desgaseifica��o"
  },
  {
    "codigo": "821255",
    "descricao": "Soprador de convertedor"
  },
  {
    "codigo": "821305",
    "descricao": "Operador de laminador"
  },
  {
    "codigo": "821310",
    "descricao": "Operador de laminador de barras a frio"
  },
  {
    "codigo": "821315",
    "descricao": "Operador de laminador de barras a quente"
  },
  {
    "codigo": "821320",
    "descricao": "Operador de laminador de metais n�o-ferrosos"
  },
  {
    "codigo": "821325",
    "descricao": "Operador de laminador de tubos"
  },
  {
    "codigo": "821330",
    "descricao": "Operador de montagem de cilindros e mancais"
  },
  {
    "codigo": "821335",
    "descricao": "Recuperador de guias e cilindros"
  },
  {
    "codigo": "821405",
    "descricao": "Encarregado de acabamento de chapas e metais  (t�mpera)"
  },
  {
    "codigo": "821410",
    "descricao": "Escarfador"
  },
  {
    "codigo": "821415",
    "descricao": "Marcador de produtos (sider�rgico e metal�rgico)"
  },
  {
    "codigo": "821420",
    "descricao": "Operador de bobinadeira de tiras a quente, no acabamento de chapas e metais"
  },
  {
    "codigo": "821425",
    "descricao": "Operador de cabine de lamina��o (fio-m�quina)"
  },
  {
    "codigo": "821430",
    "descricao": "Operador de esc�ria e sucata"
  },
  {
    "codigo": "821435",
    "descricao": "Operador de jato abrasivo"
  },
  {
    "codigo": "821440",
    "descricao": "Operador de tesoura mec�nica e m�quina de corte, no acabamento de chapas e metais"
  },
  {
    "codigo": "821445",
    "descricao": "Preparador de sucata e aparas"
  },
  {
    "codigo": "821450",
    "descricao": "Rebarbador de metal"
  },
  {
    "codigo": "822105",
    "descricao": "Forneiro de cubil�"
  },
  {
    "codigo": "822110",
    "descricao": "Forneiro de forno-po�o"
  },
  {
    "codigo": "822115",
    "descricao": "Forneiro de fundi��o (forno de redu��o)"
  },
  {
    "codigo": "822120",
    "descricao": "Forneiro de reaquecimento e tratamento t�rmico na metalurgia"
  },
  {
    "codigo": "822125",
    "descricao": "Forneiro de rev�rbero"
  },
  {
    "codigo": "823105",
    "descricao": "Preparador de massa (fabrica��o de abrasivos)"
  },
  {
    "codigo": "823110",
    "descricao": "Preparador de massa (fabrica��o de vidro)"
  },
  {
    "codigo": "823115",
    "descricao": "Preparador de massa de argila"
  },
  {
    "codigo": "823120",
    "descricao": "Preparador de barbotina"
  },
  {
    "codigo": "823125",
    "descricao": "Preparador de esmaltes (cer�mica)"
  },
  {
    "codigo": "823130",
    "descricao": "Preparador de aditivos"
  },
  {
    "codigo": "823135",
    "descricao": "Operador de atomizador"
  },
  {
    "codigo": "823210",
    "descricao": "Extrusor de fios ou fibras de vidro"
  },
  {
    "codigo": "823215",
    "descricao": "Forneiro na fundi��o de vidro"
  },
  {
    "codigo": "823220",
    "descricao": "Forneiro no recozimento de vidro"
  },
  {
    "codigo": "823230",
    "descricao": "Moldador de abrasivos na fabrica��o de cer�mica, vidro e porcelana"
  },
  {
    "codigo": "823235",
    "descricao": "Operador de banho met�lico de vidro por flutua��o"
  },
  {
    "codigo": "823240",
    "descricao": "Operador de m�quina de soprar vidro"
  },
  {
    "codigo": "823245",
    "descricao": "Operador de m�quina extrusora de varetas e tubos de vidro"
  },
  {
    "codigo": "823250",
    "descricao": "Operador de prensa de moldar vidro"
  },
  {
    "codigo": "823255",
    "descricao": "Temperador de vidro"
  },
  {
    "codigo": "823265",
    "descricao": "Trabalhador na fabrica��o de produtos abrasivos"
  },
  {
    "codigo": "823305",
    "descricao": "Classificador e empilhador de tijolos refrat�rios"
  },
  {
    "codigo": "823315",
    "descricao": "Forneiro (materiais de constru��o)"
  },
  {
    "codigo": "823320",
    "descricao": "Trabalhador da elabora��o de pr�-fabricados (cimento amianto)"
  },
  {
    "codigo": "823325",
    "descricao": "Trabalhador da elabora��o de pr�-fabricados (concreto armado)"
  },
  {
    "codigo": "823330",
    "descricao": "Trabalhador da fabrica��o de pedras artificiais"
  },
  {
    "codigo": "828105",
    "descricao": "Oleiro (fabrica��o de telhas)"
  },
  {
    "codigo": "828110",
    "descricao": "Oleiro (fabrica��o de tijolos)"
  },
  {
    "codigo": "830105",
    "descricao": "Mestre (ind�stria de celulose, papel e papel�o)"
  },
  {
    "codigo": "831105",
    "descricao": "Cilindreiro na prepara��o de pasta para fabrica��o de papel"
  },
  {
    "codigo": "831110",
    "descricao": "Operador de branqueador de pasta para fabrica��o de papel"
  },
  {
    "codigo": "831115",
    "descricao": "Operador de digestor de pasta para fabrica��o de papel"
  },
  {
    "codigo": "831120",
    "descricao": "Operador de lavagem e depura��o de pasta para fabrica��o de papel"
  },
  {
    "codigo": "831125",
    "descricao": "Operador de m�quina de secar celulose"
  },
  {
    "codigo": "832105",
    "descricao": "Calandrista de papel"
  },
  {
    "codigo": "832110",
    "descricao": "Operador de cortadeira de papel"
  },
  {
    "codigo": "832115",
    "descricao": "Operador de m�quina de fabricar papel  (fase �mida)"
  },
  {
    "codigo": "832120",
    "descricao": "Operador de m�quina de fabricar papel (fase seca)"
  },
  {
    "codigo": "832125",
    "descricao": "Operador de m�quina de fabricar papel e papel�o"
  },
  {
    "codigo": "832135",
    "descricao": "Operador de rebobinadeira na fabrica��o de papel e papel�o"
  },
  {
    "codigo": "833105",
    "descricao": "Cartonageiro, a m�quina"
  },
  {
    "codigo": "833110",
    "descricao": "Confeccionador de bolsas, sacos e sacolas e papel, a m�quina"
  },
  {
    "codigo": "833115",
    "descricao": "Confeccionador de sacos de celofane, a m�quina"
  },
  {
    "codigo": "833120",
    "descricao": "Operador de m�quina de cortar e dobrar papel�o"
  },
  {
    "codigo": "833125",
    "descricao": "Operador de prensa de embutir papel�o"
  },
  {
    "codigo": "833205",
    "descricao": "Cartonageiro, a m�o (caixas de papel�o)"
  },
  {
    "codigo": "840105",
    "descricao": "Supervisor de produ��o da ind�stria aliment�cia"
  },
  {
    "codigo": "840110",
    "descricao": "Supervisor da ind�stria de bebidas"
  },
  {
    "codigo": "840115",
    "descricao": "Supervisor da ind�stria de fumo"
  },
  {
    "codigo": "840120",
    "descricao": "Chefe de confeitaria"
  },
  {
    "codigo": "841105",
    "descricao": "Moleiro de cereais (exceto arroz)"
  },
  {
    "codigo": "841110",
    "descricao": "Moleiro de especiarias"
  },
  {
    "codigo": "841115",
    "descricao": "Operador de processo de moagem"
  },
  {
    "codigo": "841205",
    "descricao": "Moedor de sal"
  },
  {
    "codigo": "841210",
    "descricao": "Refinador de sal"
  },
  {
    "codigo": "841305",
    "descricao": "Operador de cristaliza��o na refina��o de a�ucar"
  },
  {
    "codigo": "841310",
    "descricao": "Operador de equipamentos de refina��o de a��car (processo cont�nuo)"
  },
  {
    "codigo": "841315",
    "descricao": "Operador de moenda na fabrica��o de a��car"
  },
  {
    "codigo": "841320",
    "descricao": "Operador de tratamento de calda na refina��o de a��car"
  },
  {
    "codigo": "841408",
    "descricao": "Cozinhador (conserva��o de alimentos)"
  },
  {
    "codigo": "841416",
    "descricao": "Cozinhador de carnes"
  },
  {
    "codigo": "841420",
    "descricao": "Cozinhador de frutas e legumes"
  },
  {
    "codigo": "841428",
    "descricao": "Cozinhador de pescado"
  },
  {
    "codigo": "841432",
    "descricao": "Desidratador de alimentos"
  },
  {
    "codigo": "841440",
    "descricao": "Esterilizador de alimentos"
  },
  {
    "codigo": "841444",
    "descricao": "Hidrogenador de �leos e gorduras"
  },
  {
    "codigo": "841448",
    "descricao": "Lagareiro"
  },
  {
    "codigo": "841456",
    "descricao": "Operador de c�maras frias"
  },
  {
    "codigo": "841460",
    "descricao": "Operador de prepara��o de gr�os vegetais (�leos e gorduras)"
  },
  {
    "codigo": "841464",
    "descricao": "Prensador de frutas (exceto oleaginosas)"
  },
  {
    "codigo": "841468",
    "descricao": "Preparador de ra��es"
  },
  {
    "codigo": "841472",
    "descricao": "Refinador de �leo e gordura"
  },
  {
    "codigo": "841476",
    "descricao": "Trabalhador de fabrica��o de margarina"
  },
  {
    "codigo": "841484",
    "descricao": "Trabalhador de prepara��o de pescados (limpeza)"
  },
  {
    "codigo": "841505",
    "descricao": "Trabalhador de tratamento do leite e fabrica��o de latic�nios e afins"
  },
  {
    "codigo": "841605",
    "descricao": "Misturador de caf�"
  },
  {
    "codigo": "841610",
    "descricao": "Torrador de caf�"
  },
  {
    "codigo": "841615",
    "descricao": "Moedor de caf�"
  },
  {
    "codigo": "841620",
    "descricao": "Operador de extra��o de caf� sol�vel"
  },
  {
    "codigo": "841625",
    "descricao": "Torrador de cacau"
  },
  {
    "codigo": "841630",
    "descricao": "Misturador de ch� ou mate"
  },
  {
    "codigo": "841705",
    "descricao": "Alambiqueiro"
  },
  {
    "codigo": "841710",
    "descricao": "Filtrador de cerveja"
  },
  {
    "codigo": "841715",
    "descricao": "Fermentador"
  },
  {
    "codigo": "841720",
    "descricao": "Trabalhador de fabrica��o de vinhos"
  },
  {
    "codigo": "841725",
    "descricao": "Malteiro (germina��o)"
  },
  {
    "codigo": "841730",
    "descricao": "Cozinhador de malte"
  },
  {
    "codigo": "841735",
    "descricao": "Dessecador de malte"
  },
  {
    "codigo": "841740",
    "descricao": "Vinagreiro"
  },
  {
    "codigo": "841745",
    "descricao": "Xaropeiro"
  },
  {
    "codigo": "841805",
    "descricao": "Operador de forno (fabrica��o de p�es, biscoitos e similares)"
  },
  {
    "codigo": "841810",
    "descricao": "Operador de m�quinas de fabrica��o de doces, salgados e massas aliment�cias"
  },
  {
    "codigo": "841815",
    "descricao": "Operador de m�quinas de fabrica��o de chocolates e achocolatados"
  },
  {
    "codigo": "842105",
    "descricao": "Preparador de melado e ess�ncia de fumo"
  },
  {
    "codigo": "842110",
    "descricao": "Processador de fumo"
  },
  {
    "codigo": "842115",
    "descricao": "Classificador de fumo"
  },
  {
    "codigo": "842120",
    "descricao": "Auxiliar de processamento de fumo"
  },
  {
    "codigo": "842125",
    "descricao": "Operador de m�quina (fabrica��o de cigarros)"
  },
  {
    "codigo": "842135",
    "descricao": "Operador de m�quina de prepara��o de mat�ria prima para produ��o de cigarros"
  },
  {
    "codigo": "842205",
    "descricao": "Preparador de fumo na fabrica��o de charutos"
  },
  {
    "codigo": "842210",
    "descricao": "Operador de m�quina de fabricar charutos e cigarrilhas"
  },
  {
    "codigo": "842215",
    "descricao": "Classificador de charutos"
  },
  {
    "codigo": "842220",
    "descricao": "Cortador de charutos"
  },
  {
    "codigo": "842225",
    "descricao": "Celofanista na fabrica��o de charutos"
  },
  {
    "codigo": "842230",
    "descricao": "Charuteiro a m�o"
  },
  {
    "codigo": "842235",
    "descricao": "Degustador de charutos"
  },
  {
    "codigo": "848105",
    "descricao": "Defumador de carnes e pescados"
  },
  {
    "codigo": "848110",
    "descricao": "Salgador de alimentos"
  },
  {
    "codigo": "848115",
    "descricao": "Salsicheiro (fabrica��o de ling�i�a, salsicha e produtos similares)"
  },
  {
    "codigo": "848205",
    "descricao": "Pasteurizador"
  },
  {
    "codigo": "848210",
    "descricao": "Queijeiro na fabrica��o de latic�nio"
  },
  {
    "codigo": "848215",
    "descricao": "Manteigueiro na fabrica��o de latic�nio"
  },
  {
    "codigo": "848305",
    "descricao": "Padeiro"
  },
  {
    "codigo": "848310",
    "descricao": "Confeiteiro"
  },
  {
    "codigo": "848315",
    "descricao": "Masseiro (massas aliment�cias)"
  },
  {
    "codigo": "848325",
    "descricao": "Trabalhador de fabrica��o de sorvete"
  },
  {
    "codigo": "848405",
    "descricao": "Degustador de caf�"
  },
  {
    "codigo": "848410",
    "descricao": "Degustador de ch�"
  },
  {
    "codigo": "848415",
    "descricao": "Degustador de derivados de cacau"
  },
  {
    "codigo": "848420",
    "descricao": "Degustador de vinhos ou licores"
  },
  {
    "codigo": "848425",
    "descricao": "Classificador de gr�os"
  },
  {
    "codigo": "848505",
    "descricao": "Abatedor"
  },
  {
    "codigo": "848510",
    "descricao": "A�ougueiro"
  },
  {
    "codigo": "848515",
    "descricao": "Desossador"
  },
  {
    "codigo": "848520",
    "descricao": "Magarefe"
  },
  {
    "codigo": "848525",
    "descricao": "Retalhador de carne"
  },
  {
    "codigo": "848605",
    "descricao": "Trabalhador do beneficiamento de fumo"
  },
  {
    "codigo": "860105",
    "descricao": "Supervisor de manuten��o eletromec�nica (utilidades)"
  },
  {
    "codigo": "860110",
    "descricao": "Supervisor de opera��o de fluidos (distribui��o, capta��o, tratamento de �gua, gases, vapor)"
  },
  {
    "codigo": "860115",
    "descricao": "Supervisor de opera��o el�trica (gera��o, transmiss�o e distribui��o de energia el�trica)"
  },
  {
    "codigo": "861105",
    "descricao": "Operador de central hidrel�trica"
  },
  {
    "codigo": "861110",
    "descricao": "Operador de quadro de distribui��o de energia el�trica"
  },
  {
    "codigo": "861115",
    "descricao": "Operador de central termoel�trica"
  },
  {
    "codigo": "861120",
    "descricao": "Operador de reator nuclear"
  },
  {
    "codigo": "861205",
    "descricao": "Operador de subesta��o"
  },
  {
    "codigo": "862105",
    "descricao": "Foguista (locomotivas a vapor)"
  },
  {
    "codigo": "862110",
    "descricao": "Maquinista de embarca��es"
  },
  {
    "codigo": "862115",
    "descricao": "Operador de bateria de g�s de hulha"
  },
  {
    "codigo": "862120",
    "descricao": "Operador de caldeira"
  },
  {
    "codigo": "862130",
    "descricao": "Operador de compressor de ar"
  },
  {
    "codigo": "862140",
    "descricao": "Operador de esta��o de bombeamento"
  },
  {
    "codigo": "862150",
    "descricao": "Operador de m�quinas fixas, em geral"
  },
  {
    "codigo": "862155",
    "descricao": "Operador de utilidade (produ��o e distribui��o de vapor, g�s, �leo, combust�vel, energia, oxig�nio)"
  },
  {
    "codigo": "862160",
    "descricao": "Operador de abastecimento de combust�vel de aeronave"
  },
  {
    "codigo": "862205",
    "descricao": "Operador de esta��o de capta��o, tratamento e distribui��o de �gua"
  },
  {
    "codigo": "862305",
    "descricao": "Operador de esta��o de tratamento de �gua e efluentes"
  },
  {
    "codigo": "862310",
    "descricao": "Operador de forno de incinera��o no tratamento de �gua, efluentes e res�duos industriais"
  },
  {
    "codigo": "862405",
    "descricao": "Operador de instala��o de extra��o, processamento, envasamento e distribui��o de gases"
  },
  {
    "codigo": "862505",
    "descricao": "Operador de instala��o de refrigera��o"
  },
  {
    "codigo": "862510",
    "descricao": "Operador de refrigera��o com am�nia"
  },
  {
    "codigo": "862515",
    "descricao": "Operador de instala��o de ar-condicionado"
  },
  {
    "codigo": "910105",
    "descricao": "Encarregado de manuten��o mec�nica de sistemas operacionais"
  },
  {
    "codigo": "910110",
    "descricao": "Supervisor de manuten��o de aparelhos t�rmicos, de climatiza��o e de refrigera��o"
  },
  {
    "codigo": "910115",
    "descricao": "Supervisor de manuten��o de bombas, motores, compressores e equipamentos de transmiss�o"
  },
  {
    "codigo": "910120",
    "descricao": "Supervisor de manuten��o de m�quinas gr�ficas"
  },
  {
    "codigo": "910125",
    "descricao": "Supervisor de manuten��o de m�quinas industriais t�xteis"
  },
  {
    "codigo": "910130",
    "descricao": "Supervisor de manuten��o de m�quinas operatrizes e de usinagem"
  },
  {
    "codigo": "910205",
    "descricao": "Supervisor da manuten��o e repara��o de ve�culos leves"
  },
  {
    "codigo": "910210",
    "descricao": "Supervisor da manuten��o e repara��o de ve�culos pesados"
  },
  {
    "codigo": "910905",
    "descricao": "Supervisor de reparos linhas f�rreas"
  },
  {
    "codigo": "910910",
    "descricao": "Supervisor de manuten��o de vias f�rreas"
  },
  {
    "codigo": "911105",
    "descricao": "Mec�nico de manuten��o de bomba injetora (exceto de ve�culos automotores)"
  },
  {
    "codigo": "911110",
    "descricao": "Mec�nico de manuten��o de bombas"
  },
  {
    "codigo": "911115",
    "descricao": "Mec�nico de manuten��o de compressores de ar"
  },
  {
    "codigo": "911120",
    "descricao": "Mec�nico de manuten��o de motores diesel (exceto de ve�culos automotores)"
  },
  {
    "codigo": "911125",
    "descricao": "Mec�nico de manuten��o de redutores"
  },
  {
    "codigo": "911130",
    "descricao": "Mec�nico de manuten��o de turbinas (exceto de aeronaves)"
  },
  {
    "codigo": "911135",
    "descricao": "Mec�nico de manuten��o de turbocompressores"
  },
  {
    "codigo": "911205",
    "descricao": "Mec�nico de manuten��o e instala��o de aparelhos de climatiza��o e  refrigera��o"
  },
  {
    "codigo": "911305",
    "descricao": "Mec�nico de manuten��o de m�quinas, em geral"
  },
  {
    "codigo": "911310",
    "descricao": "Mec�nico de manuten��o de m�quinas gr�ficas"
  },
  {
    "codigo": "911315",
    "descricao": "Mec�nico de manuten��o de m�quinas operatrizes (lavra de madeira)"
  },
  {
    "codigo": "911320",
    "descricao": "Mec�nico de manuten��o de m�quinas t�xteis"
  },
  {
    "codigo": "911325",
    "descricao": "Mec�nico de manuten��o de m�quinas-ferramentas (usinagem de metais)"
  },
  {
    "codigo": "913105",
    "descricao": "Mec�nico de manuten��o de aparelhos de levantamento"
  },
  {
    "codigo": "913110",
    "descricao": "Mec�nico de manuten��o de equipamento de minera��o"
  },
  {
    "codigo": "913115",
    "descricao": "Mec�nico de manuten��o de m�quinas agr�colas"
  },
  {
    "codigo": "913120",
    "descricao": "Mec�nico de manuten��o de m�quinas de constru��o e terraplenagem"
  },
  {
    "codigo": "913125",
    "descricao": "Vulcanizador de correias transportadoras"
  },
  {
    "codigo": "914105",
    "descricao": "Mec�nico de manuten��o de aeronaves, em geral"
  },
  {
    "codigo": "914110",
    "descricao": "Mec�nico de manuten��o de sistema hidr�ulico de aeronaves (servi�os de pista e hangar)"
  },
  {
    "codigo": "914205",
    "descricao": "Mec�nico de manuten��o de motores e equipamentos navais"
  },
  {
    "codigo": "914305",
    "descricao": "Mec�nico de manuten��o de ve�culos ferrovi�rios"
  },
  {
    "codigo": "914405",
    "descricao": "Mec�nico de manuten��o de autom�veis, motocicletas e ve�culos similares"
  },
  {
    "codigo": "914410",
    "descricao": "Mec�nico de manuten��o de empilhadeiras e outros ve�culos de cargas leves"
  },
  {
    "codigo": "914415",
    "descricao": "Mec�nico de manuten��o de motocicletas"
  },
  {
    "codigo": "914420",
    "descricao": "Mec�nico de manuten��o de tratores"
  },
  {
    "codigo": "914425",
    "descricao": "Mec�nico de ve�culos automotores a diesel (exceto tratores)"
  },
  {
    "codigo": "915105",
    "descricao": "T�cnico em manuten��o de instrumentos de medi��o e precis�o"
  },
  {
    "codigo": "915110",
    "descricao": "T�cnico em manuten��o de hidr�metros"
  },
  {
    "codigo": "915115",
    "descricao": "T�cnico em manuten��o de balan�as"
  },
  {
    "codigo": "915205",
    "descricao": "Restaurador de instrumentos musicais (exceto cordas arcadas)"
  },
  {
    "codigo": "915210",
    "descricao": "Reparador de instrumentos musicais"
  },
  {
    "codigo": "915215",
    "descricao": "Luthier (restaura��o de cordas arcadas)"
  },
  {
    "codigo": "915305",
    "descricao": "T�cnico em manuten��o de equipamentos e instrumentos m�dico-hospitalares"
  },
  {
    "codigo": "915405",
    "descricao": "Reparador de equipamentos fotogr�ficos"
  },
  {
    "codigo": "919105",
    "descricao": "Lubrificador industrial"
  },
  {
    "codigo": "919110",
    "descricao": "Lubrificador de ve�culos automotores (exceto embarca��es)"
  },
  {
    "codigo": "919115",
    "descricao": "Lubrificador de embarca��es"
  },
  {
    "codigo": "919205",
    "descricao": "Mec�nico de manuten��o de m�quinas cortadoras de grama, ro�adeiras, motosserras e similares"
  },
  {
    "codigo": "919305",
    "descricao": "Mec�nico de manuten��o de aparelhos esportivos e de gin�stica"
  },
  {
    "codigo": "919310",
    "descricao": "Mec�nico de manuten��o de bicicletas e ve�culos similares"
  },
  {
    "codigo": "919315",
    "descricao": "Montador de bicicletas"
  },
  {
    "codigo": "950105",
    "descricao": "Supervisor de manuten��o el�trica de alta tens�o industrial"
  },
  {
    "codigo": "950110",
    "descricao": "Supervisor de manuten��o eletromec�nica industrial, comercial e predial"
  },
  {
    "codigo": "950205",
    "descricao": "Encarregado de manuten��o el�trica de ve�culos"
  },
  {
    "codigo": "950305",
    "descricao": "Supervisor de manuten��o eletromec�nica"
  },
  {
    "codigo": "951105",
    "descricao": "Eletricista de manuten��o eletroeletr�nica"
  },
  {
    "codigo": "951305",
    "descricao": "Instalador de sistemas eletroeletr�nicos de seguran�a"
  },
  {
    "codigo": "951310",
    "descricao": "Mantenedor de sistemas eletroeletr�nicos de seguran�a"
  },
  {
    "codigo": "951315",
    "descricao": "Monitor de sistemas eletr�nicos de seguran�a interno"
  },
  {
    "codigo": "951320",
    "descricao": "Monitor de sistemas eletr�nicos de seguran�a externo"
  },
  {
    "codigo": "953105",
    "descricao": "Eletricista de instala��es (aeronaves)"
  },
  {
    "codigo": "953110",
    "descricao": "Eletricista de instala��es (embarca��es)"
  },
  {
    "codigo": "953115",
    "descricao": "Eletricista de instala��es (ve�culos automotores e m�quinas operatrizes, exceto aeronaves e embarca��es)"
  },
  {
    "codigo": "954105",
    "descricao": "Eletromec�nico de manuten��o de elevadores"
  },
  {
    "codigo": "954110",
    "descricao": "Eletromec�nico de manuten��o de escadas rolantes"
  },
  {
    "codigo": "954115",
    "descricao": "Eletromec�nico de manuten��o de portas autom�ticas"
  },
  {
    "codigo": "954120",
    "descricao": "Mec�nico de manuten��o de instala��es mec�nicas de edif�cios"
  },
  {
    "codigo": "954125",
    "descricao": "Operador eletromec�nico"
  },
  {
    "codigo": "954205",
    "descricao": "Reparador de aparelhos eletrodom�sticos (exceto imagem e som)"
  },
  {
    "codigo": "954210",
    "descricao": "Reparador de r�dio, tv e som"
  },
  {
    "codigo": "954305",
    "descricao": "Reparador de equipamentos de escrit�rio"
  },
  {
    "codigo": "991105",
    "descricao": "Conservador de via permanente (trilhos)"
  },
  {
    "codigo": "991110",
    "descricao": "Inspetor de via permanente (trilhos)"
  },
  {
    "codigo": "991115",
    "descricao": "Operador de m�quinas especiais em conserva��o de via permanente (trilhos)"
  },
  {
    "codigo": "991120",
    "descricao": "Soldador aluminot�rmico em conserva��o de trilhos"
  },
  {
    "codigo": "991205",
    "descricao": "Mantenedor de equipamentos de parques de divers�es e similares"
  },
  {
    "codigo": "991305",
    "descricao": "Funileiro de ve�culos (repara��o)"
  },
  {
    "codigo": "991310",
    "descricao": "Montador de ve�culos (repara��o)"
  },
  {
    "codigo": "991315",
    "descricao": "Pintor de ve�culos (repara��o)"
  },
  {
    "codigo": "992105",
    "descricao": "Alinhador de pneus"
  },
  {
    "codigo": "992110",
    "descricao": "Balanceador"
  },
  {
    "codigo": "992115",
    "descricao": "Borracheiro"
  },
  {
    "codigo": "992120",
    "descricao": "Lavador de pe�as"
  },
  {
    "codigo": "992205",
    "descricao": "Encarregado geral de opera��es de conserva��o de vias permanentes (exceto trilhos)"
  },
  {
    "codigo": "992210",
    "descricao": "Encarregado de equipe de conserva��o de vias permanentes (exceto trilhos)"
  },
  {
    "codigo": "992215",
    "descricao": "Operador de ceifadeira na conserva��o de vias permanentes"
  },
  {
    "codigo": "992220",
    "descricao": "Pedreiro de conserva��o de vias permanentes (exceto trilhos)"
  },
  {
    "codigo": "992225",
    "descricao": "Auxiliar geral de conserva��o de vias permanentes (exceto trilhos)"
  }
]
